(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["executeGetInfoCollectorWidget"] = factory();
	else
		root["executeGetInfoCollectorWidget"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _pexui = __webpack_require__(2);
	
	var _main_widget = __webpack_require__(3);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _flow = __webpack_require__(10);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// move the widget to a new container
	function moveTo(widget_view_id) {
	    var container = utils.getElement(widget_view_id);
	
	    if (!container) {
	        throw new Error("Can't find the container");
	    }
	
	    if (_flow.flow.widget) {
	        (0, _pexui.moveWidget)(_flow.flow.widget, container);
	    }
	}
	
	function validateParams(widgetConfig, requestData, widgetCallback) {
	    // parameters validation
	    if (_typeof(requestData.document_data) !== 'object') {
	        throw new Error("widget_request.document_data is required.");
	    }
	    // keep compatibility
	    if (Array.isArray(requestData.document_data)) {
	        if (requestData.document_data.length !== 1) {
	            throw new Error("Only 1 document_data is supported.");
	        }
	        requestData.document_data = requestData.document_data[0];
	    }
	    if (typeof widgetCallback !== 'function') {
	        throw new Error("widgetCallback function is required");
	    }
	
	    var displayMode = widgetConfig.display_mode || '';
	    var container = null;
	
	    var widgetID = widgetConfig.widget_view_id;
	    if (widgetID) {
	        container = utils.getElement(widgetID);
	        if (!container) {
	            throw new Error("Can not find an element (" + widgetID + ")");
	        }
	        if ((typeof widgetID === 'undefined' ? 'undefined' : _typeof(widgetID)) === 'object') {
	            container = widgetID;
	            // make it a string in order to pass the service-side validation
	            widgetConfig.widget_view_id = container.getAttribute('id') || 'element_without_id';
	        }
	    } else {
	        // create the container in 'overlay' mode
	        widgetConfig.widget_view_id = "dummy_for_overlay";
	        displayMode += (displayMode ? '|' : '') + 'OVERLAY|CAPTION';
	    }
	
	    // compatibility
	    if (widgetConfig.invoker_styles && !widgetConfig.invoker_style_url) {
	        widgetConfig.invoker_style_url = widgetConfig.invoker_styles;
	        delete widgetConfig.invoker_styles;
	    }
	    if (widgetConfig.invoker_prop && !widgetConfig.invoker_prop_url) {
	        widgetConfig.invoker_prop_url = widgetConfig.invoker_prop;
	        delete widgetConfig.invoker_prop;
	    }
	
	    return {
	        displayMode: displayMode,
	        container: container
	    };
	}
	
	var mainInvoked = false;
	
	/**
	 * Bootstrap the DocUploadWidget
	 * @see https://enterprise-confluence.aexp.com/confluence/pages/viewpage.action?pageId=125838007
	 * @param widgetConfig
	 * widget_view_id: Indicates Layered/Embedded view of widget,
	 *        supports "elem_id" | "#elem_id" | elem_obj | undefined (creates new root element)
	 *        if "elem_id" | "#elem_id" is provided, the elem_id will be tried to find in the current document,
	 *        if it's not found, a new div element with the elem_id will be generated.
	 *        if widgetID is undefined, a new div element with the elem_id will be generated.
	 * @param requestData
	 * @param widgetCallback callback function
	 * @return {object} an object containing move method
	 */
	function main(widgetConfig, requestData, widgetCallback) {
	    try {
	        if (!document.createElement) {
	
	            var invokeOnce = function invokeOnce() {
	                if (!mainInvoked) {
	                    mainInvoked = true;
	                    main(widgetConfig, requestData, widgetCallback);
	                }
	            };
	
	            //whichever runs first
	            if (document.addEventListener) {
	                document.addEventListener('DOMContentLoaded', invokeOnce);
	            }
	            setTimeout(invokeOnce, 500);
	
	            return;
	        }
	
	        utils.resetGlobals();
	
	        var disp = validateParams(widgetConfig, requestData, widgetCallback);
	        _globals2.default.displayMode = disp.displayMode;
	
	        // do with themes
	        if (disp.displayMode.indexOf('OVERLAY') >= 0) {
	            (0, _pexui.showModal)(_pexui.React.createElement(_main_widget.GetInfoWidgetApp, { config: widgetConfig, req: requestData, widgetCallback: widgetCallback,
	                displayMode: disp.displayMode
	            }), _pexui.LEVEL_OVERLAY);
	        } else {
	            _pexui.ReactDOM.render(_pexui.React.createElement(_main_widget.GetInfoWidgetApp, { config: widgetConfig, req: requestData, widgetCallback: widgetCallback,
	                displayMode: disp.displayMode }), disp.container);
	        }
	
	        return {
	            moveTo: moveTo
	        };
	    } catch (err) {
	        utils.logError(err);
	
	        (0, _track.track)('Start:Error');
	        (0, _track.trackError)('error.service.message');
	
	        if (typeof widgetCallback === 'function') {
	            widgetCallback({
	                event_name: 'fail',
	                event_value: String(err)
	            });
	        }
	    }
	};
	
	module.exports = main;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	(function (global, factory) {
	    if (typeof define === "function" && define.amd) {
	        define(['exports'], factory);
	    } else if (typeof exports !== "undefined") {
	        factory(exports);
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports);
	        global.pexui = mod.exports;
	    }
	})(this, function (exports) {
	    "use strict";
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	    exports.resetLocales = resetLocales;
	    exports.setCurrentLocale = setCurrentLocale;
	    exports.getCurrentLocaleUrl = getCurrentLocaleUrl;
	    exports._n = _n;
	    exports.setCustomTextProps = setCustomTextProps;
	    exports.extend = extend;
	    exports.willChange = willChange;
	    exports.endsWith = endsWith;
	    exports.joinUrl = joinUrl;
	    exports.joinIfAbsent = joinIfAbsent;
	    exports.parseHeaders = parseHeaders;
	    exports.getErrorInResponse = getErrorInResponse;
	    exports.ajax = ajax;
	    exports.upload = upload;
	    exports.download = download;
	    exports.insertStylesheetLink = insertStylesheetLink;
	    exports.insertScriptTag = insertScriptTag;
	    exports.getCookie = getCookie;
	    exports.registerMessageHandler = registerMessageHandler;
	    exports.randomString = randomString;
	    exports.evalExpr = evalExpr;
	    exports.parsePx = parsePx;
	    exports.clickOn = clickOn;
	    exports.getInitHierarchy = getInitHierarchy;
	    exports.omnitureReady = omnitureReady;
	    exports.omnitureTrack = omnitureTrack;
	    exports.moveWidget = moveWidget;
	    exports._s = _s;
	    exports.addStylesMapper = addStylesMapper;
	    exports.getOverlay = getOverlay;
	    exports.hideModal = hideModal;
	    exports.showModal = showModal;
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var I18nMgr = exports.I18nMgr = function () {
	        function I18nMgr() {
	            _classCallCheck(this, I18nMgr);
	
	            this.cache = {};
	            this.currentLocale = null;
	            this.customProps = null;
	            this._on_success = false;
	            this._downloadingCustomProps = false;
	            this.currentMap = {};
	            this.currentLocaleUrl;
	        }
	
	        _createClass(I18nMgr, [{
	            key: 'retrieve',
	            value: function retrieve(localeUrl, on_success, on_error) {
	                var mgr = this;
	                mgr._on_success = on_success;
	                mgr.currentLocaleUrl = localeUrl;
	
	                // cache hit
	                if (mgr.cache.hasOwnProperty(localeUrl)) {
	                    mgr.currentLocale = localeUrl;
	                    mgr._mergeCustomProps();
	                } else {
	                    ajax({ url: localeUrl,
	                        method: 'GET',
	                        success: function success(json) {
	                            try {
	                                var res = JSON.parse(json);
	                                mgr.cache[localeUrl] = res;
	                                mgr.currentLocale = localeUrl;
	                                mgr._mergeCustomProps();
	                            } catch (error) {
	                                var exceptionMessage = 'Inside acms retrieve => Exception while downloading content json:' + localeUrl + ':' + error;
	                                on_error(exceptionMessage);
	                            }
	                        },
	                        error: function error(_error) {
	                            var errorMessage = 'Inside acms retrieve => Error while downloading content json:' + localeUrl + ':' + _error;
	                            on_error(errorMessage);
	                        }
	                    });
	                }
	            }
	        }, {
	            key: '_mergeCustomProps',
	            value: function _mergeCustomProps() {
	                this.currentMap = {};
	                if (this.cache.hasOwnProperty(this.currentLocale)) {
	                    extend(this.currentMap, this.cache[this.currentLocale]);
	                }
	                // custom props always overwrite built-in props
	                if (this.customProps) {
	                    extend(this.currentMap, this.customProps);
	                }
	
	                if (this._downloadingCustomProps) {
	                    // hold down for the custom props being downloaded.
	                } else if (typeof this._on_success === 'function') {
	                    var on_success = this._on_success;
	                    this._on_success = false;
	                    on_success();
	                }
	            }
	        }, {
	            key: 'retrieveCustomProps',
	            value: function retrieveCustomProps(invokerPropUrl, on_success, on_error) {
	                var mgr = this;
	                mgr._downloadingCustomProps = true;
	                ajax({ url: invokerPropUrl,
	                    method: 'GET',
	                    success: function success(json) {
	                        mgr._downloadingCustomProps = false;
	                        try {
	                            var res = JSON.parse(json);
	                            mgr.customProps = res;
	                            mgr._mergeCustomProps();
	                        } catch (err) {
	                            console.error("fail to download " + invokerPropUrl + ":" + err);
	                        }
	                    },
	                    error: function error(err) {
	                        mgr._downloadingCustomProps = false;
	                        console.error("fail to download " + invokerPropUrl + ":" + err);
	                    }
	                });
	            }
	        }]);
	
	        return I18nMgr;
	    }();
	
	    var i18nMgr = new I18nMgr();
	
	    function resetLocales() {
	        i18nMgr = new I18nMgr();
	    }
	
	    function setCurrentLocale(localeUrl, on_success, on_error) {
	        i18nMgr.retrieve(localeUrl, on_success, on_error);
	    }
	
	    function getCurrentLocaleUrl() {
	        return i18nMgr.currentLocaleUrl;
	    }
	
	    function getRes(key) {
	        var imap = i18nMgr.currentMap;
	        if (imap.hasOwnProperty(key)) {
	            return imap[key];
	            //}else if(imap.hasOwnProperty(key + '.title')){
	            //    return imap[key + '.title'];
	        } else {
	            console.log("missing string resource of " + key);
	            return '';
	        }
	    }
	
	    function _n(expr, vars) {
	        var value = getRes(expr);
	        if (vars) {
	            value = evalExpr(value, vars);
	        }
	        return value;
	    }
	
	    // invokerProps can be a URL or an object
	    function setCustomTextProps(invokerProps) {
	        if (!invokerProps) {
	            // skip
	        } else if (typeof invokerProps === 'string') {
	            // URL
	            i18nMgr.retrieveCustomProps(invokerProps);
	        } else if ((typeof invokerProps === 'undefined' ? 'undefined' : _typeof(invokerProps)) === 'object') {
	            i18nMgr.customProps = invokerProps;
	            i18nMgr._mergeCustomProps();
	        } else if (typeof invokerProps === 'function') {
	            i18nMgr.customProps = invokerProps();
	            i18nMgr._mergeCustomProps();
	        } else {
	            throw new Error("Invalid type of " + invokerProps);
	        }
	    }
	
	    //
	    // common utilities
	    //
	    'use strict';
	
	    function extend(target, src1) {
	        if (!target) {
	            target = {};
	        }
	
	        for (var i = 1; i < arguments.length; i++) {
	            var src = arguments[i];
	            if (src && (typeof src === 'undefined' ? 'undefined' : _typeof(src)) === 'object') {
	                for (var k in src) {
	                    if (src.hasOwnProperty(k)) {
	                        target[k] = src[k];
	                    }
	                }
	            }
	        }
	        return target;
	    };
	
	    function willChange(target, src) {
	        if (src && (typeof src === 'undefined' ? 'undefined' : _typeof(src)) === 'object') {
	            for (var k in src) {
	                if (src.hasOwnProperty(k)) {
	                    if (!(target.hasOwnProperty(k) && src[k] === target[k])) {
	                        return true;
	                    }
	                }
	            }
	        }
	
	        return false;
	    }
	
	    function endsWith(str1, str2) {
	        if (str1 && str2) {
	            var len1 = str1.length;
	            var len2 = str2.length;
	            return len1 >= len2 && str1.substring(len1 - len2) === str2;
	        } else {
	            return false;
	        }
	    }
	
	    function joinUrl(part1, part2) {
	        if (!part2) return part1;
	
	        if (part1 && part1.charAt(part1.length - 1) === '/') {
	            if (part2 && part2.charAt(0) === '/') {
	                return part1 + part2.substring(1);
	            } else {
	                return part1 + part2;
	            }
	        } else {
	            if (part2 && part2.charAt(0) === '/') {
	                return part1 + part2;
	            } else {
	                return part1 + '/' + part2;
	            }
	        }
	    }
	
	    function joinIfAbsent(part1, part2) {
	        if (endsWith(part1, part2) || endsWith(part1, part2 + '/')) {
	            return part1; // part1 already ends with part2
	        } else {
	            return joinUrl(part1, part2);
	        }
	    }
	
	    function parseHeaders(headsText) {
	        var headers = {};
	        if (headsText) {
	            var lines = headsText.split('\n');
	            lines.forEach(function (line) {
	                var pos = line.indexOf(': ');
	                if (pos > 0) {
	                    var k = line.substring(0, pos);
	                    var v = line.substring(pos + 2).trim();
	                    headers[k] = v;
	                }
	            });
	        }
	        return headers;
	    }
	
	    function getErrorInResponse(respText) {
	        var code = '',
	            message = '';
	        var m = /code\"\s*:\s*(\d+|\"[^\"]*\")/i.exec(respText);
	        if (m) {
	            code = m[1].replace(/\"/g, '');
	        }
	
	        m = /message\"\s*:\s*\"([^\"]*)\"/i.exec(respText);
	        if (m) {
	            message = m[1];
	        }
	        return 'code:' + code + ', message:' + message;
	    }
	
	    function ajax(args) {
	        //args.method
	        var xhttp = new XMLHttpRequest();
	        try {
	            xhttp.timeout = 600000; // 10 minutes
	        } catch (err) {
	            // happens in IE
	            console.log('warning: can not set timeout.');
	        }
	        xhttp.withCredentials = args.withCredentials || false;
	        xhttp.onreadystatechange = function () {
	            if (this.readyState == 4) {
	                if (this.status == 200) {
	                    var resp = this.responseText;
	                    if (typeof args.success === 'function') {
	                        var success = args.success;
	                        var respHeaders = parseHeaders(this.getAllResponseHeaders());
	                        success(resp, respHeaders);
	                    }
	                } else {
	                    console.log(this.status + " " + this.responseText);
	                    var message = "HTTP " + this.status + " " + getErrorInResponse(this.responseText);
	                    if (typeof args.error === 'function') {
	                        args.error(message);
	                    }
	                }
	            }
	        };
	
	        if (typeof args.error === 'function') {
	            xhttp.onerror = args.error;
	        }
	
	        xhttp.open(args.method, args.url, true);
	
	        if (args.hasOwnProperty('headers') && _typeof(args.headers) === 'object' && args.headers) {
	            for (var k in args.headers) {
	                if (args.headers.hasOwnProperty(k)) {
	                    xhttp.setRequestHeader(k, args.headers[k]);
	                }
	            }
	        }
	        xhttp.send(args.data);
	    }
	
	    /**
	     * @param {object} args
	     *    {
	     *         url  : the service url
	     *         file : the file to upload,
	     *         formFields:  form fields,
	     *         headers: request headers
	     *         success: on_success callback,
	     *         error: on_error callback,
	     *         progress: on_progress callback
	     *    }
	     */
	    function upload(args) {
	        var url = args.url;
	        var file = args.file;
	        var formFields = args.formFields;
	        var on_success = args.success;
	        var on_error = args.error;
	        var on_progress = args.progress;
	
	        var xhttp = new XMLHttpRequest();
	        try {
	            xhttp.timeout = 600000; // 10 minutes
	        } catch (err) {
	            // happens in IE
	            console.log('warning: can not set timeout.');
	        }
	        xhttp.file = file;
	
	        if (xhttp.upload) {
	            if (typeof on_error === 'function') {
	                xhttp.upload.onerror = on_error;
	            }
	
	            if (typeof on_progress === 'function') {
	                xhttp.upload.onprogress = on_progress;
	            }
	
	            xhttp.upload.onabort = function (e) {
	                if (typeof on_error === 'function') {
	                    on_error("aborted");
	                }
	            };
	        } else {
	            if (typeof on_error === 'function') {
	                xhttp.onerror = on_error;
	            }
	        }
	
	        xhttp.onreadystatechange = function () {
	            if (this.readyState === 4) {
	                if (this.status === 200) {
	                    try {
	                        if (typeof on_success === 'function') {
	                            var respHeaders = parseHeaders(this.getAllResponseHeaders());
	                            on_success(file, this.responseText, respHeaders);
	                        }
	                    } catch (err) {
	                        if (typeof on_error === 'function') {
	                            on_error(err);
	                        }
	                    }
	                } else {
	                    console.log(this.status + " " + this.responseText);
	                    var message = "HTTP " + this.status + " " + getErrorInResponse(this.responseText);
	                    if (typeof on_error === 'function') {
	                        on_error(message);
	                    }
	                }
	            }
	        };
	
	        var formData = new FormData();
	        if ((typeof formFields === 'undefined' ? 'undefined' : _typeof(formFields)) === 'object' && formFields) {
	            for (var key in formFields) {
	                if (formFields.hasOwnProperty(key)) {
	                    formData.append(key, formFields[key]);
	                }
	            }
	        }
	        formData.append("file", file);
	        xhttp.open("POST", url, true);
	
	        if (_typeof(args.headers) === 'object' && args.headers) {
	            for (var k in args.headers) {
	                if (args.headers.hasOwnProperty(k)) {
	                    xhttp.setRequestHeader(k, args.headers[k]);
	                }
	            }
	        }
	        xhttp.send(formData);
	    }
	
	    function download(url) {
	        var xhttp = new XMLHttpRequest();
	        xhttp.open("GET", url, false);
	        xhttp.send(null);
	
	        if (xhttp.status === 200) {
	            return xhttp.responseText;
	        } else {
	            throw Error('Fail to download (' + xhttp.status + ') ' + xhttp.statusText);
	        }
	    }
	
	    function insertStylesheetLink(url) {
	        var found = false;
	        var elems = document.getElementsByTagName("link");
	        for (var elem in elems) {
	            if (elem.ref === "stylesheet" && elem.href === url) {
	                found = true;
	            }
	        }
	        if (found) {
	            return; // the CSS link already exists.
	        }
	
	        var head = document.head || document.getElementsByTagName("head")[0];
	
	        var linkElement = document.createElement("link");
	        linkElement.rel = "stylesheet";
	        linkElement.type = "text/css";
	        linkElement.href = url;
	        linkElement.crossorigin = 'anonymous';
	        head.appendChild(linkElement);
	
	        return linkElement;
	    }
	
	    function insertScriptTag(url, type) {
	        var found = false;
	        var elems = document.getElementsByTagName("script");
	        for (var elem in elems) {
	            if (elem.src === url) {
	                found = true;
	            }
	        }
	        if (found) {
	            return; // the script tag already exists.
	        }
	
	        var head = document.head || document.getElementsByTagName("head")[0];
	
	        var scriptElement = document.createElement("script");
	        scriptElement.type = type || "text/javascript";
	        scriptElement.src = url;
	        head.appendChild(scriptElement);
	
	        return scriptElement;
	    }
	
	    function getCookie(cname) {
	        var name = cname + "=";
	        var ca = document.cookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	            var c = ca[i];
	            while (c.charAt(0) == ' ') {
	                c = c.substring(1);
	            }
	            if (c.indexOf(name) == 0) {
	                return c.substring(name.length, c.length);
	            }
	        }
	        return "";
	    }
	
	    function registerMessageHandler(handler) {
	        // Create IE + others compatible event handler
	        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
	        var eventer = window[eventMethod];
	        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
	
	        // Listen to message from child window
	        eventer(messageEvent, handler, false);
	    }
	
	    function randomString(len) {
	        var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345679';
	        var s = '';
	        for (var i = 0; i < len; i++) {
	            s = s + CHARS.charAt(Math.round(CHARS.length * Math.random()) % CHARS.length);
	        }
	        return s;
	    }
	
	    function inArray(arr, obj) {
	        return arr.indexOf(obj) !== -1;
	    }
	
	    function mergeArray(arr1, arr2) {
	        if (typeof arr2 !== 'undefined') {
	            if (Array.isArray(arr2)) {
	                for (var i = 0; i < arr2.length; i++) {
	                    var item = arr2[i];
	                    if (!inArray(arr1, item)) {
	                        arr1.push(item);
	                    }
	                }
	            } else {
	                var item = arr2;
	                if (!inArray(arr1, item)) {
	                    arr1.push(item);
	                }
	            }
	        }
	        return arr1;
	    }
	
	    /**
	     * Evaluate Angular-like expression in a string
	     *  {{ expr }}
	     * @param {String} fmt
	     * @param {Object} value
	     * @return {String} result
	     */
	    function evalExpr(fmt, value) {
	        return fmt.replace(/\{\{([^\{\}]*)\}\}|\@\{([^\{\}]*)\}/g, function (m0, m1, m2) {
	            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value) {
	                var expr = (m1 || m2).trim();
	                var obj = value;
	                var arr = expr.split('.');
	                while (arr.length) {
	                    var field = arr.shift();
	                    if (obj.hasOwnProperty(field)) {
	                        obj = obj[field];
	                    } else {
	                        return '';
	                    }
	                }
	                return obj;
	            } else {
	                return '';
	            }
	        });
	    }
	
	    function parsePx(str) {
	        if (typeof str === 'number') {
	            return str;
	        }
	
	        var len = 0;
	        var m = /(\d+(?:\.\d*)?)\s*(px|pt|pc|in|cm|mm|em|ex|\%)?/i.exec(str);
	        if (m) {
	            var num = m[1];
	            var unit = m[2] ? m[2].toLowerCase() : '';
	            len = num.indexOf('.') >= 0 ? parseFloat(num) : parseInt(num);
	            // convert to px
	            if (unit === 'pt') {
	                len = len * 96 / 72;
	            } else if (unit === 'pc') {
	                len *= 16;
	            } else if (unit === 'in') {
	                len *= 96;
	            } else if (unit === 'cm') {
	                len *= 38;
	            } else if (unit === 'mm') {
	                len *= 3.8;
	            } else if (unit === 'em') {
	                len *= 16; //?
	            } else if (unit === 'ex') {
	                len *= 16; //?
	            }
	        }
	        return len;
	    }
	
	    function clickOn(elemOrId) {
	        var btn;
	        if (typeof elemOrId === 'string') {
	            btn = document.getElementById(elemOrId);
	        } else {
	            btn = elemOrId;
	        }
	        if (!btn) {
	            throw new Error("Fail to find element " + elemOrId);
	        }
	        var evt = document.createEvent("MouseEvents");
	        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	        return btn.dispatchEvent(evt);
	    }
	
	    // race condition fix
	    var omn_queue = [];
	    var omn_counter = 0;
	    var pageTrackerTimer = null;
	    function startOmnSender() {
	        if (!pageTrackerTimer) {
	            pageTrackerTimer = setInterval(function () {
	                if (omn_counter < 3600000) {
	                    omn_counter += 500;
	                }
	
	                // safe now or time out, send the queue
	                var nextOmn;
	                while (omnitureReady() && (nextOmn = omn_queue.shift())) {
	                    invokeOmn(nextOmn);
	                }
	
	                // if the queue is clean
	                if (omn_queue.length === 0) {
	                    stopOmnSender();
	                }
	            }, 500);
	        }
	    }
	
	    function stopOmnSender() {
	        if (pageTrackerTimer) {
	            clearInterval(pageTrackerTimer);
	            pageTrackerTimer = null;
	        }
	    }
	
	    function invokeOmnLater(newOmn) {
	        omn_queue.push(newOmn);
	        startOmnSender();
	    }
	
	    var _omn_fields = ['events', 'products', 'pcnnumber', 'appconfig', 'eVar41'];
	    var _omn_global_fields = ['omn', 'omn_events', 'omn_products', 'omn_pcnnumber', 'omn_appconfig'];
	    var initHierarchy = '';
	
	    function getInitHierarchy() {
	        return initHierarchy;
	    }
	
	    function invokeOmn(newOmn) {
	        var savedGlobals = {},
	            field,
	            i;
	
	        if (!initHierarchy) {
	            if (window.omn && _typeof(window.omn) === 'object') {
	                if (window.omn['hierarchy']) {
	                    initHierarchy = window.omn['hierarchy'];
	                } else if (window.omn['ppvpage']) {
	                    initHierarchy = window.omn['ppvpage'].replace(/\|[^\|]*$/, '');
	                }
	            }
	        }
	
	        // save the global variables
	        // clearEvents
	        for (i = 0; i < _omn_global_fields.length; i++) {
	            field = _omn_global_fields[i];
	            savedGlobals[field] = window[field];
	            if (typeof window[field] !== 'undefined') {
	                window[field] = '';
	            }
	        }
	
	        for (i = 0; i < _omn_fields.length; i++) {
	            field = _omn_fields[i];
	            s[field] = '';
	        }
	
	        if (initHierarchy) {
	            newOmn.hierarchy = initHierarchy; //initVar41.replace(/\|[^\|]*$/,'');
	        }
	        // use the new omn object
	        window.omn = newOmn;
	        var s_code = s.t();
	
	        // recover the global variables
	        for (i = 0; i < _omn_global_fields.length; i++) {
	            field = _omn_global_fields[i];
	            window[field] = savedGlobals[field];
	        }
	        return s_code;
	    }
	
	    function omnitureReady() {
	        if (window.pageTrackFired || omn_counter >= 10000) {
	            return (typeof s === 'undefined' ? 'undefined' : _typeof(s)) === 'object' && s && s.isReadyToTrack();
	        } else {
	            return false;
	        }
	    }
	
	    function omnitureTrack(newOmn) {
	        try {
	            if (typeof s === 'undefined' || typeof s.t !== 'function' || typeof s.isReadyToTrack !== 'function') {
	                console.log("Omniture tracking is unavailable.");
	                return;
	            }
	            if (!window) {
	                console.log("window object is unavailable.");
	                return;
	            }
	
	            // race condition check
	            if (omnitureReady()) {
	                //console.log("invokeOmn " + JSON.stringify(newOmn));
	                return invokeOmn(newOmn);
	            } else {
	                //console.log("invokeOmnLater " + JSON.stringify(newOmn));
	                invokeOmnLater(newOmn);
	                return;
	            }
	        } catch (err) {
	            console.log("omnitureTrack error:" + err);
	            return err;
	        }
	    }
	
	    "use strict";
	
	    // Reactlite -- a lightweight pure JS simulator of React
	
	    var didMountComps = [];
	
	    function isLower(c) {
	        return 'a' <= c && c <= 'z';
	    }
	
	    function _React$Component(props) {
	        this.props = props || {};
	        this.refs = {};
	    }
	
	    _React$Component.prototype = {
	        setState: function setState(newState) {
	            if (!this.state) this.state = {};
	
	            var changed = willChange(this.state, newState);
	            this.state = extend(this.state, newState);
	            if (changed) {
	                this.forceUpdate();
	            }
	        },
	
	        forceUpdate: function forceUpdate() {
	            var comp = this;
	            setTimeout(function () {
	                comp._redraw();
	            }, 100);
	        },
	
	        getElement: function getElement() {
	            if (isReactComponent(this.content)) {
	                // wrapper object
	                return this.content.getElement();
	            } else {
	                // simple html element
	                return this.content;
	            }
	        },
	
	        _redraw: function _redraw() {
	            var oldElem = this.getElement();
	            if (oldElem) {
	                var savedCurrDoc = ReactLite.currentDocument;
	                // rendering in the original owner document
	                ReactLite.currentDocument = oldElem.ownerDocument;
	                var newContent = this.render();
	                ReactLite.currentDocument = savedCurrDoc;
	
	                var newElem = _getElement(newContent);
	                if (oldElem.parentElement) {
	                    oldElem.parentElement.replaceChild(newElem, oldElem);
	                    this.content = newElem;
	
	                    while (didMountComps.length > 0) {
	                        var comp = didMountComps.shift();
	                        if (comp) {
	                            comp.componentDidMount();
	                        }
	                    }
	                } else {
	                    console.log("Warning: Element " + oldElem + " <" + oldElem.tagName + "> doesn't have a parent.");
	                }
	            }
	        }
	    };
	
	    function isReactComponent(comp) {
	        return comp && (comp instanceof _React$Component || _React$Component.isPrototypeOf(comp));
	    }
	
	    function _getElement(comp) {
	        if (isReactComponent(comp)) {
	            return comp.getElement();
	        } else {
	            return comp;
	        }
	    }
	
	    function _flatArray(arr, startIdx, endIdx) {
	        if (typeof startIdx === 'undefined') {
	            startIdx = 0;
	        }
	        if (typeof endIdx === 'undefined') {
	            endIdx = arr.length;
	        }
	        var newArr = [];
	        for (var i = startIdx; i < endIdx; i++) {
	            var item = arr[i];
	            if (item) {
	                if (Array.isArray(item)) {
	                    for (var j = 0; j < item.length; j++) {
	                        newArr.push(item[j]);
	                    }
	                } else {
	                    newArr.push(item);
	                }
	            }
	        }
	        return newArr;
	    }
	
	    function _createElement(elemType, props) {
	        var elem;
	        var comp;
	        var doc = ReactLite.currentDocument || document;
	        var children = _flatArray(arguments, 2);
	        // simple html tag
	        if (typeof elemType === 'string' && isLower(elemType.charAt(0))) {
	            if (props && props.hasOwnProperty("xmlns")) {
	                elem = doc.createElementNS(props.xmlns, elemType);
	            } else {
	                elem = doc.createElement(elemType);
	            }
	            // set attributes
	            if (props && (typeof props === 'undefined' ? 'undefined' : _typeof(props)) === 'object') {
	                Object.keys(props).forEach(function (key) {
	                    if (key !== 'xmlns') {
	                        var value = props[key];
	                        if (key.toLowerCase() === 'classname') {
	                            key = 'class';
	                            value = _s(value); // styles mapping
	                        }
	                        if (typeof value === 'function') {
	                            if (key.lastIndexOf('on', 0) === 0) {
	                                key = key.substring(2).toLowerCase();
	                            }
	                            elem.addEventListener(key, value);
	                        } else {
	                            if (key === 'style' && value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	                                var s = '';
	                                Object.keys(value).forEach(function (k) {
	                                    if (k) {
	                                        s += k + ':' + value[k] + ';';
	                                    }
	                                });
	                                value = s;
	                                elem.setAttribute(key, value);
	                            } else if (key === 'disabled' || key === 'checked') {
	                                if (value) {
	                                    elem.setAttribute(key, key);
	                                } else {
	                                    elem.removeAttribute(key);
	                                }
	                            } else {
	                                if (typeof value !== 'undefined' && value !== '') {
	                                    elem.setAttribute(key, value);
	                                }
	                            }
	                        }
	                    }
	                });
	            }
	
	            // adding children
	            for (var i = 0; i < children.length; i++) {
	                var arg = children[i];
	                if (typeof arg === 'string') {
	                    var node = doc.createTextNode(arg);
	                    elem.appendChild(node);
	                } else if (arg) {
	                    elem.appendChild(_getElement(arg));
	                } // ignore other type of items
	            }
	            return elem;
	        }
	        // custom tag
	        else if (typeof elemType === 'function') {
	                if (_React$Component.isPrototypeOf(elemType)) {
	                    // React.Component
	                    props = props || {};
	                    props.children = children;
	                    comp = new elemType(props || {});
	
	                    if (typeof comp.componentWillMount === 'function') {
	                        comp.componentWillMount();
	                    }
	
	                    comp.content = comp.render();
	
	                    /*
	                    if(comp.content instanceof HTMLElement && children){
	                        for(var i=0;i<children.length;i++){
	                            var arg = children[i];
	                            if(typeof arg === 'string'){
	                                var node = document.createTextNode(arg);
	                                comp.content.appendChild(node);
	                            }else if(arg){
	                                comp.content.appendChild(_getElement(arg));
	                            }// ignore other type of items
	                        }
	                    }
	                    */
	
	                    // set up comp.refs
	                    _traverseChildren(comp, function (subComp) {
	                        if (isReactComponent(subComp)) {
	                            var ref = subComp.props.ref;
	                            if (ref) {
	                                comp.refs[ref] = subComp.getElement();
	                            }
	                        } else {
	                            if (subComp.hasAttribute('ref')) {
	                                var ref = subComp.getAttribute('ref');
	                                comp.refs[ref] = subComp;
	                                subComp.removeAttribute('ref');
	                            }
	                        }
	                    });
	
	                    // saving the comp for later invocation of componentDidMount
	                    if (typeof comp.componentDidMount === 'function') {
	                        didMountComps.push(comp);
	                    }
	                    return comp;
	                } else {
	                    // pure function
	                    props = props || {};
	                    props.children = children;
	                    comp = elemType(props);
	                    // adding children
	                    return comp;
	                }
	            } else {
	                throw new Error("Invalid type of " + (typeof elemType === 'undefined' ? 'undefined' : _typeof(elemType)));
	            }
	    }
	
	    function _createClassForES5(compDef) {
	        var CompType = function (_React$Component2) {
	            _inherits(CompType, _React$Component2);
	
	            function CompType(props) {
	                _classCallCheck(this, CompType);
	
	                var _this = _possibleConstructorReturn(this, (CompType.__proto__ || Object.getPrototypeOf(CompType)).call(this, props));
	
	                if (typeof compDef.getInitialState === 'function') {
	                    _this.state = compDef.getInitialState.call(_this);
	                }
	                return _this;
	            }
	
	            _createClass(CompType, [{
	                key: 'render',
	                value: function render() {
	                    if (typeof compDef.render === 'function') {
	                        return compDef.render.call(this);
	                    } else {
	                        throw new Error('render function not defined.');
	                    }
	                }
	            }]);
	
	            return CompType;
	        }(React.Component);
	
	        return CompType;
	    }
	
	    function cleanChildren(elem) {
	        while (elem && elem.lastChild) {
	            elem.removeChild(elem.lastChild);
	        }
	    }
	
	    function _traverseChildren(comp, cb) {
	        if (comp) {
	            if (isReactComponent(comp)) {
	                cb(comp);
	                _traverseChildren(comp.content, cb);
	            } else if (comp instanceof HTMLElement) {
	                cb(comp);
	
	                var subElem = comp.firstChild;
	                while (subElem) {
	                    if (subElem instanceof HTMLElement) {
	                        _traverseChildren(subElem, cb);
	                    }
	                    subElem = subElem.nextSibling;
	                }
	            }
	        }
	    }
	
	    function _renderDom(comp, container, append) {
	        if (!append) {
	            cleanChildren(container);
	        }
	        container.appendChild(_getElement(comp));
	
	        while (didMountComps.length > 0) {
	            var comp = didMountComps.shift();
	            if (comp) {
	                comp.componentDidMount();
	            }
	        }
	    }
	
	    function moveWidget(comp, container) {
	        cleanChildren(container);
	        container.appendChild(_getElement(comp));
	    }
	
	    var React = exports.React = {
	        createElement: _createElement,
	        createClass: _createClassForES5,
	        Component: _React$Component,
	        PropTypes: {
	            object: {
	                isRequired: 'required_object'
	            },
	            number: {
	                isRequired: 'required_number'
	            },
	            string: {
	                isRequired: 'required_string'
	            },
	            bool: {
	                isRequired: 'required_bool'
	            },
	            func: {
	                isRequired: "required_func"
	            },
	            node: {
	                isRequired: "required_node"
	            },
	            oneOfType: function oneOfType(arr) {
	                return { "oneOf": arr };
	            },
	            arrayOf: function arrayOf(node) {
	                return { "arrayOf": node };
	            }
	        }
	    };
	
	    var ReactDOM = exports.ReactDOM = {
	        render: _renderDom,
	        findDOMNode: _getElement
	    };
	
	    // helpers
	    var ReactLite = exports.ReactLite = {
	        isReactComponent: isReactComponent,
	        traverseChildren: _traverseChildren,
	        moveWidget: moveWidget,
	        currentDocument: null
	    };
	    "use strict";
	
	    var stylesMappers = []; // a chain of styles mappers each of which can be an object or a function
	
	    function _s(className) {
	        if (!className) return className;
	        return className.replace(/[\w\-\_@#]+/g, function (c) {
	            for (var i = 0; i < stylesMappers.length; i++) {
	                var m = stylesMappers[i];
	                if (typeof m === 'function') {
	                    var v = m(c);
	                    if (v) {
	                        // if the function returns non-trivial value
	                        return c + ' ' + v;
	                    }
	                } else if (m && (typeof m === 'undefined' ? 'undefined' : _typeof(m)) === 'object') {
	                    if (m.hasOwnProperty(c)) {
	                        return c + ' ' + m[c];
	                    }
	                }
	            }
	
	            // none of the mappers matches
	            return c;
	        });
	    }
	
	    function addStylesMapper(m) {
	        if (m && m.styles && _typeof(m.styles) === 'object') {
	            m = m.styles;
	        }
	
	        stylesMappers.unshift(m);
	    }
	
	    var AccordionPanel = exports.AccordionPanel = function (_React$Component3) {
	        _inherits(AccordionPanel, _React$Component3);
	
	        function AccordionPanel(props) {
	            _classCallCheck(this, AccordionPanel);
	
	            return _possibleConstructorReturn(this, (AccordionPanel.__proto__ || Object.getPrototypeOf(AccordionPanel)).call(this, props));
	        }
	
	        _createClass(AccordionPanel, [{
	            key: 'render',
	            value: function render() {
	                var _props = this.props,
	                    name = _props.name,
	                    title = _props.title,
	                    expanded = _props.expanded,
	                    shown = _props.shown,
	                    onSelect = _props.onSelect,
	                    renderExpanded = _props.renderExpanded,
	                    renderCollapsed = _props.renderCollapsed;
	
	                if (shown) {
	                    if (expanded) {
	                        return React.createElement(
	                            'div',
	                            {
	                                className: 'infw-accordion-border infw-open',
	                                role: 'listitem' },
	                            React.createElement(
	                                'div',
	                                { className: 'infw-accordion-header',
	                                    onClick: function onClick() {
	                                        if (onSelect) onSelect(name);
	                                    } },
	                                React.createElement(
	                                    'span',
	                                    {
	                                        className: 'dls-glyph-down',
	                                        'aria-expanded': expanded,
	                                        role: 'button' },
	                                    title
	                                )
	                            ),
	                            React.createElement(
	                                'div',
	                                { className: 'infw-accordion-content' },
	                                renderExpanded()
	                            )
	                        );
	                    } else {
	                        return React.createElement(
	                            'div',
	                            {
	                                className: 'infw-accordion-border infw-close',
	                                role: 'listitem' },
	                            React.createElement(
	                                'div',
	                                { className: 'infw-accordion-header',
	                                    onClick: function onClick() {
	                                        if (onSelect) onSelect(name);
	                                    } },
	                                React.createElement(
	                                    'span',
	                                    {
	                                        className: 'dls-glyph-right',
	                                        onKeyDown: function onKeyDown(e) {
	                                            if (e.keyCode === 32 && onSelect) onSelect(name)
	                                        },
	                                        'tabindex': 0,
	                                        'aria-expanded': expanded,
	                                        'aria-label': 'toggle button for collapsible accordion',
	                                        role: 'button' },
	                                    title
	                                )
	                            ),
	                            renderCollapsed ? React.createElement(
	                                'div',
	                                { className: 'infw-accordion-content' },
	                                renderCollapsed()
	                            ) : false
	                        );
	                    }
	                } else {
	                    return React.createElement('div', null); // place holder
	                }
	            }
	        }]);
	
	        return AccordionPanel;
	    }(React.Component);
	
	    ;
	
	    AccordionPanel.propTypes = {
	        name: React.PropTypes.string.isRequired,
	        title: React.PropTypes.string.isRequired,
	        expanded: React.PropTypes.bool,
	        shown: React.PropTypes.bool,
	        onSelect: React.PropTypes.func,
	        renderExpanded: React.PropTypes.func.isRequired,
	        renderCollapsed: React.PropTypes.func,
	        children: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.node), React.PropTypes.node])
	    };
	
	    var Accordion = exports.Accordion = function (_React$Component4) {
	        _inherits(Accordion, _React$Component4);
	
	        function Accordion(props) {
	            _classCallCheck(this, Accordion);
	
	            var _this3 = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));
	
	            _this3.state = { active: _this3.props.active };
	            return _this3;
	        }
	
	        _createClass(Accordion, [{
	            key: 'nav',
	            value: function nav(panel) {
	                if (this.state.active === panel) {
	                    this.setState({ active: null });
	                } else {
	                    this.setState({ active: panel });
	                    if (typeof this.props.onSelect === 'function') {
	                        this.props.onSelect.call(this, panel);
	                    }
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this4 = this;
	
	                var panels = [];
	                this.props.children.forEach(function (child) {
	                    mergeArray(panels, child);
	                });
	
	                var children = [];
	                panels.forEach(function (panel) {
	                    if (panel instanceof AccordionPanel) {
	                        var panelName = panel.props.name;
	                        panel.props.shown = true;
	                        panel.props.expanded = panelName === _this4.state.active;
	                        panel.props.onSelect = _this4.nav.bind(_this4);
	
	                        children.push(panel.render());
	                    } else {
	                        throw new Error("AccordionPanel is required in an Accordion");
	                    }
	                });
	
	                return React.createElement(
	                    'div',
	                    {
	                        id: this.props.id,
	                        className: this.props.className,
	                        style: this.props.style,
	                        role: 'list'
	                    },
	                    children
	                );
	            }
	        }]);
	
	        return Accordion;
	    }(React.Component);
	
	    Accordion.propTypes = {
	        id: React.PropTypes.string,
	        className: React.PropTypes.string,
	        style: React.PropTypes.object
	    };
	
	    var ELEM_ID_OVERLAY_PREFIX = exports.ELEM_ID_OVERLAY_PREFIX = 'px_widget_overlay_';
	    var ELEM_ID_OVERLAY_BOX_PREFIX = exports.ELEM_ID_OVERLAY_BOX_PREFIX = 'px_widget_overlay_box_';
	    var OVERLAY_ZINDEX_BASE = exports.OVERLAY_ZINDEX_BASE = 99990;
	    var LEVEL_OVERLAY = exports.LEVEL_OVERLAY = 1;
	    var LEVEL_DIALOG = exports.LEVEL_DIALOG = 9;
	    var OVERLAY_PERCENTAGE = exports.OVERLAY_PERCENTAGE = 0.9;
	
	    var Overlay = exports.Overlay = function (_React$Component5) {
	        _inherits(Overlay, _React$Component5);
	
	        function Overlay(props) {
	            _classCallCheck(this, Overlay);
	
	            var _this5 = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));
	
	            _this5.compContent = null;
	            _this5.visible = props.visible || false;
	            _this5.zIndex = props.zIndex || 99990;
	            return _this5;
	        }
	
	        _createClass(Overlay, [{
	            key: 'renderBox',
	            value: function renderBox() {
	                return this.compContent;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var width = this.visible ? window.innerWidth : 0;
	                var height = this.visible ? window.innerHeight : 0;
	
	                return React.createElement(
	                    'div',
	                    { id: this.props.id,
	                        className: 'infw-modal-wrapper',
	                        style: {
	                            position: 'fixed',
	                            'z-index': this.zIndex,
	                            display: this.visible ? 'block' : 'none',
	                            top: '0px',
	                            left: '0px',
	                            right: width + 'px',
	                            bottom: height + 'px',
	                            background: 'rgba(0, 0, 0, 0.3)'
	                        } },
	                    React.createElement(
	                        'div',
	                        { ref: 'contentBox', id: this.props.boxId,
	                            className: this.props.className },
	                        this.renderBox()
	                    )
	                );
	            }
	        }]);
	
	        return Overlay;
	    }(React.Component);
	
	    function resizeOverlay(elemBase, elemBox) {
	        // resize for overlay, not dialog
	        if (elemBase.style.display === 'block' && elemBase.style.position === 'absolute') {
	            var windowWidth = window.innerWidth;
	            var windowHeight = window.innerHeight;
	
	            elemBase.style.right = windowWidth;
	            elemBase.style.bottom = windowHeight;
	
	            var width = windowWidth * OVERLAY_PERCENTAGE;
	            var height = windowHeight * OVERLAY_PERCENTAGE;
	            elemBox.style['margin-left'] = -width / 2 + 'px';
	            elemBox.style['margin-top'] = -height / 2 + 'px';
	            elemBox.style.width = elemBox.style['min-width'] = width + 'px';
	            elemBox.style.height = elemBox.style['min-height'] = height + 'px';
	        }
	    }
	
	    function getOverlay(overlayLevel, createNew) {
	        var elemId = ELEM_ID_OVERLAY_PREFIX + overlayLevel;
	        var elemOverlay = document.getElementById(elemId),
	            elemBox = null;
	        if (elemOverlay) {
	            elemBox = document.getElementById(ELEM_ID_OVERLAY_BOX_PREFIX + overlayLevel);
	        } else {
	            if (createNew) {
	                var zIndex = OVERLAY_ZINDEX_BASE + overlayLevel;
	                var isOverlay = zIndex !== LEVEL_DIALOG;
	
	                var overlay = React.createElement(Overlay, { id: elemId,
	                    boxId: ELEM_ID_OVERLAY_BOX_PREFIX + overlayLevel,
	                    visible: false,
	                    className: isOverlay ? 'infw-modal-overlay' : 'infw-modal-dialog',
	                    zIndex: zIndex });
	
	                var container = document.getElementById('widget_root');
	                if (container) {
	                    ReactDOM.render(overlay, container, true);
	                } else {
	                    ReactDOM.render(overlay, document.body, true);
	                }
	                elemOverlay = ReactDOM.findDOMNode(overlay);
	                elemBox = overlay.refs.contentBox;
	
	                window.addEventListener("resize", function (evt) {
	                    resizeOverlay(elemOverlay, elemBox);
	                });
	            }
	        }
	        if (elemOverlay && elemBox) {
	
	            return {
	                base: elemOverlay,
	                box: elemBox
	            };
	        } else {
	            console.log("Fail to find the overlay.");
	            return null;
	        }
	    }
	
	    function hideModal(overlayLevel) {
	        var overlay = getOverlay(overlayLevel);
	        if (overlay) {
	            overlay.base.style.display = 'none';
	            overlay.base.style.right = overlay.base.style.left;
	            overlay.base.style.bottom = overlay.base.style.top;
	        }
	    }
	
	    function showModal(comp, overlayLevel) {
	        overlayLevel = overlayLevel || LEVEL_DIALOG;
	        var overlay = getOverlay(overlayLevel, true);
	
	        if (!overlay) {
	            throw new Error("Fail to create overlay of level " + overlayLevel);
	        }
	
	        // show it
	        var elemBase = overlay.base;
	        var elemBox = overlay.box;
	
	        elemBase.style.display = "block";
	
	        elemBox.style.position = 'relative';
	        elemBox.style.left = '50%';
	        elemBox.style.top = '50%';
	
	        if (overlayLevel === LEVEL_DIALOG) {
	            elemBase.style.position = 'fixed';
	
	            var windowWidth = window.innerWidth;
	            var windowHeight = window.innerHeight;
	            elemBase.style.right = windowWidth;
	            elemBase.style.bottom = windowHeight;
	
	            var width = 600;
	            var height = 300;
	            if (comp.props.width) {
	                width = parsePx(comp.props.width);
	            } else if (comp.props.style && comp.props.style.width) {
	                width = parsePx(comp.props.style.width);
	            }
	            if (width > windowWidth) {
	                width = windowWidth;
	            }
	
	            if (comp.props.height) {
	                height = parsePx(comp.props.height);
	            } else if (comp.props.style && comp.props.style.height) {
	                height = parsePx(comp.props.style.height);
	            }
	            if (height > windowHeight) {
	                height = windowHeight;
	            }
	
	            elemBox.style['margin-left'] = -width / 2 + 'px';
	            elemBox.style['margin-top'] = -height / 2 + 'px';
	            elemBox.style.width = elemBox.style['min-width'] = width + 'px';
	            elemBox.style.height = elemBox.style['min-height'] = height + 'px';
	        } else {
	            elemBase.style.position = 'absolute';
	
	            resizeOverlay(elemBase, elemBox);
	        }
	
	        ReactDOM.render(comp, elemBox);
	    }
	
	    var WidgetApp = exports.WidgetApp = function (_React$Component6) {
	        _inherits(WidgetApp, _React$Component6);
	
	        function WidgetApp(props) {
	            _classCallCheck(this, WidgetApp);
	
	            var _this6 = _possibleConstructorReturn(this, (WidgetApp.__proto__ || Object.getPrototypeOf(WidgetApp)).call(this, props));
	
	            _this6.pages = {};
	            return _this6;
	        }
	
	        _createClass(WidgetApp, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                var _this7 = this;
	
	                var resourceUrl = this.getTextResourceUrl();
	                if (resourceUrl) {
	                    setCurrentLocale(resourceUrl, function () {
	                        _this7.onResourcesLoaded();
	                    }, function (err) {
	                        _this7.showError(err);
	                    });
	                }
	            }
	        }, {
	            key: 'addPage',
	            value: function addPage(pageName, pageClass, props) {
	                this.pages[pageName] = { pageClass: pageClass, props: props };
	            }
	        }, {
	            key: 'nav',
	            value: function nav(pageName) {
	                // to trigger rendering
	                this.setState({ pageName: pageName });
	            }
	        }, {
	            key: 'onResourcesLoaded',
	            value: function onResourcesLoaded() {
	                console.log("Resources ready.");
	            }
	        }, {
	            key: 'showError',
	            value: function showError(err) {
	                console.log(err);
	            }
	        }, {
	            key: 'onClose',
	            value: function onClose(evt) {
	                console.log("WARN: not implemented.");
	            }
	        }, {
	            key: 'getTextResourceUrl',
	            value: function getTextResourceUrl() {
	                throw new Error('getTextResourceUrl() not implemented');
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	
	                var page = this.pages[this.state.pageName];
	                if ((typeof page === 'undefined' ? 'undefined' : _typeof(page)) !== 'object') {
	                    throw new Error('Invalid page ' + this.state.pageName);
	                }
	                var props = extend({
	                    widget: this,
	                    onClose: this.onClose.bind(this)
	                }, page.props);
	                var pageComp = React.createElement(page.pageClass, props);
	
	                return React.createElement(
	                    'div',
	                    { id: this.props.id,
	                        className: this.props.className,
	                        style: this.props.style },
	                    pageComp
	                );
	            }
	        }]);
	
	        return WidgetApp;
	    }(React.Component);
	
	    WidgetApp.propTypes = {
	        config: React.PropTypes.object.isRequired
	    };
	});


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GetInfoWidgetApp = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _consts = __webpack_require__(65);
	
	var consts = _interopRequireWildcard(_consts);
	
	var _flow = __webpack_require__(10);
	
	var _init = __webpack_require__(77);
	
	var _index = __webpack_require__(83);
	
	var _yodlee = __webpack_require__(104);
	
	var _thank = __webpack_require__(107);
	
	var _yodleesubmit = __webpack_require__(108);
	
	var _yodleeoptout = __webpack_require__(113);
	
	var _yodleeoptout2 = _interopRequireDefault(_yodleeoptout);
	
	var _nova = __webpack_require__(114);
	
	var _nova2 = _interopRequireDefault(_nova);
	
	var _dialog = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetInfoWidgetApp = exports.GetInfoWidgetApp = function (_WidgetApp) {
	    _inherits(GetInfoWidgetApp, _WidgetApp);
	
	    function GetInfoWidgetApp(props) {
	        _classCallCheck(this, GetInfoWidgetApp);
	
	        var _this = _possibleConstructorReturn(this, (GetInfoWidgetApp.__proto__ || Object.getPrototypeOf(GetInfoWidgetApp)).call(this, (0, _pexui.extend)({
	            id: consts.ELEM_ID_WIDGET,
	            className: consts.CLASS_WIDGET
	        }, props)));
	
	        _this.addPage("init", _init.InitPage);
	        _this.addPage("index", _index.IndexPage);
	        _this.addPage("yodlee", _yodlee.YodleePage);
	        _this.addPage("yodleeSubmit", _yodleesubmit.YodleeSubmitPage);
	        _this.addPage('yodleeOptOut', _yodleeoptout2.default);
	        _this.addPage("thankyou", _thank.ThankYouPage);
	        _this.addPage("nova", _nova2.default);
	
	        _this.state = {
	            pageName: "init"
	        };
	        return _this;
	    }
	
	    _createClass(GetInfoWidgetApp, [{
	        key: 'showError',
	        value: function showError(err) {
	            console.error(err);
	        }
	    }, {
	        key: 'closeWidget',
	        value: function closeWidget() {
	            (0, _pexui.hideModal)(_pexui.LEVEL_OVERLAY);
	
	            var elem = _pexui.ReactDOM.findDOMNode(this);
	            var parent = elem.parentNode;
	            while (parent && parent.lastChild) {
	                parent.removeChild(parent.lastChild);
	            }
	        }
	    }, {
	        key: 'allCompleted',
	        value: function allCompleted() {
	            //status completed will only be true if it is yodlee only
	            return _flow.STATUS_COMPLETED === _flow.flow.getReadyStatus();
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit() {
	            var _this2 = this;
	
	            var doSubmit = function doSubmit() {
	                //for Yodlee-only, ThankYou has already been tracked.
	                if (!_flow.flow.isYodleeOnly()) {
	                    (0, _track.track)("ThankYou", {
	                        events: consts.SUCCESSFUL_COMPLETED_JOURNEY_EVENT
	                    });
	                }
	
	                _flow.flow.raiseInvokerEvent('submit', '');
	                _this2.closeWidget();
	            };
	
	            if (this.allCompleted()) {
	                doSubmit();
	            } else {
	                (0, _track.track)("AYSSubmit");
	
	                _pexui.React.createElement(_dialog.SubmitDialog, null).show().then(function (choice) {
	                    if (choice === 'yes') {
	                        //trackClick('Click_YesSubmit');
	                        doSubmit();
	                    } else {
	                        (0, _track.trackClick)('Click_NoGoBack');
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onClose',
	        value: function onClose() {
	            var _this3 = this;
	
	            (0, _track.track)("AYSExit", { contentName: (0, _flow.getTrackLabel)(_flow.flow.nodes && _flow.flow.nodes[0]) });
	
	            var exitDialog = _flow.flow.isYodleeOnly() ? _pexui.React.createElement(_dialog.ExitYodleeDialog, null) : _pexui.React.createElement(_dialog.ExitConfirmDialog, null);
	            exitDialog.show().then(function (choice) {
	                if (choice === 'yes') {
	                    (0, _track.trackExit)();
	
	                    _flow.flow.raiseInvokerEvent('fail', 'User cancelled');
	
	                    _this3.closeWidget();
	                } else {
	                    (0, _track.trackClick)('Click_NoGoBack');
	                }
	            });
	        }
	    }, {
	        key: 'getTextResourceUrl',
	        value: function getTextResourceUrl() {
	            return '';
	        }
	    }]);
	
	    return GetInfoWidgetApp;
	}(_pexui.WidgetApp);
	
	GetInfoWidgetApp.propTypes = {
	    config: _pexui.React.PropTypes.object.isRequired,
	    req: _pexui.React.PropTypes.object.isRequired,
	    widgetCallback: _pexui.React.PropTypes.func.isRequired
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.determineMessageType = exports.formatYodleeData = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	//
	// utils
	//
	
	exports.resetGlobals = resetGlobals;
	exports.ajaxPromise = ajaxPromise;
	exports.uploadPromise = uploadPromise;
	exports.getBaseUri = getBaseUri;
	exports.getSameDomainBaseUrl = getSameDomainBaseUrl;
	exports.getElement = getElement;
	exports.findElement = findElement;
	exports.findElements = findElements;
	exports.hasClass = hasClass;
	exports.inArray = inArray;
	exports.mergeArray = mergeArray;
	exports.findArray = findArray;
	exports.deleteArray = deleteArray;
	exports.reduceArray = reduceArray;
	exports.randomString = randomString;
	exports.getAllWeneedCodes = getAllWeneedCodes;
	exports.parseWeneedCodes = parseWeneedCodes;
	exports.goOverFlowNodes = goOverFlowNodes;
	exports.goOverTree = goOverTree;
	exports.registerMessageHandler = registerMessageHandler;
	exports.isHtml = isHtml;
	exports.isContentId = isContentId;
	exports.getUrlFromResource = getUrlFromResource;
	exports.formatHtml = formatHtml;
	exports.safeHtml = safeHtml;
	exports.getHtmlContent = getHtmlContent;
	exports.getHtml = getHtml;
	exports.getContent = getContent;
	exports.makeUrl = makeUrl;
	exports.parseYodleeResponse = parseYodleeResponse;
	exports.parseUrlParams = parseUrlParams;
	exports.filenameMatches = filenameMatches;
	exports.formatTime = formatTime;
	exports.beginsWith = beginsWith;
	exports.endsWith = endsWith;
	exports.sprintf = sprintf;
	exports.getTimestamp = getTimestamp;
	exports.formatTimestamp = formatTimestamp;
	exports.getUniqueId = getUniqueId;
	exports.convertError = convertError;
	exports.logError = logError;
	exports.getLanguage = getLanguage;
	exports.isGoodBrowser = isGoodBrowser;
	
	var _es6PromisePolyfill = __webpack_require__(5);
	
	var _pexui = __webpack_require__(2);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _flow = __webpack_require__(10);
	
	var _lodash = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Promise = _es6PromisePolyfill.Promise;
	exports.evalExpr = _pexui.evalExpr;
	
	function resetGlobals() {
	    for (var k in _globals2.default) {
	        if (_globals2.default.hasOwnProperty(k)) {
	            delete _globals2.default[k];
	        }
	    }
	
	    _globals2.default.config = {};
	    _globals2.default.widgetConfig = null;
	    _globals2.default.req = null;
	    _globals2.default.widgetCallback = null;
	}
	
	/**
	 * Ajax call
	 * @param {object} args
	 *    {
	 *         url  : the service url
	 *         method: HTTP method "GET", "POST" etc
	 *         headers: request headers
	 *    }
	 * @return {object} Promise
	 */
	function ajaxPromise(args) {
	    return new _es6PromisePolyfill.Promise(function (resolve, reject) {
	        args.success = function (payload, respHeaders) {
	            resolve({
	                data: payload,
	                headers: respHeaders
	            });
	        };
	        args.error = reject;
	        (0, _pexui.ajax)(args);
	    });
	}
	
	/**
	 * Upload a file
	 * @param {object} args
	 *    {
	 *         url  : the service url
	 *         file : the file to upload,
	 *         formFields:  form fields,
	 *         headers: request headers
	 *    }
	 * @return {object} Promise
	 */
	function uploadPromise(args) {
	    return new _es6PromisePolyfill.Promise(function (resolve, reject) {
	        args.success = function (file, payload, respHeaders) {
	            resolve({
	                file: file,
	                data: payload,
	                headers: respHeaders
	            });
	        };
	
	        args.error = reject;
	
	        (0, _pexui.upload)(args);
	    });
	}
	
	function getBaseUri() {
	    if (_globals2.default.BASE_URI) {
	        return _globals2.default.BASE_URI;
	    }
	
	    var widgetConfig = _globals2.default.widgetConfig;
	    if (widgetConfig && widgetConfig.widget_base_url) {
	        _globals2.default.BASE_URI = widgetConfig.widget_base_url;
	        return _globals2.default.BASE_URI;
	    }
	
	    _globals2.default.BASE_URI = findScriptTag('pex_getinfo_widget.js');
	    if (_globals2.default.BASE_URI) {
	        return _globals2.default.BASE_URI;
	    } else {
	        throw new Error('Can not find the widget base URL, please either pass widget_config.widget_base_url or define a <script> tag refering the widget js.');
	    }
	}
	
	function getSameDomainBaseUrl() {
	    var pageUrl = document.location.href;
	    pageUrl = pageUrl.replace(/\?.*$/, '');
	
	    var uri = getBaseUri();
	    if (pageUrl.indexOf('americanexpress.com') >= 0 && uri.indexOf('americanexpress.com') === -1) {
	        // replace E1 URL with E2 URL, download html from E2 instead.
	        uri = uri.replace('dxp-docupload-dev.aexp.com', 'dxp-docupload-qa.americanexpress.com');
	    }
	    return uri;
	}
	
	function findScriptTag(scriptName) {
	    var scripts = document.getElementsByTagName("script");
	    for (var i = 0; i < scripts.length; i++) {
	        var script = scripts[i];
	        var pos;
	        if (script.src && (pos = script.src.indexOf(scriptName)) !== -1) {
	            var url = script.src.substring(0, pos);
	            return url.replace(/\/scripts\/$/, '/');
	        }
	    }
	    return '';
	}
	
	function getElement(elemOrId) {
	    if (!elemOrId) {
	        throw new Error("Empty elem id");
	    } else if (typeof elemOrId === 'string') {
	        if (beginsWith(elemOrId, '#')) {
	            elemOrId = elemOrId.substring(1);
	        }
	
	        return document.getElementById(elemOrId);
	    } else if (elemOrId instanceof HTMLElement) {
	        return elemOrId;
	    } else if (elemOrId instanceof _pexui.React.Component) {
	        return ReactDOM.findDOMNode(elemOrId);
	    }
	    throw new Error("Invalid element " + elemOrId);
	}
	
	function findElement(query) {
	    return document.querySelector(query);
	}
	
	function findElements(query) {
	    var elems = [];
	    var list = document.querySelectorAll(query);
	    for (var i = 0; i < list.length; i++) {
	        elems.push(list.item(i));
	    }
	    return elems;
	}
	
	function hasClass(elem, cls) {
	    return (' ' + elem.className + ' ').indexOf(' ' + cls + ' ') >= 0;
	}
	
	function inArray(arr, obj) {
	    if (arr) {
	        return arr.indexOf(obj) !== -1;
	    } else {
	        return false;
	    }
	}
	
	function arrayAdd(arr, item) {
	    if (!inArray(arr, item)) {
	        arr.push(item);
	    }
	}
	
	function mergeArray(arr1, arr2) {
	    arr1 = arr1 || [];
	    if (!Array.isArray(arr1)) {
	        arr1 = [arr1];
	    }
	    if (arr2) {
	        if (Array.isArray(arr2)) {
	            for (var i = 0; i < arr2.length; i++) {
	                arrayAdd(arr1, arr2[i]);
	            }
	        } else {
	            arrayAdd(arr1, arr2);
	        }
	    }
	    return arr1;
	}
	
	function findArray(arr, condition) {
	    if (arr && Array.isArray(arr)) {
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i] && condition(arr[i])) {
	                return arr[i];
	            }
	        }
	    }
	    return null;
	}
	
	function deleteArray(arr, condition) {
	    if (!(arr && Array.isArray(arr))) {
	        return arr;
	    }
	    var done = false;
	    while (!done) {
	        done = true;
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i] && condition(arr[i])) {
	                arr.splice(i, 1);
	                done = false;
	                break;
	            }
	        }
	    }
	    return arr;
	}
	
	function reduceArray(arr, reducer, initValue) {
	    if (arr && typeof Array.prototype.reduce === 'function') {
	        return arr.reduce(reducer, initValue);
	    } else {
	        var value = initValue;
	        if (arr && Array.isArray(arr)) {
	            for (var i = 0; i < arr.length; i++) {
	                value = reducer(value, arr[i]);
	            }
	        }
	        return value;
	    }
	}
	
	function randomString(len) {
	    var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345679';
	    var s = '';
	    for (var i = 0; i < len; i++) {
	        s = s + CHARS.charAt(Math.round(CHARS.length * Math.random()) % CHARS.length);
	    }
	    return s;
	}
	
	function getAllWeneedCodes(weneedCodes) {
	    return weneedCodes.replace(/[\(\)\s]/g, '').replace(/[\|\&|\+]/g, ',');
	}
	
	function parseOr(expr) {
	    var lastPos = -1,
	        level = 0;
	    var items = [];
	    var item = '';
	    for (var i = 0; i < expr.length; i++) {
	        var c = expr.charAt(i);
	        if (c === '(') {
	            ++level;
	        } else if (c === ')') {
	            --level;
	            if (level < 0) {
	                throw new Error("Invalid we need code expression \"" + expr + "\", unpaired braces");
	            }
	        } else if (level === 0 && c === '|') {
	            item = expr.substring(lastPos + 1, i);
	            lastPos = i;
	            items.push(item);
	            item = '';
	        }
	        item += c;
	    }
	    if (lastPos + 1 < expr.length) {
	        var item2 = expr.substring(lastPos + 1);
	        items.push(item2);
	    }
	    if (items.length > 1) {
	        var data = [];
	        items.forEach(function (item3) {
	            data.push(parseOr(item3));
	        });
	        return {
	            op: 'OR',
	            data: data
	        };
	    } else {
	        return parseAnd(expr);
	    }
	}
	
	function parseAnd(expr) {
	    if (expr.length === 0) {
	        throw new Error("Invalid we need code expression, empty item");
	    }
	
	    var lastPos = -1,
	        level = 0;
	    var items = [];
	    var item = '';
	    for (var i = 0; i < expr.length; i++) {
	        var c = expr.charAt(i);
	        if (c === '(') {
	            ++level;
	        } else if (c === ')') {
	            --level;
	            if (level < 0) {
	                throw new Error("Invalid we need code expression \"" + expr + "\", unpaired braces");
	            }
	        } else if (level === 0 && c === '&') {
	            item = expr.substring(lastPos + 1, i);
	            lastPos = i;
	            items.push(item);
	            item = '';
	        }
	        item += c;
	    }
	    if (lastPos + 1 < expr.length) {
	        item = expr.substring(lastPos + 1);
	        items.push(item);
	    }
	    if (items.length > 1) {
	        var data = [];
	        items.forEach(function (item) {
	            data.push(parseAnd(item));
	        });
	        return {
	            op: 'AND',
	            data: data
	        };
	    } else {
	        if (expr.charAt(0) === '(') {
	            if (expr.charAt(expr.length - 1) === ')') {
	                return parseOr(expr.substring(1, expr.length - 1));
	            } else {
	                throw new Error("Invalid we need code expression \"" + expr + "\", unpaired braces");
	            }
	        } else {
	            return {
	                op: 'ITEM',
	                data: expr
	            };
	        }
	    }
	}
	
	function parseWeneedCodes(weneedCodes) {
	    weneedCodes = weneedCodes.replace(/[\s]/g, '').replace(/[\+,]/g, '&');
	    return parseOr(weneedCodes);
	}
	
	function goOverFlowNodes(nodes, handler) {
	    if (nodes) {
	        nodes.forEach(function (node) {
	            handler(node);
	            if (node.choices) {
	                node.choices.forEach(function (choice) {
	                    goOverFlowNodes(choice, handler);
	                });
	            }
	        });
	    }
	}
	
	function goOverTree(node, f) {
	    if (node.op === 'OR') {
	        f('(');
	        for (var i = 0; i < node.data.length; i++) {
	            if (i > 0) {
	                f('OR');
	            }
	            goOverTree(node.data[i], f);
	        }
	        f(')');
	    } else if (node.op === 'AND') {
	        f('(');
	        for (var _i = 0; _i < node.data.length; _i++) {
	            if (_i > 0) {
	                f('AND');
	            }
	            goOverTree(node.data[_i], f);
	        }
	        f(')');
	    } else if (node.op === 'ITEM') {
	        f(node);
	    }
	}
	
	function registerMessageHandler(handler) {
	    // Create IE + others compatible event handler
	    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
	    var eventer = window[eventMethod];
	    var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
	
	    // Listen to message from child window
	    eventer(messageEvent, handler, false);
	}
	
	function isHtml(text) {
	    return (/<\w{1,5}.*>/.test(text)
	    );
	}
	
	function isContentId(str) {
	    return typeof str === 'string' && /^[\w_]([\w_\-\.]*[\w_])?$/.test(str);
	}
	
	function getUrlFromResource(contentId) {
	    var url = isContentId(contentId) ? (0, _pexui._n)(contentId) : contentId;
	    if (typeof url === 'string' && url) {
	        url = url.replace(/^\s*url\((.*)\)\s*$/, '$1');
	        url = url.trim();
	
	        if (/^https?:\/\//i.test(url)) {
	            // absolute url
	        } else {
	            // relative url
	            url = makeUrl((0, _pexui.getCurrentLocaleUrl)(), url);
	        }
	    }
	    return url;
	}
	
	function formatHtml(text) {
	    // rich text
	    if (isHtml(text)) {
	        text = safeHtml(text);
	    } else if (text.indexOf('\n') >= 0) {
	        text = text.replace(/\n/g, '<br/>');
	    }
	    return text;
	}
	
	function safeHtml(html) {
	    if (html) {
	        // remove comments
	        html = html.replace(/<!--[\s\S]*?-->/g, '');
	        var m = /<\s*body[^\>]*>([\s\S]*)<\/\s*body\s*>/i.exec(html);
	        if (m) {
	            // only the body content
	            html = m[1];
	        }
	        // removes script tags for injection attack
	        html = html.replace(/<\s*script[^>]*>[\s\S]*?<\/\s*script\s*>/gi, '');
	        // make all hyperlinks shown in new tabs, in order not to break the widget.
	        html = html.replace(/<a\s+([^>]*)>/gi, function (tag, attrs) {
	            if (/target\s*=/i.test(attrs)) {
	                return tag;
	            } else {
	                return '<a ' + attrs + ' target="_blank">';
	            }
	        });
	        html = html.replace(/<\w+[^>]*>/g, function (tag) {
	            // removes event handlers
	            return tag.replace(/\son\w+\s*=\s*\"[^\"]*\"/gi, '');
	        });
	    }
	    return html;
	}
	
	/**
	 * Get HTML or plain text content by contentId
	 * @param {String} contentId
	 * @return {object} could be a String if the content is ready, or a promise
	 */
	function getHtmlContent(contentId, value) {
	    var content = getContent(contentId, value);
	    if (content instanceof _es6PromisePolyfill.Promise) {
	        return content.then(function (resp) {
	            resp.data = safeHtml(resp.data);
	            return resp;
	        });
	    } else {
	        return safeHtml(content);
	    }
	}
	
	function getHtml(content) {
	    if (isContentId(content)) {
	        // like a content id
	        content = getHtmlContent(content);
	    } else {
	        content = formatHtml(content);
	    }
	
	    if (typeof content === 'string') {
	        // a string
	        if (isHtml(content)) {
	            var elem = document.createElement('span');
	            elem.innerHTML = content;
	            return elem;
	        } else {
	            return content;
	        }
	    } else if (content instanceof _es6PromisePolyfill.Promise) {
	        // a promise
	        var _elem = document.createElement('span');
	        content.then(function (resp) {
	            _elem.innerHTML = resp.data;
	        });
	        return _elem;
	    } else {
	        return content;
	    }
	}
	
	/**
	 * Get HTML or plain text content by contentId
	 * @param {String} contentId
	 * @return {object} could be a String if the content is ready, or a promise
	 */
	function getContent(contentId, value) {
	    var content = isContentId(contentId) ? (0, _pexui._n)(contentId, value) : (0, _pexui.evalExpr)(contentId, value);
	    var m = /^\s*url\((.*)\)\s*$/.exec(content);
	    if (m) {
	        // url
	        var url = m[1].trim();
	
	        if (/^https?:\/\//i.test(url)) {
	            // absolute url
	        } else {
	            // relative url
	            url = makeUrl((0, _pexui.getCurrentLocaleUrl)(), url);
	        }
	
	        if (_globals2.default.htmlCache && _globals2.default.htmlCache.hasOwnProperty(url)) {
	            return (0, _pexui.evalExpr)(_globals2.default.htmlCache[url], value);
	        } else {
	            return ajaxPromise({
	                method: 'GET',
	                url: url
	            }).then(function (resp) {
	                var content = resp.data;
	
	                // cache it
	                if (!_globals2.default.htmlCache) {
	                    _globals2.default.htmlCache = {};
	                }
	                _globals2.default.htmlCache[url] = content;
	
	                resp.data = (0, _pexui.evalExpr)(content, value);
	                return resp;
	            }).catch(function (err) {
	                logError(err);
	            });
	        }
	    } else {
	        return content;
	    }
	}
	
	function makeUrl(url, path) {
	    url = url.replace('\?.*$', '').replace(/[^\/]+$/, '');
	    path = path.replace(/^(\.\/)+/, '');
	    while (/^\.\.\//.test(path)) {
	        // deletes starting ../
	        path = path.replace(/^\.\.\/(\.\/)*/, '');
	        // deletes ending foo/
	        url = url.replace(/[^\/]+\/?$/, '');
	    }
	    url = url + path;
	    return url;
	}
	
	function parseYodleeResponse(encoded) {
	    var decoded = encoded.replace(/\%([0-9a-fA-F]{2})/g, function (_all, hex) {
	        return String.fromCharCode(parseInt(hex, 16));
	    });
	    var o = {};
	    decoded.split('&').forEach(function (phrase) {
	        var pos = phrase.indexOf('=');
	        if (pos > 0) {
	            var key = phrase.substring(0, pos);
	            var value = phrase.substring(pos + 1);
	            o[key] = value;
	        }
	    });
	    return o;
	}
	
	var formatYodleeData = exports.formatYodleeData = function formatYodleeData(data) {
	    if ((0, _lodash.isObject)(data)) {
	        return JSON.stringify(data).slice(1, -1);
	    }
	    return data;
	};
	
	function parseUrlParams(urlQuery) {
	    urlQuery = urlQuery || '';
	    var o = {};
	    urlQuery.split('&').forEach(function (phrase) {
	        var pos = phrase.indexOf('=');
	        if (pos > 0) {
	            var key = phrase.substring(0, pos);
	            var value = phrase.substring(pos + 1).replace(/\+/g, ' ').replace(/\%([0-9a-fA-F]{2})/g, function (_all, hex) {
	                return String.fromCharCode(parseInt(hex, 16));
	            });;
	            o[key] = value;
	        }
	    });
	    return o;
	}
	
	var determineMessageType = exports.determineMessageType = function determineMessageType(data) {
	    if (/JSONCallbackStatus/.test(data)) {
	        return 'JSONCallbackStatus';
	    } else if (/yodlee_success/.test(data)) {
	        return 'yodlee_success';
	    } else if (/yodlee_login_error/.test(data)) {
	        return 'yodlee_login_error';
	    } else if (/yodlee_login_error/.test(data)) {
	        return 'yodlee_login_error';
	    } else if (/yodlee_session_error/.test(data)) {
	        return 'yodlee_session_error';
	    } else if (/yodlee_tech_error/.test(data)) {
	        return 'yodlee_tech_error';
	    } else if (/yodlee_default_error/.test(data)) {
	        return 'yodlee_default_error';
	    }
	};
	
	function filenameMatches(fname1, fname2) {
	    fname1 = fname1.replace(/^.*\//, '');
	    fname2 = fname2.replace(/^.*\//, '');
	    return fname1.toLowerCase() === fname2.toLowerCase();
	}
	
	var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	function getDaySuffix(day) {
	    if (day < 10 || day > 20) {
	        switch (day % 10) {
	            case 1:
	                return 'st';
	            case 2:
	                return 'nd';
	            case 3:
	                return 'rd';
	            default:
	                break;
	        }
	    }
	    return 'th';
	}
	
	function formatTime(d) {
	    return monthNames[d.getMonth()] + ' ' + d.getDate() + getDaySuffix(d.getDate()) + ',' + d.getFullYear();
	}
	
	function beginsWith(s1, s2) {
	    return s1.lastIndexOf(s2, 0) === 0;
	}
	
	function endsWith(s1, s2) {
	    return s1.length >= s2.length && s1.lastIndexOf(s2, s1.length - s2.length) === s1.length - s2.length;
	}
	
	function sprintf() {
	    var args = arguments,
	        fmt = args[0];
	    var argsIdx = 1;
	    return fmt.replace(/%(%|\d*s|\d*d|\d*(\.\d*)?f)/g, function (m) {
	        // m is the matched format, e.g. %s, %d
	        var val = void 0;
	        if (m === '%%') {
	            val = '%';
	        } else if (endsWith(m, 's')) {
	            val = sprintf4s(m, String(args[argsIdx++]));
	        } else if (endsWith(m, 'd')) {
	            val = sprintf4d(m, String(args[argsIdx++]));
	        } else if (endsWith(m, 'f')) {
	            val = sprintf4f(m, args[argsIdx++]);
	        } else {
	            throw new Error("Won't happen, format:[" + m + "]");
	        }
	        return val;
	    });
	}
	
	function sprintf4s(fmt, val) {
	    var m = /%(\d*)s/.exec(fmt);
	    if (m && m[1]) {
	        var digFmt = m[1];
	        var fillChar = ' ';
	        var len = parseInt(digFmt);
	        while (val.length < len) {
	            val = fillChar + val;
	        }
	    }
	    return val;
	}
	
	function sprintf4d(fmt, val) {
	    var m = /%(\d*)d/.exec(fmt);
	    if (m && m[1]) {
	        var digFmt = m[1];
	        var fillChar = digFmt[0] === '0' ? '0' : ' ';
	        var len = parseInt(digFmt);
	        while (val.length < len) {
	            val = fillChar + val;
	        }
	    }
	    return val;
	}
	
	function sprintf4f(fmt, val) {
	    var m = /%(\d*)(?:\.(\d*))?f/.exec(fmt);
	    if (m) {
	        if (typeof val === 'string') {
	            val = parseFloat(val);
	        }
	        if (m[2]) {
	            var dec = parseInt(m[2]);
	            val = val.toFixed(dec);
	        }
	        val = String(val);
	        if (m[1]) {
	            var len = parseInt(m[1]);
	            while (len > 0 && val.length < len) {
	                val = ' ' + val;
	            }
	        }
	    }
	    return val;
	}
	
	function getTimestamp() {
	    var now = new Date();
	    return formatTimestamp(now);
	}
	
	function formatTimestamp(now) {
	    return sprintf("%02d/%02d/%04d %02d:%02d:%02d.%04d", now.getUTCMonth() + 1, now.getUTCDate(), now.getUTCFullYear(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
	}
	
	function getUniqueId(prefix, node) {
	    return prefix + '_' + (node && node.widgetOption ? node.widgetOption.content_id : randomString(5));
	}
	
	/**
	 * Converts a response object to error message
	 * @param {object} respObj
	 * @return {string} error message
	 */
	function convertError(respObj) {
	    if (respObj) {
	        if (respObj instanceof Error) {
	            respObj = respObj.message;
	            if (respObj.charAt(0) === '!') {
	                // already converted
	                return respObj.substr(1);
	            }
	        }
	
	        if ((typeof respObj === 'undefined' ? 'undefined' : _typeof(respObj)) === 'object' && respObj.response_code) {
	            logError('Error code:' + respObj.response_code + ', message: ' + respObj.response_message);
	            _flow.flow.lastError = respObj.response_code;
	            return {
	                message: (0, _pexui._n)('error.' + respObj.response_code + '.message'),
	                errorKey: 'error.' + respObj.response_code + '.message'
	            };
	        } else if (typeof respObj === 'string') {
	            logError('Error:' + respObj);
	            if (respObj.charAt(0) === '!') {
	                // already converted
	                return { message: respObj.substr(1) };
	            }
	            var m = /code:\s*(\d+)/i.exec(respObj);
	            if (m) {
	                var errMessage = (0, _pexui._n)('error.' + m[1] + '.message');
	                if (errMessage) {
	                    return {
	                        message: errMessage,
	                        errorKey: 'error.' + m[1] + '.message'
	                    };
	                }
	            }
	
	            return {
	                message: (0, _pexui._n)('error.service.message'),
	                errorKey: 'error.service.message'
	            };
	        }
	    }
	    return {
	        message: (0, _pexui._n)('error.default.message'),
	        errorKey: 'error.default.message'
	    };
	}
	
	function logError(err) {
	    console.error(err);
	}
	
	function getLanguage(locale) {
	    if (locale && typeof locale === 'string') {
	        var m = /^[a-z]{2}/.exec(locale);
	        if (m) {
	            return m[0];
	        } else {
	            return 'en'; // default language
	        }
	    } else {
	        return 'en';
	    }
	}
	
	function isGoodBrowser() {
	    var userAgent = window.navigator.userAgent;
	    return userAgent.indexOf('Chrome') >= 0 || userAgent.indexOf('Firefox') >= 0 || userAgent.indexOf('Safari') >= 0;
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate) {(function(global){
	
	//
	// Check for native Promise and it has correct interface
	//
	
	var NativePromise = global['Promise'];
	var nativePromiseSupported =
	  NativePromise &&
	  // Some of these methods are missing from
	  // Firefox/Chrome experimental implementations
	  'resolve' in NativePromise &&
	  'reject' in NativePromise &&
	  'all' in NativePromise &&
	  'race' in NativePromise &&
	  // Older version of the spec had a resolver object
	  // as the arg rather than a function
	  (function(){
	    var resolve;
	    new NativePromise(function(r){ resolve = r; });
	    return typeof resolve === 'function';
	  })();
	
	
	//
	// export if necessary
	//
	
	if (typeof exports !== 'undefined' && exports)
	{
	  // node.js
	  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
	  exports.Polyfill = Promise;
	}
	else
	{
	  // AMD
	  if (true)
	  {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	      return nativePromiseSupported ? NativePromise : Promise;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  else
	  {
	    // in browser add to global
	    if (!nativePromiseSupported)
	      global['Promise'] = Promise;
	  }
	}
	
	
	//
	// Polyfill
	//
	
	var PENDING = 'pending';
	var SEALED = 'sealed';
	var FULFILLED = 'fulfilled';
	var REJECTED = 'rejected';
	var NOOP = function(){};
	
	function isArray(value) {
	  return Object.prototype.toString.call(value) === '[object Array]';
	}
	
	// async calls
	var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
	var asyncQueue = [];
	var asyncTimer;
	
	function asyncFlush(){
	  // run promise callbacks
	  for (var i = 0; i < asyncQueue.length; i++)
	    asyncQueue[i][0](asyncQueue[i][1]);
	
	  // reset async asyncQueue
	  asyncQueue = [];
	  asyncTimer = false;
	}
	
	function asyncCall(callback, arg){
	  asyncQueue.push([callback, arg]);
	
	  if (!asyncTimer)
	  {
	    asyncTimer = true;
	    asyncSetTimer(asyncFlush, 0);
	  }
	}
	
	
	function invokeResolver(resolver, promise) {
	  function resolvePromise(value) {
	    resolve(promise, value);
	  }
	
	  function rejectPromise(reason) {
	    reject(promise, reason);
	  }
	
	  try {
	    resolver(resolvePromise, rejectPromise);
	  } catch(e) {
	    rejectPromise(e);
	  }
	}
	
	function invokeCallback(subscriber){
	  var owner = subscriber.owner;
	  var settled = owner.state_;
	  var value = owner.data_;  
	  var callback = subscriber[settled];
	  var promise = subscriber.then;
	
	  if (typeof callback === 'function')
	  {
	    settled = FULFILLED;
	    try {
	      value = callback(value);
	    } catch(e) {
	      reject(promise, e);
	    }
	  }
	
	  if (!handleThenable(promise, value))
	  {
	    if (settled === FULFILLED)
	      resolve(promise, value);
	
	    if (settled === REJECTED)
	      reject(promise, value);
	  }
	}
	
	function handleThenable(promise, value) {
	  var resolved;
	
	  try {
	    if (promise === value)
	      throw new TypeError('A promises callback cannot return that same promise.');
	
	    if (value && (typeof value === 'function' || typeof value === 'object'))
	    {
	      var then = value.then;  // then should be retrived only once
	
	      if (typeof then === 'function')
	      {
	        then.call(value, function(val){
	          if (!resolved)
	          {
	            resolved = true;
	
	            if (value !== val)
	              resolve(promise, val);
	            else
	              fulfill(promise, val);
	          }
	        }, function(reason){
	          if (!resolved)
	          {
	            resolved = true;
	
	            reject(promise, reason);
	          }
	        });
	
	        return true;
	      }
	    }
	  } catch (e) {
	    if (!resolved)
	      reject(promise, e);
	
	    return true;
	  }
	
	  return false;
	}
	
	function resolve(promise, value){
	  if (promise === value || !handleThenable(promise, value))
	    fulfill(promise, value);
	}
	
	function fulfill(promise, value){
	  if (promise.state_ === PENDING)
	  {
	    promise.state_ = SEALED;
	    promise.data_ = value;
	
	    asyncCall(publishFulfillment, promise);
	  }
	}
	
	function reject(promise, reason){
	  if (promise.state_ === PENDING)
	  {
	    promise.state_ = SEALED;
	    promise.data_ = reason;
	
	    asyncCall(publishRejection, promise);
	  }
	}
	
	function publish(promise) {
	  var callbacks = promise.then_;
	  promise.then_ = undefined;
	
	  for (var i = 0; i < callbacks.length; i++) {
	    invokeCallback(callbacks[i]);
	  }
	}
	
	function publishFulfillment(promise){
	  promise.state_ = FULFILLED;
	  publish(promise);
	}
	
	function publishRejection(promise){
	  promise.state_ = REJECTED;
	  publish(promise);
	}
	
	/**
	* @class
	*/
	function Promise(resolver){
	  if (typeof resolver !== 'function')
	    throw new TypeError('Promise constructor takes a function argument');
	
	  if (this instanceof Promise === false)
	    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
	
	  this.then_ = [];
	
	  invokeResolver(resolver, this);
	}
	
	Promise.prototype = {
	  constructor: Promise,
	
	  state_: PENDING,
	  then_: null,
	  data_: undefined,
	
	  then: function(onFulfillment, onRejection){
	    var subscriber = {
	      owner: this,
	      then: new this.constructor(NOOP),
	      fulfilled: onFulfillment,
	      rejected: onRejection
	    };
	
	    if (this.state_ === FULFILLED || this.state_ === REJECTED)
	    {
	      // already resolved, call callback async
	      asyncCall(invokeCallback, subscriber);
	    }
	    else
	    {
	      // subscribe
	      this.then_.push(subscriber);
	    }
	
	    return subscriber.then;
	  },
	
	  'catch': function(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	Promise.all = function(promises){
	  var Class = this;
	
	  if (!isArray(promises))
	    throw new TypeError('You must pass an array to Promise.all().');
	
	  return new Class(function(resolve, reject){
	    var results = [];
	    var remaining = 0;
	
	    function resolver(index){
	      remaining++;
	      return function(value){
	        results[index] = value;
	        if (!--remaining)
	          resolve(results);
	      };
	    }
	
	    for (var i = 0, promise; i < promises.length; i++)
	    {
	      promise = promises[i];
	
	      if (promise && typeof promise.then === 'function')
	        promise.then(resolver(i), reject);
	      else
	        results[i] = promise;
	    }
	
	    if (!remaining)
	      resolve(results);
	  });
	};
	
	Promise.race = function(promises){
	  var Class = this;
	
	  if (!isArray(promises))
	    throw new TypeError('You must pass an array to Promise.race().');
	
	  return new Class(function(resolve, reject) {
	    for (var i = 0, promise; i < promises.length; i++)
	    {
	      promise = promises[i];
	
	      if (promise && typeof promise.then === 'function')
	        promise.then(resolve, reject);
	      else
	        resolve(promise);
	    }
	  });
	};
	
	Promise.resolve = function(value){
	  var Class = this;
	
	  if (value && typeof value === 'object' && value.constructor === Class)
	    return value;
	
	  return new Class(function(resolve){
	    resolve(value);
	  });
	};
	
	Promise.reject = function(reason){
	  var Class = this;
	
	  return new Class(function(resolve, reject){
	    reject(reason);
	  });
	};
	
	})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(6).setImmediate))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(7);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(8)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	// globals
	
	module.exports = {};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.flow = exports.GetInfoFlow = exports.STATUS_COMPLETED = exports.STATUS_MAYBE_READY = exports.STATUS_NOT_READY = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getNodeReadyStatus = getNodeReadyStatus;
	exports.getTrackLabel = getTrackLabel;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _docuploadsvc = __webpack_require__(68);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// data model of the required documents and we need items tree
	var STATUS_NOT_READY = exports.STATUS_NOT_READY = 0;
	var STATUS_MAYBE_READY = exports.STATUS_MAYBE_READY = 1;
	var STATUS_COMPLETED = exports.STATUS_COMPLETED = 2;
	
	function getNodeReadyStatus(node) {
	    if (Array.isArray(node)) {
	        return utils.reduceArray(node, function (status, n) {
	            return Math.max(getNodeReadyStatus(n), status);
	        }, STATUS_NOT_READY);
	    } else if (node.choices) {
	        return utils.reduceArray(node.choices, function (status, n) {
	            return Math.max(getNodeReadyStatus(n), status);
	        }, STATUS_NOT_READY);
	    } else if (node.widgetOption) {
	        return utils.reduceArray(node.widgetOption.document_types, function (status, dt) {
	            return Math.max(getDocOptionReadyStatus(node, dt), status);
	        }, STATUS_NOT_READY);
	    } else {
	        // null node.widgetOption
	        return STATUS_MAYBE_READY;
	    }
	}
	
	function getTrackLabel(node) {
	    if (!(node && node.widgetOption && node.code)) {
	        return '';
	    }
	    var ignores = ['a', 'the', 'please', 'provide', 'of', 'your', 'last'];
	    var simplifies = { 'months': 'M', 'month': 'M', 'year': 'Y', 'years': 'Y' };
	
	    var label = (0, _pexui._n)(node.widgetOption.content_id + '.name');
	    if (!label) {
	        label = (0, _pexui._n)(node.widgetOption.content_id + '.title');
	        label = label.replace(/^.*:\s*/, '').replace(/[\-\(\{].*$/, '').replace(/(\S+)\s*/g, function (_a, word) {
	            var lword = word.toLowerCase();
	            if (ignores.indexOf(lword) >= 0) {
	                return '';
	            } else if (simplifies.hasOwnProperty(lword)) {
	                return simplifies[lword];
	            } else {
	                return word;
	            }
	        });
	    }
	
	    if (label) {} else {
	        label = node.code;
	    }
	    return label;
	}
	
	function getDocOptionReadyStatus(node, dt) {
	    // docOpt = {document_option: 'Yodlee', document_type: '...'}
	    if (dt.document_option === 'Yodlee') {
	        return dt.done ? STATUS_COMPLETED : STATUS_NOT_READY;
	    } else if (dt.document_option === 'LinkedIn') {
	        return dt.done ? STATUS_COMPLETED : STATUS_MAYBE_READY;
	    } else if (dt.document_option === 'DocUpload') {
	        return getDocOptionReadyStatusDocUpload(node);
	    } else {
	        return STATUS_MAYBE_READY;
	    }
	}
	
	function getDocOptionReadyStatusDocUpload(node) {
	    var status = STATUS_NOT_READY;
	    for (var i = 0; i < node.files.length; i++) {
	        var file = node.files[i];
	        if (file.type !== 'info') {
	            if (file.completedTime) {
	                status = STATUS_MAYBE_READY;
	            } else {
	                status = STATUS_NOT_READY;
	                // one file not ready, all not ready
	                break;
	            }
	        }
	    }
	    return status;
	}
	
	function buildWeneedTree(tree, nodes, acct, level, key) {
	    if (tree.op === 'ITEM') {
	        nodes.push({
	            level: level,
	            done: false,
	            account: acct,
	            code: tree.data,
	            messages: [],
	            files: [],
	            key: key
	        });
	    } else if (tree.op === 'AND') {
	        tree.data.forEach(function (item, i) {
	            buildWeneedTree(item, nodes, acct, level, key + '' + i);
	        });
	    } else if (tree.op === 'OR') {
	        var choices = [];
	        tree.data.forEach(function (item, i) {
	            var choice = [];
	            buildWeneedTree(item, choice, acct, level + 1, key + '' + i);
	            choices.push(choice);
	        });
	        nodes.push({
	            level: level,
	            done: false,
	            account: acct,
	            choices: choices,
	            messages: [],
	            files: [],
	            key: key
	        });
	    }
	}
	
	// nodes of the we need items tree
	/*export class WorkFlowNode{
	    constructor(props){
	        this.level = props.level;
	        this.account = props.account;
	        this.code = props.code;
	        this.widgetOption = props.widgetOption;
	        this.choices = [];  // multiple choices node
	        this.messages = []; // messages to display
	        this.files = [];    // uploaded files {name: , time: }
	        this.done = false;
	    }
	}*/
	
	// work flow
	
	var GetInfoFlow = exports.GetInfoFlow = function () {
	    function GetInfoFlow() {
	        _classCallCheck(this, GetInfoFlow);
	
	        this.reset();
	    }
	
	    _createClass(GetInfoFlow, [{
	        key: 'reset',
	        value: function reset() {
	            this.config = null;
	            this.req = null;
	            this.widgetCallback = null;
	            this.documents = [];
	            this.widgetOptions = [];
	            this.allDocOptions = [];
	            this.currLevelNodes = [];
	            this.currNode;
	            this.allWeneedCodes = '';
	            this.docupld_token = null;
	            this.docUploadTids = {};
	            this.stack = []; // stack of the parent nodes of work flow, [{index:prev_index, nodes:prev_nodes}, {index:prev_prev_index, } ...]
	            this.nodes = []; // nodes of the we need items tree
	            this.lastNodeForYodlee = null;
	            this.lastError = '';
	            this.lastChannel = '';
	        }
	
	        /**
	         * @param {*} widget
	         * @return {Promise} a Promise
	         */
	
	    }, {
	        key: 'init',
	        value: function init(widget) {
	            var _this = this;
	
	            this.widget = widget;
	            this.config = widget.props.config;
	            this.widgetCallback = widget.props.widgetCallback;
	            var req = this.req = widget.props.req;
	            this.transaction_id = req.transaction_id;
	
	            this.documents = req.document_data.documents_requested;
	            this.docUploadTids = {};
	            this.widgetOptions = [];
	            this.allDocOptions = [];
	            this.currLevelNodes = [];
	            this.allWeneedCodes = '';
	            this.stack = []; // [{index:prev_index, nodes:prev_nodes}, {index:prev_prev_index, } ...]
	            this.nodes = [];
	
	            var flow = this;
	            var allWeneedCodes = [];
	            flow.doc_data = flow.req.document_data;
	
	            flow.documents.forEach(function (acct, i) {
	                utils.mergeArray(allWeneedCodes, utils.getAllWeneedCodes(acct.documents_requested_options_desc));
	                var tree = utils.parseWeneedCodes(acct.documents_requested_options_desc);
	                buildWeneedTree(tree, _this.nodes, acct, 1, i);
	            });
	
	            this.allWeneedCodes = allWeneedCodes = allWeneedCodes.join(',');
	
	            return _docuploadsvc.DocUploadService.createDocument(flow.config, flow.req).then(function (resp) {
	
	                var widgetOptions = resp.widget_options;
	                if (widgetOptions) {
	                    flow.widgetOptions = widgetOptions;
	
	                    flow.allDocOptions = [];
	                    flow.widgetOptions.forEach(function (widgetOption) {
	
	                        widgetOption.title = widgetOption.content_id + '.title';
	                        widgetOption.desc = widgetOption.content_id + '.desc';
	                        // convert to old data structure
	                        var docOptions = [];
	                        widgetOption.document_types.forEach(function (dt) {
	                            docOptions.push(dt.document_option);
	                            if (dt.document_option === 'DocUpload') {
	                                widgetOption.document_type = dt.document_type;
	                            }
	                        });
	                        widgetOption.docOptions = docOptions;
	                        //widgetOption.doc_options.split(/,/).map(s=>s.trim());
	
	                        //widgetOption.code
	                        utils.mergeArray(flow.allDocOptions, docOptions);
	                    });
	
	                    // set up data associations
	                    utils.goOverFlowNodes(flow.nodes, function (node) {
	                        node.widgetOption = utils.findArray(flow.widgetOptions, function (o) {
	                            return o.code === node.code;
	                        });
	                    });
	
	                    flow.currLevelNodes = flow.nodes;
	                    flow.currNodeIndex = flow.currLevelNodes.length > 0 ? 0 : -1;
	
	                    return resp;
	                } else {
	                    throw new Error('no widget_options');
	                }
	            });
	        }
	    }, {
	        key: 'getCurrentNode',
	        value: function getCurrentNode() {
	            if (!this.currNode) {
	                this.currNode = this.currLevelNodes[0];
	            }
	            return this.currNode;
	        }
	    }, {
	        key: 'getCurrentLevel',
	        value: function getCurrentLevel() {
	            return this.stack.length + 1;
	        }
	    }, {
	        key: 'getNodeIndex',
	        value: function getNodeIndex(node) {
	            for (var i = 0; i < this.currLevelNodes.length; i++) {
	                if (node === this.currLevelNodes[i]) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            var index = this.getNodeIndex(this.currNode);
	            if (index > 0) {
	                this.currNode = this.currLevelNodes[index - 1];
	            } else if (this.stack.length > 0) {
	                this.up();
	                this.prev(); // move to the next at the upper level
	            }
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            var index = this.getNodeIndex(this.currNode);
	            if (0 <= index && index < this.currLevelNodes.length - 1) {
	                this.currNode = this.currLevelNodes[index + 1];
	            } else if (this.stack.length > 0) {
	                this.up();
	                this.next(); // move to the next at the upper level
	            }
	        }
	    }, {
	        key: 'up',
	        value: function up() {
	            if (this.stack.length > 0) {
	                var prev = this.stack.shift();
	                this.currLevelNodes = prev.nodes;
	                this.currNode = this.currLevelNodes[prev.index];
	            }
	        }
	    }, {
	        key: 'down',
	        value: function down(index) {
	            var currNode = this.currNode;
	            if (currNode && currNode.choices && 0 <= index && index < currNode.choices.length) {
	                this.stack.unshift({
	                    index: this.getNodeIndex(currNode),
	                    nodes: this.currLevelNodes
	                });
	
	                this.currLevelNodes = currNode.choices[index];
	                this.currNode = this.currLevelNodes[0];
	            }
	        }
	    }, {
	        key: 'setCurrentNode',
	        value: function setCurrentNode(node) {
	            this.currNode = node;
	        }
	    }, {
	        key: 'addMessage',
	        value: function addMessage(text, errorKey) {
	            if (this.currNode) {
	                this.addNodeMessage(this.currNode, text, errorKey);
	            }
	        }
	    }, {
	        key: 'addMessageToCurrentNode',
	        value: function addMessageToCurrentNode(message) {
	            var messages = this.currNode.messages;
	
	
	            if (Array.isArray(messages)) {
	                messages.push('!' + message);
	            }
	        }
	    }, {
	        key: 'addNodeMessage',
	        value: function addNodeMessage(node, err, errorKey) {
	            var _utils$convertError = utils.convertError(err),
	                message = _utils$convertError.message,
	                derivedErrorKey = _utils$convertError.errorKey;
	
	            node.messages.push('!' + message);
	
	            (0, _track.trackError)(errorKey || derivedErrorKey);
	
	            // notify the invoker
	            this.raiseInvokerEvent("message", message);
	        }
	    }, {
	        key: 'raiseInvokerEvent',
	        value: function raiseInvokerEvent(eventName, eventValue, formattedYodleeMetadata) {
	            if (typeof this.widgetCallback === 'function') {
	                if (eventName === 'message') {
	                    return this.widgetCallback({
	                        event_name: eventName,
	                        event_value: eventValue,
	                        //error_code:  this.lastError,  //for later extension when error codes are defined.
	                        submission_channel_code: this.lastChannel,
	                        documents_requested_code: this.getCurrentNode() ? this.getCurrentNode().code : ''
	                    });
	                } else {
	                    var failEventBody = {};
	                    if (formattedYodleeMetadata) {
	                        failEventBody = {
	                            event_name: eventName,
	                            event_value: eventValue,
	                            yodlee_metadata: formattedYodleeMetadata
	                        };
	                    } else {
	                        failEventBody = {
	                            event_name: eventName,
	                            event_value: eventValue
	                        };
	                    }
	                    return this.widgetCallback(failEventBody);
	                }
	            }
	            return undefined;
	        }
	    }, {
	        key: 'getReadyStatus',
	        value: function getReadyStatus() {
	
	            // get the min value of ready status of all nodes
	            var readyStatuses = this.nodes.map(function (node) {
	                return getNodeReadyStatus(node);
	            });
	
	            var readyStatus = utils.reduceArray(readyStatuses, function (s2, s) {
	                return Math.min(s, s2);
	            }, STATUS_COMPLETED);
	            var hightestStatus = utils.reduceArray(readyStatuses, function (s2, s) {
	                return Math.max(s, s2);
	            }, STATUS_NOT_READY);
	
	            // Assuming multiple we need codes are additional, if some codes are provided, we consider it as STATUS_MAYBE_READY.
	            if (readyStatus === STATUS_NOT_READY && hightestStatus > STATUS_NOT_READY) {
	                readyStatus = STATUS_MAYBE_READY;
	            }
	            return readyStatus;
	        }
	    }, {
	        key: 'isYodleeOnly',
	        value: function isYodleeOnly() {
	            return this.nodes.length === 1 && this.nodes[0] && this.nodes[0].widgetOption && this.nodes[0].widgetOption.docOptions && this.nodes[0].widgetOption.docOptions.length === 1 && this.nodes[0].widgetOption.docOptions[0] === 'Yodlee';
	        }
	    }, {
	        key: 'isNovaOnly',
	        value: function isNovaOnly() {
	            return this.nodes.length === 1 && this.nodes[0] && this.nodes[0].widgetOption && this.nodes[0].widgetOption.docOptions && this.nodes[0].widgetOption.docOptions.length === 1 && this.nodes[0].widgetOption.docOptions[0] === 'Nova';
	        }
	    }]);
	
	    return GetInfoFlow;
	}();
	
	var flow = exports.flow = new GetInfoFlow();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeTagObject = exports.getQuestionNumber = exports.getIsDtm = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.initTrack = initTrack;
	exports.setTrackOpts = setTrackOpts;
	exports.createOMNObject = createOMNObject;
	exports.track = track;
	exports.trackError = trackError;
	exports.trackClick = trackClick;
	exports.trackExit = trackExit;
	exports.omnAction = omnAction;
	
	var _pexui = __webpack_require__(2);
	
	var _get = __webpack_require__(12);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _flow = __webpack_require__(10);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _dtm = __webpack_require__(64);
	
	var dtm = _interopRequireWildcard(_dtm);
	
	var _consts = __webpack_require__(65);
	
	var _errorTagging = __webpack_require__(66);
	
	var _successTagging = __webpack_require__(67);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trackMethod = '';
	var trackMarket = 'IN';
	var lastOmn = {};
	var initReq;
	
	function initTrack(config, req) {
	  trackMarket = req.market;
	  initReq = req;
	  updateTrackMethod();
	  _globals2.default.omnInvokerId = req.originator_id;
	}
	
	// postponed initialization (in eapply case, objects may be available after a while)
	var updateTrackMethod = function updateTrackMethod() {
	  if (!trackMethod) {
	    var _req = getReq();
	
	    if ((0, _get2.default)(_flow.flow, 'widgetConfig.analytics.analyticsClick')) {
	      return trackMethod = _consts.ONE_AMEX_DDL;
	    }
	    if ((0, _get2.default)(_flow.flow, 'widgetConfig.analytics_ddl_callback')) {
	      return trackMethod = _consts.ONE_APP_DDL_TRACKING;
	    }
	    if (_req.market === 'IN') {
	      return trackMethod = _consts.ITAG;
	    }
	    if (dtm.hasDtm() || _req.originator_id.indexOf('DXP') >= 0) {
	      return trackMethod = _consts.DTM;
	    }
	    if ((typeof s === 'undefined' ? 'undefined' : _typeof(s)) === 'object' && s) {
	      return trackMethod = _consts.ITAG;
	    }
	  }
	};
	
	function setTrackOpts(pagename, opts) {
	  lastOmn = makeTagObject(pagename, opts);
	}
	
	var getIsDtm = exports.getIsDtm = function getIsDtm() {
	  return trackMethod === _consts.DTM;
	};
	
	var getReq = function getReq() {
	  return _flow.flow.req || initReq;
	};
	
	var getQuestionNumber = exports.getQuestionNumber = function getQuestionNumber(node) {
	  return 'Q' + Math.max(_flow.flow.getNodeIndex(node) + 1, 1);
	};
	
	var getCapability = function getCapability() {
	  var options = _flow.flow.getCurrentNode().widgetOption.docOptions;
	  if (options.length > 1) {
	    return 'Options';
	  }
	  return options[0];
	};
	
	var getMultiSingle = function getMultiSingle(arr) {
	  return arr.length > 1 ? 'Multi' : 'Single';
	};
	
	var getCapabilityFlow = function getCapabilityFlow() {
	  return _flow.flow.currLevelNodes.map(function (node) {
	    return (0, _get2.default)(node, 'widgetOption.docOptions') ? node.widgetOption.docOptions.join('-') : 'NULL';
	  }).join(':');
	};
	
	var getPageName = function getPageName(event, currentPage) {
	  var pageNameBase = 'Widget:GI:' + getQuestionNumber(_flow.flow.getCurrentNode());
	  if (event === _consts.SUCCESSFUL_COMPLETED_JOURNEY_EVENT) {
	    return pageNameBase + ':' + getCapability() + ':' + currentPage;
	  }
	
	  if (currentPage) {
	    return pageNameBase + ':' + currentPage;
	  }
	
	  //successfully loaded page, accordion clicks
	  return pageNameBase + ':' + getCapability();
	};
	
	var getTools = function getTools(bankName, successStatus) {
	  var bankNameString = bankName ? ':BankName-' + bankName : '';
	  var questionsWithDetails = successStatus ? (0, _successTagging.mapSuccessKeyToTag)(successStatus) : _flow.flow.nodes.map(function (node) {
	    return getQuestionNumber(node) + '-' + (0, _flow.getTrackLabel)(node);
	  }).join(':');
	  return getMarket() + ':GI:' + questionsWithDetails + bankNameString;
	};
	
	var getProducts = function getProducts() {
	  return getMarket() + ':' + getBusinessUnit() + ':' + getPmc();
	};
	
	var getMarket = function getMarket() {
	  var products = (0, _get2.default)(window.s, 'products', '');
	
	  return products.split(':')[0] || '' + trackMarket;
	};
	
	var getBusinessUnit = function getBusinessUnit() {
	  var products = (0, _get2.default)(window.s, 'products', '');
	  var productsBusinessUnitCode = products.split(':')[1];
	  var documentDataBusinessUnitCode = getReq().document_data.business_unit_code;
	
	  return productsBusinessUnitCode || documentDataBusinessUnitCode;
	};
	
	var getPmc = function getPmc() {
	  var req = getReq();
	  var products = (0, _get2.default)(window.s, 'products', '');
	  var pmc = products.split(':')[2];
	
	  return pmc || req.originator_id;
	};
	
	var getFlowType = function getFlowType() {
	  var question = getMultiSingle(_flow.flow.widgetOptions);
	  var capability = getMultiSingle(_flow.flow.allDocOptions);
	
	  return question + 'Q-' + capability + 'C';
	};
	
	var getId = function getId() {
	  return getMarket() + ':GI:' + getBusinessUnit() + ':' + getFlowType() + ':' + getCapabilityFlow();
	};
	
	var getCurrencyCode = function getCurrencyCode() {
	  return (0, _get2.default)(window.s, 'currencyCode') || getMarket();
	};
	
	var getLocale = function getLocale() {
	  return (0, _get2.default)(_flow.flow, 'config.invoker_locale');
	};
	
	var getConversionStep = function getConversionStep(e) {
	  switch (e) {
	    case _consts.SUCCESSFUL_FIRST_LOAD_EVENT:
	      return 'selfservicestart';
	    case _consts.SUCCESSFUL_COMPLETED_JOURNEY_EVENT:
	      return 'selfservicecomplete';
	    default:
	      return '';
	  }
	};
	
	function createOMNObject(pagename) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var req = getReq();
	  var market = getMarket();
	  var pmc = getPmc() || req.originator_id;
	  var productID = (0, _get2.default)(window, 's.contextData["omn.productID"]', '');
	  var productIDParts = productID.split(':');
	
	  var invokerId = req.originator_id;
	  var events = opts.events;
	  var bankName = opts.bankName;
	  var customerType = 'Customer';
	
	  if (productIDParts.length >= 2) {
	    invokerId = productIDParts[1];
	  } else {
	    invokerId = 'ICSS';
	  }
	
	  _globals2.default.omnInvokerId = invokerId;
	
	  if (req.document_data.business_unit_code === 'OPEN') {
	    if (req.is_small_business) {
	      customerType = 'SBS';
	    } else {
	      customerType = 'Corporate';
	    }
	  }
	
	  var channelName = pagename.replace(/[\|\:].*$/, '').replace(/\s/g, '');
	  var tagScenario = getTagScenario(req.document_data && req.document_data.documents_requested && req.document_data.documents_requested[0].documents_requested_options_desc);
	
	  if (!_globals2.default.event51Sent) {
	    // widget start event
	    _globals2.default.initOmnProducts = ';' + market + ':' + customerType + ':' + pmc + ',;' + market + ':Widget:GI' + ',;' + market + ':Widget:GI:' + tagScenario;
	    _globals2.default.initOmnPagename = channelName;
	  } else {
	    if (opts.selfServiceStart) {
	      opts.noRepeat = true;
	    } else {
	      // Doc Upload Success / Capability Completion Page
	      var m = /(.+):Success$/.exec(pagename);
	      if (m) {
	        opts.noRepeat = true;
	      }
	    }
	  }
	  return {
	    pagename: getPageName(events, pagename),
	    hierarchy: (0, _pexui.getInitHierarchy)(),
	    events: events,
	    language: utils.getLanguage(_flow.flow.config ? _flow.flow.config.invoker_locale : 'en'),
	    newpagename: "yes",
	    pcnnumber: req && req.document_data ? req.document_data.process_control_number : '',
	    products: getProducts(),
	    tools: getTools(bankName),
	    widgetID: getId()
	  };
	}
	
	var createDTMObject = function createDTMObject(currentPage) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var noRepeat = opts.noRepeat,
	      selfServiceStart = opts.selfServiceStart,
	      events = opts.events,
	      successStatus = opts.successStatus,
	      bankName = opts.bankName;
	
	  var req = getReq();
	
	  return {
	    pagename: getPageName(events, currentPage),
	    hierarchy: dtm.getDtmHierarchy(getMarket()),
	    events: events,
	    language: utils.getLanguage(_flow.flow.config ? _flow.flow.config.invoker_locale : 'en'),
	    newpagename: "yes",
	    pcnnumber: req && req.document_data ? req.document_data.process_control_number : '',
	    products: getProducts(),
	    tools: getTools(bankName, successStatus),
	    id: getId()
	  };
	};
	
	var createOneAmexDDLObject = function createOneAmexDDLObject(currentPage) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var events = opts.events,
	      bankName = opts.bankName;
	
	  var req = getReq();
	
	  return {
	    element: 'track_journey_step',
	    meta: {
	      step: {
	        id: getPageName(events, currentPage)
	      },
	      conversionStep: getConversionStep(events),
	      journey: 'widgetapplication',
	      pcn: req && req.document_data ? req.document_data.process_control_number : '',
	      widgetID: getId(),
	      tools: getTools(bankName),
	      products: {
	        id: getPmc(),
	        description: 'GI Widget',
	        type: 'widget',
	        lineOfBusiness: getBusinessUnit(),
	        paymentType: 'lending',
	        currencyCode: getCurrencyCode(),
	        locale: getLocale()
	      }
	    }
	  };
	};
	
	var makeTagObject = exports.makeTagObject = function makeTagObject(pagename, opts) {
	  var updatedPageName = pagename.replace('AddFile', 'DocUpload');
	  //Ensure track method is set properly, some cases allow for delayed availability of tracking libraries
	  updateTrackMethod();
	  switch (trackMethod) {
	    case _consts.ONE_AMEX_DDL:
	    case _consts.ONE_APP_DDL_TRACKING:
	      return createOneAmexDDLObject(updatedPageName, opts);
	    case _consts.DTM:
	      return createDTMObject(updatedPageName, opts);
	    case _consts.ITAG:
	      return createOMNObject(updatedPageName, opts);
	    default:
	      return {};
	  }
	};
	
	function isRepeated(newOmn, opts) {
	  if (typeof _globals2.default.trackedPages === 'undefined') {
	    _globals2.default.trackedPages = {};
	  }
	  var trackedPages = _globals2.default.trackedPages;
	  var key = newOmn.pagename || (0, _get2.default)(newOmn, 'meta.step.id');
	  var hasBeenTracked = !!trackedPages[key];
	  trackedPages[key] = true;
	  // don't repeat for initialing pages
	  if (opts && opts.noRepeat) {
	    return hasBeenTracked;
	  }
	  return false;
	}
	
	function getTagScenario(weneedcodes) {
	  var useCaseId = (weneedcodes || '').replace(/[\(\)\s]/g, '').replace(/[\&\|]/g, '-');
	  return (0, _pexui._n)(useCaseId.toLowerCase() + '.tag_scenario') || useCaseId;
	}
	
	function track(pagename) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var newOmn = makeTagObject(pagename, opts);
	  if (!isRepeated(newOmn, opts)) {
	    lastOmn = (0, _pexui.extend)({}, newOmn); // save a copy
	
	    if (trackMethod === _consts.ITAG) {
	      (0, _pexui.omnitureTrack)(newOmn);
	    } else if (trackMethod === _consts.DTM) {
	      dtm.dtmTrack(newOmn, opts && opts.isAction ? "widgetAction" : "widgetView");
	    } else if (trackMethod === _consts.ONE_AMEX_DDL) {
	      var element = newOmn.element,
	          meta = newOmn.meta;
	
	
	      (0, _get2.default)(_flow.flow, 'widgetConfig.analytics.analyticsImpression')({
	        element: element,
	        meta: meta
	      });
	    } else if (trackMethod === _consts.ONE_APP_DDL_TRACKING) {
	      var _element = newOmn.element,
	          _meta = newOmn.meta;
	
	
	      (0, _get2.default)(_flow.flow, 'widgetConfig.analytics_ddl_callback')({
	        element: _element,
	        meta: _meta
	      });
	    } else {
	      console.log('Tried to track journey event ' + pagename + ', but no tracking library found');
	    }
	  }
	
	  if (opts.events === _consts.SUCCESSFUL_FIRST_LOAD_EVENT) {
	    _globals2.default.event51Sent = true;
	  }
	}
	
	function trackError(errorKey) {
	  var errorString = getMarket() + ':Widget:GI:Error:' + (0, _errorTagging.mapErrorKeyToErrorTag)(errorKey);
	
	  try {
	    if (trackMethod === _consts.ITAG && typeof omn_rmsiteerror === 'function') {
	      var savedOmn = window.omn;
	      // use the last tracked page as default
	      window.omn = (0, _pexui.extend)({}, savedOmn, lastOmn);
	      omn_rmsiteerror(errorString);
	
	      return window.omn = savedOmn;
	    }
	
	    if (trackMethod === _consts.DTM) {
	      return dtm.dtmTrack({
	        pagename: lastOmn ? lastOmn.pagename : 'Widget:GI:Error',
	        hierarchy: lastOmn ? lastOmn.hierarchy : getMarket() + "|AMEX|Widget|GI",
	        error: errorString
	      }, "widgetError");
	    }
	
	    if (trackMethod === _consts.ONE_AMEX_DDL) {
	      return (0, _get2.default)(_flow.flow, 'widgetConfig.analytics.analyticsImpression')({
	        element: 'Error',
	        detail: errorString
	      });
	    }
	
	    if (trackMethod === _consts.ONE_APP_DDL_TRACKING) {
	      return (0, _get2.default)(_flow.flow, 'widgetConfig.analytics_ddl_callback')({
	        element: 'Error',
	        detail: errorString
	      });
	    }
	
	    return console.log('Tried to track error ' + errorKey + ', but no tracking library found');
	  } catch (err) {
	    console.error(err);
	  }
	}
	
	function trackClick(eventName, vars) {
	  if (trackMethod === _consts.ITAG) {
	    return omnAction(lastOmn ? lastOmn.pagename : getMarket() + '|AMEX|Widget|GI', eventName, vars);
	  }
	
	  if (trackMethod === _consts.DTM || trackMethod === _consts.ITAG) {
	    eventName = eventName.replace(/^Click_/, '');
	
	    return dtm.dtmTrack({
	      pagename: lastOmn ? lastOmn.pagename : 'Error',
	      hierarchy: lastOmn ? lastOmn.hierarchy : getMarket() + "|AMEX|Widget|GI",
	      products: lastOmn ? lastOmn.products : _globals2.default.initOmnProducts,
	      pcnnumber: lastOmn ? lastOmn.pcnnumber : req && req.document_data ? req.document_data.process_control_number : '',
	      eventAction: "Click",
	      eventAsset: eventName
	    }, 'widgetAction');
	  }
	
	  if (trackMethod === _consts.ONE_AMEX_DDL) {
	    var newEventName = eventName.replace(/^Click_/, '');
	    return (0, _get2.default)(_flow.flow, 'widgetConfig.analytics.analyticsClick')({
	      element: newEventName,
	      detail: newEventName
	    });
	  }
	
	  if (trackMethod === _consts.ONE_APP_DDL_TRACKING) {
	    var _newEventName = eventName.replace(/^Click_/, '');
	    return (0, _get2.default)(_flow.flow, 'widgetConfig.analytics_ddl_callback')({
	      element: _newEventName,
	      detail: _newEventName
	    });
	  }
	
	  return console.log('Tried to track click event ' + eventName + ', but no tracking library found');
	}
	
	function trackExit() {
	  trackClick('YesExit');
	}
	
	function omnAction(arg1, arg2, vars) {
	  try {
	    if (typeof omn_rmaction === 'function') {
	      var savedOmn = window.omn;
	      // use the last tracked page as default
	      window.omn = (0, _pexui.extend)({}, savedOmn, lastOmn);
	
	      if ((typeof vars === 'undefined' ? 'undefined' : _typeof(vars)) === 'object' && vars) {
	        for (var k in vars) {
	          if (vars.hasOwnProperty(k)) {
	            omn_rmvar(k, vars[k]);
	          }
	        }
	      }
	
	      omn_rmaction(arg1, arg2);
	
	      window.omn = savedOmn;
	    }
	  } catch (err) {
	    console.error(err);
	  }
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(13);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(14),
	    toKey = __webpack_require__(63);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(15),
	    isKey = __webpack_require__(16),
	    stringToPath = __webpack_require__(25),
	    toString = __webpack_require__(60);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(15),
	    isSymbol = __webpack_require__(17);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(18),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19),
	    getRawTag = __webpack_require__(22),
	    objectToString = __webpack_require__(23);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(20);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(21);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(26);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(27);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(28);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(29),
	    mapCacheDelete = __webpack_require__(54),
	    mapCacheGet = __webpack_require__(57),
	    mapCacheHas = __webpack_require__(58),
	    mapCacheSet = __webpack_require__(59);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(30),
	    ListCache = __webpack_require__(45),
	    Map = __webpack_require__(53);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(31),
	    hashDelete = __webpack_require__(41),
	    hashGet = __webpack_require__(42),
	    hashHas = __webpack_require__(43),
	    hashSet = __webpack_require__(44);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(32);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(33);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(34),
	    getValue = __webpack_require__(40);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(35),
	    isMasked = __webpack_require__(37),
	    isObject = __webpack_require__(36),
	    toSource = __webpack_require__(39);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(18),
	    isObject = __webpack_require__(36);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(38);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(20);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(32);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(32);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(32);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(46),
	    listCacheDelete = __webpack_require__(47),
	    listCacheGet = __webpack_require__(50),
	    listCacheHas = __webpack_require__(51),
	    listCacheSet = __webpack_require__(52);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(49);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(33),
	    root = __webpack_require__(20);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(55);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(56);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(55);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(55);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(55);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(61);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19),
	    arrayMap = __webpack_require__(62),
	    isArray = __webpack_require__(15),
	    isSymbol = __webpack_require__(17);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(17);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasDtm = hasDtm;
	exports.dtmTrack = dtmTrack;
	exports.getDtmHierarchy = getDtmHierarchy;
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasDtm() {
	    return (typeof _satellite === 'undefined' ? 'undefined' : _typeof(_satellite)) === 'object' && typeof _satellite.track === 'function';
	}
	
	function dtmTrack(newOmn, trackType) {
	    if (hasDtm()) {
	        if (typeof digitalData === 'undefined') {
	            window.digitalData = {};
	        }
	
	        window.digitalData.widget = {
	            pageName: newOmn.pagename,
	            hierarchy: newOmn.hierarchy,
	            pcn: newOmn.pcnnumber,
	            events: newOmn.events || '',
	            products: newOmn.products,
	            tools: newOmn.tools,
	            eventAction: newOmn.eventAction || '',
	            eventAsset: newOmn.eventAsset || '',
	            error: newOmn.error,
	            id: newOmn.id
	        };
	
	        _satellite.track(trackType);
	        return true;
	    } else {
	        return false;
	    }
	}
	
	function getDtmHierarchy(market) {
	    var hierarchy = '';
	    try {
	        //As per suggestion from tagging team, getting the parent page hierarchy using digitalData from the tagging context.
	        if ((typeof _satellite === 'undefined' ? 'undefined' : _typeof(_satellite)) === 'object' && (typeof digitalData === 'undefined' ? 'undefined' : _typeof(digitalData)) === 'object' && digitalData && _typeof(digitalData.page) === 'object' && digitalData.page && _typeof(digitalData.page.category) === 'object' && digitalData.page.category && _typeof(digitalData.page.pageInfo) === 'object' && digitalData.page.pageInfo) {
	
	            var country = digitalData.page.pageInfo.country ? digitalData.page.pageInfo.country + "|" : "";
	            var businessUnit = digitalData.page.category.businessUnit ? digitalData.page.category.businessUnit + "|" : "";
	            var primaryCategory = digitalData.page.category.primaryCategory ? digitalData.page.category.primaryCategory + "|" : "";
	            var subCategory1 = digitalData.page.category.subCategory1 ? digitalData.page.category.subCategory1 + "|" : "";
	            var subCategory2 = digitalData.page.category.subCategory2 ? digitalData.page.category.subCategory2 + "|" : "";
	            var subCategory3 = digitalData.page.category.subCategory3 ? digitalData.page.category.subCategory3 : "";
	
	            hierarchy = '' + country + businessUnit + primaryCategory + subCategory1 + subCategory2 + subCategory3;
	
	            if (hierarchy.endsWith('|')) {
	                hierarchy = hierarchy.slice(0, hierarchy.length - 1);
	            }
	        }
	    } catch (err) {}
	
	    if (!hierarchy) {
	        hierarchy = market + '|AMEX|Widget|GI'; // default hierarchy
	    }
	    return hierarchy;
	}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ELEM_ID_WIDGET = exports.ELEM_ID_WIDGET = "widget_root";
	var CLASS_WIDGET = exports.CLASS_WIDGET = "infw-root";
	
	var SUCCESS_CODE = exports.SUCCESS_CODE = 0;
	var PARTIAL_SUCCESS_CODE = exports.PARTIAL_SUCCESS_CODE = 60210;
	
	var SUCCESSFUL_FIRST_LOAD_EVENT = exports.SUCCESSFUL_FIRST_LOAD_EVENT = 'event51';
	var SUCCESSFUL_COMPLETED_JOURNEY_EVENT = exports.SUCCESSFUL_COMPLETED_JOURNEY_EVENT = 'event14';
	
	var DTM = exports.DTM = 'DTM';
	var ITAG = exports.ITAG = 'ITAG';
	var ONE_AMEX_DDL = exports.ONE_AMEX_DDL = 'ONE_AMEX_DDL';
	var ONE_APP_DDL_TRACKING = exports.ONE_APP_DDL_TRACKING = 'ONE_APP_DDL_TRACKING';

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DOCUPLOAD_SYSTEM_ERROR = "Docupload:System Error";
	var DOCUPLOAD_UPLOAD_FAILURE = "Docupload:Upload Failure";
	var DOCUPLOAD_SUBMISSION_ERROR = "Docupload:Submission Error";
	var DOCUPLOAD_FILE_SIZE_ERROR = "Docupload:File Size Error";
	var YODLEE_FG_MATCH_ERROR = "Yodlee:TPDG API Failure";
	var YODLEE_FG_NAME_MATCH_ERROR = "Yodlee:TPDG API Failure:003:Name Match Criteria";
	var YODLEE_FG_FEW_TRANSACTIONS_ERROR = "Yodlee:TPDG API Failure:004:Not Enough Transactions";
	var YODLEE_FG_TRANSACTION_HISTORY_ERROR = "Yodlee:TPDG API Failure:005:No Trx Greater Than 30d";
	var YODLEE_FG_ACCOUNT_SUPPORT_ERROR = "Yodlee:TPDG API Failure:006:Non Supported Account Type";
	var YODLEE_FG_BETA_SITE_ERROR = "Yodlee:TPDG API Failure:007:Beta Site";
	var YODLEE_FG_PARTIAL_DATA_ERROR = "Yodlee:TPDG API Failure 008:Partial Data";
	var YODLEE_FG_NO_DATA_ERROR = "Yodlee:TPDG API Failure 009: No Data";
	var YODLEE_FG_ACCOUNT_INFO_ERROR = "TPDG API Failure 010: Acc Or Routing No Is NA Or Incorrect";
	
	var errorTagMap = {
	  "error.default.message": "Default Error",
	  "error.dialog.icon": "Icon Warning",
	  "error.service.message": "Service Error",
	  "Docupload.failed.message": DOCUPLOAD_UPLOAD_FAILURE,
	  "error.50100.message": DOCUPLOAD_SYSTEM_ERROR,
	  "error.50110.message": DOCUPLOAD_SYSTEM_ERROR,
	  "error.50130.message": "Docupload:Corrupt File Error",
	  "error.50200.message": DOCUPLOAD_SYSTEM_ERROR,
	  "error.50210.message": DOCUPLOAD_SYSTEM_ERROR,
	  "error.50220.message": DOCUPLOAD_SYSTEM_ERROR,
	  "error.50260.message": DOCUPLOAD_SUBMISSION_ERROR,
	  "error.50270.message": DOCUPLOAD_SUBMISSION_ERROR,
	  "error.50280.message": DOCUPLOAD_SYSTEM_ERROR,
	  "error.50300.message": DOCUPLOAD_FILE_SIZE_ERROR,
	  "error.50310.message": "Docupload:File Format Error",
	  "error.50320.message": DOCUPLOAD_FILE_SIZE_ERROR,
	  "error.50360.message": DOCUPLOAD_SUBMISSION_ERROR,
	  "error.60200.message": DOCUPLOAD_UPLOAD_FAILURE,
	  "error.60210.message": DOCUPLOAD_UPLOAD_FAILURE,
	  "error.60220.message": DOCUPLOAD_UPLOAD_FAILURE,
	  "error.60240.message": DOCUPLOAD_UPLOAD_FAILURE,
	  "error.duplicate.message": "Docupload:Same File Name Error",
	  "error.fileName.message": "Docupload:File Name Size Error",
	  "DocuSign.failed.message": "DocuSign:DocuSign Failed Error",
	  "error.901.message": "LinkedIn:Invalid State Token Error",
	  "error.911.message": "LinkedIn:Invalid Request Parameters Error",
	  "error.921.message": "LinkedIn:User Cancellation Error",
	  "error.931.message": "LinkedIn:Profile Id Error",
	  "error.951.message": "LinkedIn:Gateway Internal Error",
	  "LinkedIn.failed.message": "LinkedIn:Verification Failure",
	  "LinkedIn.unavailable.message": "LinkedIn:LinkedIn Unavailable",
	  "error.FG_failed.message": "Yodlee:FG Failure Error",
	  "Yodlee.failed.message": "Yodlee:Yodlee failure",
	  "yodlee.fg.match.error": YODLEE_FG_MATCH_ERROR,
	  "yodlee.fg.match.error.001": YODLEE_FG_MATCH_ERROR,
	  "yodlee.fg.match.error.002": YODLEE_FG_MATCH_ERROR,
	  "yodlee.fg.match.error.003": YODLEE_FG_NAME_MATCH_ERROR,
	  "yodlee.fg.match.error.004": YODLEE_FG_FEW_TRANSACTIONS_ERROR,
	  "yodlee.fg.match.error.005": YODLEE_FG_TRANSACTION_HISTORY_ERROR,
	  "yodlee.fg.match.error.006": YODLEE_FG_ACCOUNT_SUPPORT_ERROR,
	  "yodlee.fg.match.error.007": YODLEE_FG_BETA_SITE_ERROR,
	  "yodlee.fg.match.error.008": YODLEE_FG_PARTIAL_DATA_ERROR,
	  "yodlee.fg.match.error.009": YODLEE_FG_NO_DATA_ERROR,
	  "yodlee.fg.match.error.010": YODLEE_FG_ACCOUNT_INFO_ERROR,
	  "yodlee.fg.match.error.all.attempts": "Yodlee:FG All Attempts Failure",
	  "nova.UNSUPPORTED_COUNTRY": "Nova:Unsupported Country",
	  "nova.REQUEST_TIMEOUT": "Nova:Request Timeout",
	  "nova.BUREAU_UNRESPONSIVE": "Nova:Bureau Unresponsive",
	  "nova.UNKNOWN_CUSTOMER": "Nova:Unknown Customer",
	  "nova.INVALID_PRODUCT": "Nova:Invalid Product",
	  "nova.INTERNAL_ERROR": "Nova:Internal Error",
	  "nova.SCRIPT": "Nova:Script load failed"
	};
	
	var mapErrorKeyToErrorTag = exports.mapErrorKeyToErrorTag = function mapErrorKeyToErrorTag(errorKey) {
	  return errorTagMap[errorKey] || errorTagMap['error.default.message'];
	};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var successTagMap = {
	  "success.default.message": "Success",
	  "nova.NOT_FOUND": "NovaSuccess:Unable to retrieve",
	  "nova.NOT_AUTHENTICATED": "NovaSuccess:Unable to authenticate",
	  "nova.PENDING": "NovaSuccess:Pending"
	};
	
	var mapSuccessKeyToTag = exports.mapSuccessKeyToTag = function mapSuccessKeyToTag(errorKey) {
	  return successTagMap[errorKey] || successTagMap['success.default.message'];
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocUploadService = exports.checkResponseCode = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _lodash = __webpack_require__(69);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _secutil = __webpack_require__(71);
	
	var _consts = __webpack_require__(65);
	
	var consts = _interopRequireWildcard(_consts);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _flow = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// currency hashmap
	var currencyHashMap = {
	  US: 'USD'
	};
	
	// communication with backend
	var getDocuploadUri = function getDocuploadUri() {
	  var wconfig = _globals2.default.widgetConfig;
	  return wconfig && wconfig.widget_service_url || (0, _pexui.joinUrl)(utils.getBaseUri(), '/acquisition/digital/v1/info_collector');
	};
	
	// communication with backend
	var getDocuploadUriV2 = function getDocuploadUriV2() {
	  var wconfig = _globals2.default.widgetConfig;
	  return wconfig && wconfig.widget_service_url || (0, _pexui.joinUrl)(utils.getBaseUri(), '/acquisition/digital/v2/info_collector');
	};
	
	var getDocuploadUploadUrl = function getDocuploadUploadUrl() {
	  return (
	    // getDocuploadUri().replace('/acquisition/digital/v1/info_collector', '/v1/shared/services/application/upload')
	    (0, _pexui.joinUrl)(getDocuploadUri(), '/document_upload')
	  );
	};
	
	var encodeAllSpcChars = function encodeAllSpcChars(str) {
	  return str ? str.replace(/[\W]/g, function (c) {
	    var s = '00' + c.charCodeAt(0).toString(16);
	    return '%' + s.slice(-2);
	  }) : '';
	};
	
	var checkResponseCode = exports.checkResponseCode = function checkResponseCode(respObj) {
	  // Check for null response
	  if (respObj) {
	    if (!(respObj.hasOwnProperty('response_code') && (respObj.response_code === consts.SUCCESS_CODE || respObj.response_code === consts.PARTIAL_SUCCESS_CODE))) {
	      throw respObj;
	    }
	  }
	};
	
	var clearTidAndToken = function clearTidAndToken(respObj, code) {
	  // Check for null response
	  var respCode = (0, _lodash.get)(respObj, 'response_code');
	  var isAtLeastPartialSuccess = respCode === consts.SUCCESS_CODE || respCode === consts.PARTIAL_SUCCESS_CODE;
	
	  if (isAtLeastPartialSuccess) {
	    // Clear cached TID and token by setting to empty strings on succesful submit
	    _flow.flow.docUploadTids[code] = '';
	    _flow.flow.docupld_token = '';
	  }
	
	  checkResponseCode(respObj);
	};
	
	var updateTidAndToken = function updateTidAndToken(respObj, code) {
	  // Check for null response
	  if (respObj) {
	    // Set cached TID to the response TID if the response is successful
	    if (typeof respObj.response_code !== 'undefined' && respObj.response_code === consts.SUCCESS_CODE) {
	      if (respObj.docupld_tid) {
	        _flow.flow.docUploadTids[code] = respObj.docupld_tid;
	      }
	    }
	    // Set cached token to response token if it exists, otherwise set to empty string
	    _flow.flow.docupld_token = respObj.docupld_token || '';
	  }
	  checkResponseCode(respObj);
	};
	
	/**
	 * A common util to call REST service
	 * @param {string} path relative path of the service
	 * @param {object} headers additional request headers
	 * @param {object} reqObj the request object being encoded in JSON and sent in the body
	 * @param {object} opts optional arguments passed to ajax call.
	 * @return {object} Promise
	 */
	
	var callRest = function callRest(path, headers, reqObj, opts) {
	  reqObj = reqObj || {};
	  if (!reqObj.messageId && !reqObj.message_id) {
	    reqObj.message_id = utils.randomString(12);
	  }
	  headers = headers || {};
	  if (!headers.hasOwnProperty('Widget-Token')) {
	    headers['Widget-Token'] = (0, _secutil.generateSessionToken)();
	  }
	  headers['Content-Type'] = 'application/vnd.americanexpress.req-v1+json';
	  headers['Request-Tracker'] = (0, _secutil.getRequestTracker)(reqObj.message_id, _flow.flow.req.originator_id, _flow.flow.req.transaction_id);
	
	  var promise = utils.ajaxPromise((0, _pexui.extend)({
	    method: 'POST',
	    url: (0, _pexui.joinUrl)(getDocuploadUri(), path),
	    headers: headers,
	    data: JSON.stringify(reqObj)
	  }, opts)).then(function (resp) {
	    resp.obj = JSON.parse(resp.data);
	
	    if (reqObj.message_id && resp.obj.message_id !== reqObj.message_id || reqObj.messageId && resp.obj.messageId !== reqObj.messageId) {
	      throw new Error('request/response mismatch');
	    }
	    return resp;
	  });
	
	  return promise;
	};
	
	var callRestV2 = function callRestV2(path, headers, reqObj, opts) {
	  reqObj = reqObj || {};
	  if (!reqObj.messageId && !reqObj.message_id) {
	    reqObj.message_id = utils.randomString(12);
	  }
	  headers = headers || {};
	  if (!headers.hasOwnProperty('Widget-Token')) {
	    headers['Widget-Token'] = (0, _secutil.generateSessionToken)();
	  }
	  headers['Content-Type'] = 'application/vnd.americanexpress.req-v1+json';
	  headers['Request-Tracker'] = (0, _secutil.getRequestTracker)(reqObj.message_id, _flow.flow.req.originator_id, _flow.flow.req.transaction_id);
	
	  var promise = utils.ajaxPromise((0, _pexui.extend)({
	    method: 'POST',
	    url: (0, _pexui.joinUrl)(getDocuploadUriV2(), path),
	    headers: headers,
	    data: JSON.stringify(reqObj)
	  }, opts)).then(function (resp) {
	    return resp;
	  });
	
	  return promise;
	};
	
	var DocUploadService = exports.DocUploadService = {
	  /**
	     * Initialize widget session
	     * @return a Promise
	     */
	  createDocument: function createDocument(widgetConfig, widgetRequest) {
	    var widgetRequest2 = (0, _pexui.extend)({}, widgetRequest); // clone and modify the req before sending to service
	    var vaultKey = widgetRequest.vault_key || '';
	    // remove vault key data from front end
	    delete widgetRequest2.vault_key;
	    widgetRequest2.widget_config = widgetConfig;
	
	    return callRest('/documents', { 'Widget-Token': vaultKey }, {
	      widget_request: widgetRequest2
	    }).then(function (resp) {
	      checkResponseCode(resp.obj);
	
	      var widgetSessionKey = resp.obj.widget_session_key || resp.headers['Widget-Session-Key'];
	      (0, _secutil.beginWidgetSession)(widgetSessionKey);
	      // save the widget config from node side
	      _globals2.default.config = resp.obj.config || {};
	
	      return resp.obj;
	    });
	  },
	
	  /**
	     * @param {object} file the file to upload
	     * @param {object} formFields  {transactionId, weneedCode, originatorId, market}
	     * @return {object} Promise
	     */
	  upload: function upload(file, formFields, code) {
	    return utils.uploadPromise({
	      url: getDocuploadUploadUrl(),
	      file: file,
	      formFields: formFields,
	      headers: {
	        'Widget-Token': (0, _secutil.generateSessionToken)(),
	        'Request-Tracker': (0, _secutil.getRequestTracker)(formFields.message_id, _flow.flow.req.originator_id, _flow.flow.req.transaction_id),
	        'Personal-Info': formFields.personal_info
	      }
	    }).then(function (resp) {
	      resp.obj = JSON.parse(resp.data);
	
	      updateTidAndToken(resp.obj, code);
	      return resp;
	    });
	  },
	
	  /**
	     * Confirm an uploaded file to DMR (by Upload button)
	     * @param {object} reqObj
	     * @return {object} Promise
	     */
	  confirmUpload: function confirmUpload(reqObj, code) {
	    return callRest('/document_submit', null, reqObj).then(function (resp) {
	      clearTidAndToken(resp.obj, code);
	
	      return resp.obj;
	    });
	  },
	
	  /**
	     * Remove an attached file from DMR
	     * @param {object} reqObj
	     * @return {object} Promise
	     */
	  removeFile: function removeFile(reqObj, code) {
	    return callRest('/document_remove', null, reqObj).then(function (resp) {
	      updateTidAndToken(resp.obj, code);
	      return resp.obj;
	    });
	  },
	
	  /**
	     * Save Yodlee Terms and Condition when user accepts
	     * @param {string} transactionId
	     * @param {string} transactionId
	     * @param {string} pcn
	     * @param {string} tncType
	     * @param {string} tnc
	     * @param {boolean} accepted
	     * @return {object} a Promise
	     */
	  saveTnCAcceptance: function saveTnCAcceptance(transactionId, originatorId, pcn, tncType, tnc, accepted) {
	    return callRest('/documents/tnc_acceptance', null, {
	      transaction_id: transactionId,
	      originator_id: originatorId,
	      process_control_number: pcn,
	      tnc_type: tncType,
	      tnc_text: tnc,
	      accepted: accepted
	    }).then(function (resp) {
	      checkResponseCode(resp.obj);
	      return resp.obj;
	    });
	  },
	
	  /**
	     * Get Yodlee Attributes
	     * @param {object} req the widget request
	     * @return {object} Promise
	     */
	  getYodleeAttributes: function getYodleeAttributes(req) {
	    var reqObj = void 0;
	    if (req.is_single_sign_on || req.is_sso) {
	      reqObj = {
	        transaction_id: req.transaction_id,
	        originator_id: req.originator_id,
	        is_sso_flow: true,
	        market: req.market,
	        business_unit_code: req.document_data.business_unit_code,
	        account_number: req.account_number,
	        use_case: req.document_data.offer_details_code
	        // security_token & public_guid will be added by the node layer getting values from the SSO cookies.
	      };
	    } else {
	      reqObj = {
	        transaction_id: req.transaction_id,
	        originator_id: req.originator_id,
	        is_sso_flow: false,
	        market: req.market,
	        business_unit_code: req.document_data.business_unit_code,
	        personal_info: req.personal_info,
	        use_case: req.document_data.offer_details_code
	      };
	    }
	
	    return callRest('/yodlee_attributes', null, reqObj, { withCredentials: true }).then(function (resp) {
	      checkResponseCode(resp.obj);
	      var _resp$obj = resp.obj,
	          isRecurr = _resp$obj.is_recurr,
	          providerSpecifics = _resp$obj.provider_specifics,
	          responseMessage = _resp$obj.response_message,
	          encryptedYodleeAttribute = _resp$obj.encrypted_yodlee_attribute,
	          additionalYodleeParams = _resp$obj.additionalYodleeParams,
	          saml = _resp$obj.saml;
	
	
	      var yodleeAttributes = encryptedYodleeAttribute || saml;
	
	      if (!yodleeAttributes) {
	        throw new Error(responseMessage || 'yodlee error');
	      }
	
	      return { yodleeAttributes: yodleeAttributes, isRecurr: isRecurr, providerSpecifics: providerSpecifics, additionalYodleeParams: additionalYodleeParams };
	    });
	  },
	
	  /**
	     * Check Account Mismatch with FG
	     * @param {object} requestPayload
	     * @param {object} yodleeResponse
	     */
	  validateAccountDetails: function validateAccountDetails(yodleeResp, submitAttempts, isYsl) {
	    var isRecurr = _flow.flow.isRecurr,
	        req = _flow.flow.req;
	    var client_organization_id = req.client_organization_id,
	        document_data = req.document_data,
	        personal_info = req.personal_info,
	        account_number = req.account_number,
	        is_single_sign_on = req.is_single_sign_on,
	        originator_id = req.originator_id,
	        market = req.market,
	        transaction_id = req.transaction_id;
	    var businessCode = document_data.business_unit_code,
	        usecase_name = document_data.offer_details_code,
	        documentsRequested = document_data.documents_requested,
	        process_control_number = document_data.process_control_number;
	
	
	    var companyData = businessCode === 'OPEN' || businessCode === 'GCP' ? { company_name: documentsRequested[0].organization_name } : null;
	
	    var yslData = { guid: yodleeResp.GUID, sites: yodleeResp.sites };
	    var yodleeData = {
	      guid: yodleeResp.GUID,
	      segment_name: yodleeResp.Segment,
	      snapshot_required_indicator: yodleeResp.SNAPSHOT_REQUIRED,
	      yodlee_xref_id: yodleeResp.appID,
	      is_unregister: !isRecurr
	    };
	
	    var yodleeRequestData = isYsl ? yslData : yodleeData;
	
	    var requestObj = {
	      account_number: account_number,
	      account_business_unit_code: businessCode,
	      client_organization_id: client_organization_id,
	      company_data: companyData,
	      currency_code: currencyHashMap[market] || 'USD',
	      country_code: market,
	      is_single_sign_on: is_single_sign_on,
	      originator_id: originator_id,
	      personal_info: personal_info,
	      process_control_number: process_control_number,
	      submit_attempts: submitAttempts,
	      transaction_id: transaction_id,
	      usecase_name: usecase_name,
	      yodlee_data: yodleeRequestData,
	      is_recurr: isRecurr
	    };
	
	    // TODO - implement axios library instead of relying on pexui ajax function
	    // so we can handle node response object with appropriate code
	    return callRest('/details/validate', null, requestObj).then(function (res) {
	      return JSON.parse(res.data);
	    });
	  },
	
	  /**
	     * Save Yodlee Response
	     * @param {string} transactionId
	     * @param {object} yodleeResponse
	     * @return {object} Promise
	     */
	  saveYodleeResponse: function saveYodleeResponse(transactionId, yodleeResponse) {
	    return callRest('/documents/yodlee_response', null, {
	      transaction_id: transactionId,
	      yodlee_response: yodleeResponse
	    }).then(function (res) {
	      return res.obj;
	    }).catch(function (err) {
	      return console.log('Fail to save Yodlee response with the following error:', err);
	    });
	  },
	
	  /**
	     * Get DocuSign URL
	     * @param {Object} req widgetRequest
	     * @param {String} returnURL return URL
	     * @return {object} Promise
	     * resp object:
	     *   envelope_id
	     *   docusign_url
	     */
	  getDocuSignUrl: function getDocuSignUrl(req, returnURL) {
	    return callRest('/docusign/url', null, {
	      transaction_id: req.transaction_id,
	      originator_id: 'getinfowidget',
	      is_sso_flow: req.is_single_sign_on,
	      account_number: req.account_number,
	      is_small_business: req.is_small_business || false,
	      segment_name: req.segment_name || 'Retail',
	      snapshot_required: req.snapshot_required || false,
	      process_control_number: req.document_data.process_control_number,
	      return_url: returnURL
	    }, { withCredentials: true }).then(function (resp) {
	      checkResponseCode(resp.obj);
	      return resp.obj;
	    });
	  },
	
	  /**
	     * Get FG OptIn status
	     * @param {object} req the widget request
	     * @return {object} Promise
	     */
	  getOptInStatus: function getOptInStatus(req) {
	    return callRest('/optin/status', null, {
	      account_number: req.account_number,
	      country_code: req.market,
	      usecase_name: req.document_data.offer_details_code,
	      transaction_id: req.transaction_id
	    }).then(function (response) {
	      return response.obj;
	    }).catch(function (error) {
	      throw new Error('!' + utils.convertError(error).message);
	    });
	  },
	
	  /**
	      * Make log to server-side
	      * @param {object} req
	      */
	  log2Server: function log2Server(req) {
	    return callRestV2('/log', null, req).catch(function (error) {
	      console.log(error);
	    });
	  }
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(70)(module)))

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.beginWidgetSession = beginWidgetSession;
	exports.generateSessionToken = generateSessionToken;
	exports.hmacSha256 = hmacSha256;
	exports.getRequestTracker = getRequestTracker;
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _hmacSha = __webpack_require__(72);
	
	var _hmacSha2 = _interopRequireDefault(_hmacSha);
	
	var _encBase = __webpack_require__(76);
	
	var _encBase2 = _interopRequireDefault(_encBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function beginWidgetSession(widgetSessionKey) {
	    if (widgetSessionKey) {
	        var parts = widgetSessionKey.split(':');
	        if (parts.length === 3) {
	            _globals2.default.widgetSessionId = parts[0].trim();
	            _globals2.default.widgetSessionSecret = parts[1].trim();
	            var serverTimestamp = parts[2].trim();
	            _globals2.default.clockOffset = serverTimestamp ? parseInt(serverTimestamp) - new Date().getTime() : 0;
	        } else {
	            console.error('bad session key');
	        }
	    }
	} //
	// secutil.js
	//
	function generateSessionToken() {
	    if (_globals2.default.widgetSessionId && _globals2.default.widgetSessionSecret) {
	        var timestamp = String(new Date().getTime() + _globals2.default.clockOffset);
	        var payload = 'GET-INFO-WIDGET:' + timestamp;
	        var hash = hmacSha256(payload, _globals2.default.widgetSessionSecret);
	        var token = _globals2.default.widgetSessionId + ':' + timestamp + ':' + hash;
	        return token;
	    } else {
	        return '';
	    }
	}
	
	function hmacSha256(payload, key) {
	    var hash = (0, _hmacSha2.default)(payload, key);
	    var hashB64 = _encBase2.default.stringify(hash);
	    return hashB64;
	}
	
	function getRequestTracker(messageId, originatorId, transactionId) {
	    if (originatorId && transactionId) {
	        return originatorId + ':' + transactionId + ':' + messageId;
	    } else {
	        return '';
	    }
	}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(73), __webpack_require__(74), __webpack_require__(75));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha256", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		return CryptoJS.HmacSHA256;
	
	}));

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(73));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(73));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var C_algo = C.algo;
	
		    /**
		     * HMAC algorithm.
		     */
		    var HMAC = C_algo.HMAC = Base.extend({
		        /**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */
		        init: function (hasher, key) {
		            // Init hasher
		            hasher = this._hasher = new hasher.init();
	
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof key == 'string') {
		                key = Utf8.parse(key);
		            }
	
		            // Shortcuts
		            var hasherBlockSize = hasher.blockSize;
		            var hasherBlockSizeBytes = hasherBlockSize * 4;
	
		            // Allow arbitrary length keys
		            if (key.sigBytes > hasherBlockSizeBytes) {
		                key = hasher.finalize(key);
		            }
	
		            // Clamp excess bits
		            key.clamp();
	
		            // Clone key for inner and outer pads
		            var oKey = this._oKey = key.clone();
		            var iKey = this._iKey = key.clone();
	
		            // Shortcuts
		            var oKeyWords = oKey.words;
		            var iKeyWords = iKey.words;
	
		            // XOR keys with pad constants
		            for (var i = 0; i < hasherBlockSize; i++) {
		                oKeyWords[i] ^= 0x5c5c5c5c;
		                iKeyWords[i] ^= 0x36363636;
		            }
		            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */
		        reset: function () {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Reset
		            hasher.reset();
		            hasher.update(this._iKey);
		        },
	
		        /**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            this._hasher.update(messageUpdate);
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Compute HMAC
		            var innerHash = hasher.finalize(messageUpdate);
		            hasher.reset();
		            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
		            return hmac;
		        }
		    });
		}());
	
	
	}));

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(73));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InitPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _flow = __webpack_require__(10);
	
	var _themes = __webpack_require__(78);
	
	var _themes2 = _interopRequireDefault(_themes);
	
	var _track = __webpack_require__(11);
	
	var _docuploadsvc = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Promise = utils.Promise;
	
	var InitPage = exports.InitPage = function (_React$Component) {
	    _inherits(InitPage, _React$Component);
	
	    function InitPage(props) {
	        _classCallCheck(this, InitPage);
	
	        var _this = _possibleConstructorReturn(this, (InitPage.__proto__ || Object.getPrototypeOf(InitPage)).call(this, props));
	
	        _this.messages = [];
	        _this.state = {
	            messagesCount: 0
	        };
	        return _this;
	    }
	
	    _createClass(InitPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // All widget initialization are moved here, to be clearer
	            var widget = this.props.widget;
	            var widgetConfig = widget.props.config;
	            var widgetRequest = widget.props.req;
	            var widgetCallback = widget.props.widgetCallback;
	            // reset globals
	            _globals2.default.config = {};
	            _globals2.default.widgetConfig = widgetConfig;
	            _globals2.default.BASE_URI = '';
	            _globals2.default.htmlCache = {};
	            _globals2.default.widgetSessionId = '';
	            _globals2.default.widgetSessionSecret = '';
	            _globals2.default.sentOnloadEvent = false;
	
	            _flow.flow.widgetConfig = widgetConfig;
	            _flow.flow.req = widgetRequest;
	            _flow.flow.widgetCallback = widgetCallback;
	            var _flow$req = _flow.flow.req,
	                transaction_id = _flow$req.transaction_id,
	                originator_id = _flow$req.originator_id,
	                country_code = _flow$req.market,
	                documentData = _flow$req.document_data;
	            var process_control_number = documentData.process_control_number;
	
	            try {
	                (0, _track.initTrack)(widgetConfig, widgetRequest);
	                //Initialization tasks in parallel
	                //Initialize themes
	                var themesInitialization = (0, _themes2.default)(widgetConfig, widgetRequest);
	                //Initialize the workflow (data model)
	                var flowInitialization = _flow.flow.init(widget);
	
	                var allTasks = Promise.all([themesInitialization, flowInitialization]);
	
	                allTasks.then(function () {
	                    // The Nova flow skips all "landing" pages
	                    // and begins the Nova invocation immediately
	                    if (_flow.flow.isNovaOnly()) {
	                        widget.nav("nova");
	                    } else {
	                        // initialization is done, navigate to the IndexPage
	                        widget.nav("index");
	                    }
	                }).catch(function (promiseError) {
	                    var logData = {
	                        transaction_id: transaction_id,
	                        originator_id: originator_id,
	                        country_code: country_code,
	                        process_control_number: process_control_number,
	                        log_type: 'ERROR',
	                        log_message: 'Widget load exception: Failed to complete background processes: ' + promiseError
	                    };
	                    _docuploadsvc.DocUploadService.log2Server(logData);
	                    (0, _track.track)('Start:Error');
	
	                    var _utils$convertError = utils.convertError(promiseError),
	                        message = _utils$convertError.message,
	                        errorKey = _utils$convertError.errorKey;
	
	                    (0, _track.trackError)(errorKey);
	                    _this2.showError('Fail to initialize the documents: ' + message);
	                    _flow.flow.raiseInvokerEvent('fail', message);
	                });
	            } catch (loadError) {
	                var logData = {
	                    transaction_id: transaction_id,
	                    originator_id: originator_id,
	                    country_code: country_code,
	                    process_control_number: process_control_number,
	                    log_type: 'ERROR',
	                    log_message: 'Widget load exception: ' + loadError
	                };
	                _docuploadsvc.DocUploadService.log2Server(logData);
	                (0, _track.track)('Start:Error');
	
	                var _utils$convertError2 = utils.convertError(loadError),
	                    message = _utils$convertError2.message,
	                    errorKey = _utils$convertError2.errorKey;
	
	                (0, _track.trackError)(errorKey);
	                this.showError('Fail to initialize: ' + message);
	                _flow.flow.raiseInvokerEvent('fail', message);
	            }
	        }
	    }, {
	        key: 'showError',
	        value: function showError(err) {
	            if (err) {
	                var messages = this.messages;
	                messages.push(err);
	                this.setState({ messagesCount: messages.length });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var hasErrors = false;
	            var errors = this.messages.map(function (message) {
	                hasErrors = true;
	                return _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-error' },
	                    '' + message
	                );
	            });
	            var iconStyle = hasErrors ? { left: '50%' } : { left: '50%', 'margin-left': '-25px' };
	
	            return _pexui.React.createElement(
	                'div',
	                { className: 'infw-page px-widget' },
	                _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-message' },
	                    'Loading...'
	                ),
	                errors,
	                _pexui.React.createElement(
	                    'div',
	                    { style: { width: '100%', 'margin-top': '20px' } },
	                    _pexui.React.createElement('div', { className: hasErrors ? "dls-icon-warning-filled dls-accent-red-01" : "progress-circle progress-indeterminate",
	                        style: iconStyle })
	                )
	            );
	        }
	    }]);
	
	    return InitPage;
	}(_pexui.React.Component);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _default = __webpack_require__(79);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _dxp_dumas = __webpack_require__(80);
	
	var _dxp_dumas2 = _interopRequireDefault(_dxp_dumas);
	
	var _dxp_acq = __webpack_require__(81);
	
	var _dxp_acq2 = _interopRequireDefault(_dxp_acq);
	
	var _intl_eapply = __webpack_require__(82);
	
	var _intl_eapply2 = _interopRequireDefault(_intl_eapply);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Promise = utils.Promise;
	
	var hostedLocales = {
	    // Supports old convention for setting locale
	    'US': 'en_US',
	    'en': 'en_US',
	    'es': 'es_US',
	    'fr': 'fr_CA',
	    'IN': 'en_IN',
	    'jp': 'jp_JP',
	    'JP': 'jp_JP',
	    // Supports new convention
	    'en_UK': 'en_UK',
	    'en_US': 'en_US',
	    'es_US': 'es_US',
	    'fr_CA': 'fr_CA',
	    'en_IN': 'en_IN',
	    'jp_JP': 'jp_JP',
	    'zh_CN': 'zh_CN'
	};
	
	var customTheme = null;
	
	function setTheme(theme) {
	    (0, _pexui.addStylesMapper)(theme);
	
	    customTheme = theme;
	}
	
	function decideThemes(widgetConfig, widgetRequest) {
	    var originatorId = widgetRequest.originator_id;
	
	    // do with default
	    (0, _pexui.addStylesMapper)(_default2.default);
	
	    // --------- theme rules ------------
	    switch (originatorId.toUpperCase()) {
	        case 'DXP_DUMAS':
	            setTheme(_dxp_dumas2.default);
	            break;
	        case 'DXP_ACQUISITION':
	            setTheme(_dxp_acq2.default);
	            break;
	        case 'INTL_EAPPLY':
	            setTheme(_intl_eapply2.default);
	            break;
	    }
	
	    // ----------------------------------
	}
	
	// initTheme
	module.exports = function (widgetConfig, widgetRequest) {
	    decideThemes(widgetConfig, widgetRequest);
	
	    if (widgetConfig.invoker_style_url && (_typeof(widgetConfig.invoker_style_url) === 'object' || typeof widgetConfig.invoker_style_url === 'function')) {
	        (0, _pexui.addStylesMapper)(widgetConfig.invoker_style_url);
	        widgetConfig.invoker_style_url = null; // clean the parameter in order to pass the server-side validation.
	    }
	
	    var urlCss = widgetConfig.invoker_style_url && typeof widgetConfig.invoker_style_url === 'string' ? widgetConfig.invoker_style_url : widgetConfig.invoker_style_url === true ? 'none' : (0, _pexui.joinUrl)((0, _pexui.joinIfAbsent)(utils.getBaseUri(), 'infowidget'), 'styles/dls-widget.min.css');
	
	    if (urlCss && urlCss !== 'true' && urlCss !== 'none' && urlCss !== 'provided') {
	        (0, _pexui.insertStylesheetLink)(urlCss);
	    }
	
	    //
	    if (urlCss && urlCss !== 'true' && urlCss !== 'none') {
	        (0, _pexui.insertStylesheetLink)((0, _pexui.joinUrl)((0, _pexui.joinIfAbsent)(utils.getBaseUri(), 'infowidget'), 'styles/pex_getinfo_widget.css'));
	    }
	
	    // do with textual props
	    (0, _pexui.resetLocales)();
	
	    var locale = 'default';
	    var invokerLocale = widgetConfig.invoker_locale;
	
	    if (invokerLocale && hostedLocales[invokerLocale]) {
	        locale = invokerLocale;
	    }
	
	    var internalJsonMandatory = true;
	    if (widgetConfig.invoker_prop_url) {
	        (0, _pexui.setCustomTextProps)(widgetConfig.invoker_prop_url);
	
	        if (_typeof(widgetConfig.invoker_prop_url) === 'object' || typeof widgetConfig.invoker_prop_url === 'function') {
	            widgetConfig.invoker_prop_url = null; // clean the parameter in order to pass the server-side validation.
	        }
	        // once the invoker provides a customized resource, the internal one is not mandatory.
	        internalJsonMandatory = false;
	    } else if (customTheme && customTheme.labels && customTheme.labels[locale]) {
	        (0, _pexui.setCustomTextProps)(customTheme.labels[locale]);
	    }
	    var resourceUrl = (0, _pexui.joinUrl)((0, _pexui.joinIfAbsent)(utils.getBaseUri(), 'infowidget'), 'locales/json/' + locale + '.json?' + Date.now());
	    return new Promise(function (resolve, reject) {
	        (0, _pexui.setCurrentLocale)(resourceUrl, function () {
	            resolve();
	        }, function (error) {
	            reject(Error('Failed to download default content from Url: ' + resourceUrl + ', error: ' + error));
	        });
	    });
	};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    'infw-root': 'px-widget',
	    'infw-page': 'dls-accent-white-01-bg',
	    'infw-caption-bar': 'row dls-accent-blue-02-bg dls-accent-white-01 pad-1-tb flex-align-center',
	    'infw-caption-bar-inner': 'col-xs-10 col-md-10 col-lg-10 text-align-center',
	    'infw-caption-text': 'heading-4 margin-0-b',
	    'infw-message': 'col-md-12 margin-0-b text-align-center heading-3',
	
	    'infw-message-wrapper': 'row margin',
	    'infw-content': 'pad-1-t',
	    'infw-content-container': 'row',
	
	    'infw-footer': 'row pad margin-b',
	    'infw-footer-help': '',
	    'infw-footer-buttons': 'text-align-center',
	    'infw-btn-desc': 'body-2 margin-lr-sm-up pad-2',
	
	    // overlay & dialogs
	    'infw-modal-wrapper': 'px-widget',
	    'infw-modal-overlay': '',
	    'infw-dialog-frame': 'dls-accent-white-01-bg container-fluid text-align-center',
	    'infw-dialog-title-bar': 'row dls-accent-white-01-bg dls-accent-blue-02 flex-align-center',
	    'infw-dialog-title': 'col-md-10 col-md-offset-1 modal-title infw-dialog-title-font',
	    'infw-dialog-body': 'card-body',
	    'infw-dialog-icons': 'text-align-center',
	    'infw-dialog-subtitle': 'heading-4',
	    'infw-dialog-text': 'body-1',
	    'infw-dialog-question': 'margin-0-b font-weight-bold',
	    'infw-dialog-btn-box': 'card-foot pad-0-t row',
	    'infw-dialog-btn-desc': 'infw-small-desc-13',
	
	    'infw-small-desc': 'infw-small-desc-13',
	    'infw-paragraph-padding': 'pad-1-b body-1',
	    'infw-padding-30': 'pad-3',
	    'infw-font-bold': 'font-weight-bold',
	    'infw-pad-left': 'pad-1-2',
	    "infw-section-desc": "body-1 text-align-left pad-tb",
	
	    // buttons
	    'infw-btn-primary': 'btn btn-block btn-block-center btn-primary',
	    'infw-btn-secondary': 'btn btn-block btn-block-center btn-secondary',
	    'infw-btn-primary-small': 'btn btn-primary btn-block-center btn-sm',
	    'infw-btn-secondary-small': 'btn btn-secondary btn-block-center btn-sm',
	
	    // icons
	    'infw-icon-back-holder': 'col-xs-1 col-md-1 col-lg-1',
	    'infw-icon-close-holder': 'col-xs-1 col-md-1 col-lg-1',
	
	    'infw-icon-close': 'dls-icon-close icon-sm icon-hover',
	    'infw-icon-right': 'dls-glyph-right',
	    'infw-icon-left': 'dls-icon-left icon-sm',
	    'infw-icon-down': 'dls-icon-down icon-sm',
	    'infw-icon-warning': 'dls-icon-warning-filled dls-accent-red-01',
	    'infw-icon-info': 'dls-icon-info dls-accent-blue-02',
	    'infw-icon-check': 'dls-icon-check icon-sm dls-rewards-green-02',
	    'infw-icon-success': 'dls-icon-success icon-sm pad-1-lr dls-rewards-green-02 font-weight-medium',
	    'infw-icon-error': 'dls-icon-warning icon-sm pad-1-lr dls-accent-red-01 font-weight-medium',
	    'infw-icon-remove': 'dls-icon-cancel-circle pad-1-lr icon-sm',
	
	    // yodlee
	    'infw-yodlee-how-section': '',
	    'infw-yodlee-how-container1': '',
	    'infw-yodlee-how-container2': 'container pad-2-tb',
	    'infw-yodlee-how-container3': 'text-align-center',
	    'infw-list-text-rws': 'pad-1 heading-3 dls-core-blue-01',
	    'infw-yodlee-how-subtitle': 'body-3',
	    'infw-yodlee-how-icons-area': 'infw-with-2-icons',
	    'infw-yodlee-tnc-box': 'infw-tnc-box',
	    'infw-yodlee-tnc-links': 'text-align-center',
	    'infw-yodlee-tnc-confirm-container1': 'card-body',
	    'infw-yodlee-tnc-confirm-container2': 'infw-hbox',
	    'infw-yodlee-tnc-confirm-container-chk': '',
	    'infw-yodlee-tnc-confirm-container-label': 'infw-small-desc',
	    'infw-checkbox': 'infw-dls-checkbox margin-1-r',
	
	    'infw-panel-content': 'flex-align-center border-dark-t pad dls-accent-gray-01-bg',
	    'infw-link': '',
	    'infw-link-help': '',
	
	    'infw-single-box': 'single-box',
	    'infw-accordion-header': 'collapsible flex-align-center text-align-left dls-accent-white-01-bg',
	    'infw-accordion-content': 'accordion-content',
	    'infw-accordion-border': 'accordion border-tb open',
	
	    // LinkedIn
	    'infw-linkedin-page': 'card',
	    'infw-linkedin-how-container': 'container',
	    'infw-linkedin-how-title': 'infw-align-center heading-3 margin-2-tb',
	    'infw-linkedin-how-section': 'infw-hbox infw-grey-border margin-1-b',
	    'infw-linkedin-how-icons-area': 'infw-align-center dls-accent-gray-01-bg',
	    'infw-linkedin-how-icon': 'icon-md dls-accent-blue-02',
	    'infw-linkedin-how-text-area': 'ls-accent-white-01-bg text-align-left pad-1',
	    'infw-linkedin-how-text': 'heading-3 margin-1-tb',
	    'infw-linkedin-how-desc': 'body-3',
	    'infw-linkedin-tnc-box': 'infw-tnc-box',
	    'infw-linkedin-tnc-links': 'pad-2-lr text-align-right',
	    'infw-linkedin-tnc-confirm-box': 'infw-hbox pad-2-lr',
	    'infw-linkedin-tnc-confirm-chk': 'infw-checkbox',
	    'infw-linkedin-tnc-confirm-label': 'infw-small-desc',
	
	    // FAQ
	    'infw-faq-page': 'px-widget',
	    'infw-faq-content': 'dls-accent-gray-02-bg pad-1',
	    'infw-faq-title': 'heading-4 pad-1 dls-accent-white-01-bg',
	    'infw-faq-item': 'text-align-left dls-accent-white-01-bg pad-1-t',
	    'infw-faq-question': 'a margin-1',
	    'infw-faq-answer': 'body-1 margin-1',
	    'infw-faq-seeall': 'dls-accent-white-01-bg pad-1 margin-1-t'
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    styles: {
	        'infw-footer': 'row pad custom-footer'
	    },
	
	    labels: {
	        en: {},
	        es: {}
	    }
	};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    styles: {
	        // keep compatibility of old DOM
	        'infw-yodlee-how-container1': 'container text-align-center',
	        'infw-yodlee-how-container2': 'card-body pad-3-lr printable',
	        'infw-yodlee-how-container3': 'pad-2 printable',
	        'infw-yodlee-how-subtitle': 'body-1 margin-0-b text-xs-center printable',
	        'infw-yodlee-how-answer': 'infw-list-text-rws pad-1 heading-3 dls-core-blue-01',
	        'infw-yodlee-how-section': '',
	        'infw-list-text-rws': 'pad-1 heading-3 dls-core-blue-01 printable',
	
	        'infw-yodlee-tnc-confirm-container1': 'card-body',
	        'infw-yodlee-tnc-confirm-container2': 'row',
	        'infw-yodlee-tnc-confirm-container-chk': 'col-xs-1',
	        'infw-yodlee-tnc-confirm-container-label': 'infw-small-desc col-xs-11 pad-1-lr',
	        'infw-yodlee-tnc-links': 'card-body pad-3-lr text-align-center',
	
	        'infw-checkbox': '',
	        'dummy': ''
	    },
	
	    labels: {
	        en_US: {
	            "widget.message": "We need additional information from you.",
	            "yodlee.home.how": "<div>How It Works</div><div class=\"pad-1-t heading-3 dls-core-blue-01\" style=\"font-size:1.2em;\">We work with a third party provider to get an overview of your recent finances without having to pull your credit report again.</div>"
	        },
	        es_US: {}
	    }
	};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    styles: {
	        'infw-yodlee-how-icons-area': 'infw-with-2-icons',
	        'infw-yodlee-how-badge': '',
	        'infw-dialog-body': 'infw-hbox',
	        'infw-dialog-icons': '',
	        'infw-dialog-text': 'body-1 text-align-left',
	
	        'infw-yodlee-how-container3': '',
	        'infw-yodlee-how-subtitle': 'infw-font-bs margin-0-b text-align-left',
	        // keep compatibility of old DOM
	        'infw-yodlee-how-container1': 'container text-align-center',
	        'infw-yodlee-how-container2': 'card-body pad-3-lr printable',
	        'infw-yodlee-how-section': '',
	        'infw-list-text-rws': 'pad-1 heading-3 dls-core-blue-01 printable',
	        'infw-list-item': 'tnc-list-item',
	
	        'infw-yodlee-tnc-confirm-container1': 'card-body',
	        'infw-yodlee-tnc-confirm-container2': 'row',
	        'infw-yodlee-tnc-confirm-container-chk': 'col-xs-1',
	        'infw-yodlee-tnc-confirm-container-label': 'infw-small-desc infw-small-desc-13 col-xs-11 pad-1-lr',
	        'infw-yodlee-tnc-links': 'card-body pad-3-lr text-align-center',
	        'infw-checkbox': '',
	        'dummy': ''
	    },
	
	    labels: {
	        en: {},
	        es: {}
	    }
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.IndexPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _base = __webpack_require__(84);
	
	var _uicomps = __webpack_require__(85);
	
	var _files = __webpack_require__(97);
	
	var _flow = __webpack_require__(10);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _choice = __webpack_require__(98);
	
	var _section = __webpack_require__(99);
	
	var _track = __webpack_require__(11);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPanelTitle = function getPanelTitle(node) {
	    var value = '';
	    if (node.choices) {
	        value = (0, _pexui._n)('choice_title');
	    } else if (node.widgetOption) {
	        value = (0, _pexui._n)(node.widgetOption.content_id + '.title', { business_name: node.account.organization_name });
	    }
	    return value;
	};
	
	var nodeName = function nodeName(node) {
	    if (node && _typeof(node.account) === 'object') {
	        return (node.account.organization_id || '') + '/' + (node.account.organization_name || '') + '/' + (node.code || '') + '/' + (node.key || '');
	    } else {
	        return ''; // show nothing
	    }
	};
	
	var IndexPage = exports.IndexPage = function (_BasePage) {
	    _inherits(IndexPage, _BasePage);
	
	    function IndexPage(props) {
	        _classCallCheck(this, IndexPage);
	
	        var _this = _possibleConstructorReturn(this, (IndexPage.__proto__ || Object.getPrototypeOf(IndexPage)).call(this, props));
	
	        _this.state = { level: _flow.flow.getCurrentLevel() };
	        return _this;
	    }
	
	    _createClass(IndexPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!_globals2.default.sentOnloadEvent) {
	                _flow.flow.raiseInvokerEvent('loaded', undefined);
	                _globals2.default.sentOnloadEvent = true;
	            }
	        }
	    }, {
	        key: 'hasBackButton',
	        value: function hasBackButton() {
	            return _flow.flow.getCurrentLevel() > 1;
	        }
	    }, {
	        key: 'onBack',
	        value: function onBack() {
	            _flow.flow.up();
	            this.setState({ level: _flow.flow.getCurrentLevel() });
	        }
	    }, {
	        key: 'getSection',
	        value: function getSection(node) {
	            if (node.choices) {
	                return _pexui.React.createElement(_choice.ChoiceSection, { page: this, flow: _flow.flow, node: node,
	                    className: 'infw-panel-content' });
	            } else {
	                return _pexui.React.createElement(_section.RequiredDocSection, { page: this, flow: _flow.flow, node: node,
	                    className: 'infw-panel-content' });
	            }
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            var _this2 = this;
	
	            // if only 1 choices, show the ChoiceSection without an Accordion
	            if (_flow.flow.currLevelNodes.length === 1) {
	                var currentNode = _flow.flow.currLevelNodes[0];
	                var contentsComp = _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-single-box' },
	                    _pexui.React.createElement(
	                        'div',
	                        { className: 'infw-accordion-header' },
	                        getPanelTitle(currentNode)
	                    ),
	                    this.getSection(currentNode)
	                );
	            } else {
	                var panels = _flow.flow.currLevelNodes.map(function (node) {
	                    return _pexui.React.createElement(_pexui.AccordionPanel, { name: nodeName(node),
	                        title: getPanelTitle(node),
	                        renderExpanded: function renderExpanded() {
	                            return _this2.getSection(node);
	                        },
	                        renderCollapsed: node.choices ? false : function () {
	                            return _pexui.React.createElement(_files.FilesList, { node: node, withRemove: false, withComment: false });
	                        }
	                    });
	                });
	                var contentsComp = _pexui.React.createElement(
	                    _pexui.Accordion,
	                    {
	                        widget: this.props.widget,
	                        active: nodeName(_flow.flow.getCurrentNode()),
	                        style: { width: "100%" },
	                        onSelect: function onSelect(panelName) {
	                            var currNode = utils.findArray(_flow.flow.currLevelNodes, function (node) {
	                                return nodeName(node) === panelName;
	                            });
	                            _flow.flow.setCurrentNode(currNode);
	                            (0, _track.track)('', {
	                                contentName: (0, _flow.getTrackLabel)(currNode),
	                                selfServiceStart: true
	                            });
	                        }
	                    },
	                    panels
	                );
	            }
	
	            return [_pexui.React.createElement(
	                'div',
	                { className: 'infw-message-wrapper' },
	                _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-message' },
	                    utils.getHtml((0, _pexui._n)("widget.message"))
	                )
	            ), contentsComp];
	        }
	    }]);
	
	    return IndexPage;
	}(_base.BasePage);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BasePage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _uicomps = __webpack_require__(85);
	
	var _dialog = __webpack_require__(88);
	
	var _flow = __webpack_require__(10);
	
	var _header = __webpack_require__(90);
	
	var _footer = __webpack_require__(91);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasePage = exports.BasePage = function (_React$Component) {
	    _inherits(BasePage, _React$Component);
	
	    function BasePage(props) {
	        _classCallCheck(this, BasePage);
	
	        return _possibleConstructorReturn(this, (BasePage.__proto__ || Object.getPrototypeOf(BasePage)).call(this, props));
	    }
	
	    _createClass(BasePage, [{
	        key: 'hasHeader',
	        value: function hasHeader() {
	            return this.props.widget.props.displayMode.indexOf('CAPTION') >= 0;
	        }
	    }, {
	        key: 'hasFooter',
	        value: function hasFooter() {
	            return true;
	        }
	    }, {
	        key: 'getTitle',
	        value: function getTitle() {
	            return (0, _pexui._n)("widget.title");
	        }
	    }, {
	        key: 'hasBackButton',
	        value: function hasBackButton() {
	            return false;
	        }
	    }, {
	        key: 'hasHelp',
	        value: function hasHelp() {
	            return true;
	        }
	    }, {
	        key: 'onBack',
	        value: function onBack() {}
	    }, {
	        key: 'getFooterButtons',
	        value: function getFooterButtons() {
	            var _this2 = this;
	
	            var buttons = [];
	
	            if (this.hasBackButton() && !this.hasHeader()) {
	                buttons.push({ id: 'infw_btn_back',
	                    label: (0, _pexui._n)('footer.back'),
	                    isPrimary: false,
	                    onClick: function onClick(evt) {
	                        return _this2.onBack();
	                    }
	                });
	            }
	
	            var yodleeOnly = _flow.flow.isYodleeOnly();
	            var readyStatus = _flow.flow.getReadyStatus();
	            var cancelDisabled = readyStatus > _flow.STATUS_MAYBE_READY;
	            var submitDisabled = readyStatus < _flow.STATUS_MAYBE_READY;
	            if (yodleeOnly) {
	                if (readyStatus === _flow.STATUS_COMPLETED) {
	                    buttons.push({ id: 'infw_btn_submit',
	                        className: 'infw-btn-primary',
	                        label: (0, _pexui._n)('footer.submit'),
	                        isPrimary: true,
	                        onClick: function onClick(evt) {
	                            return _this2.props.widget.onSubmit();
	                        }
	                    });
	                } else {
	                    buttons.push({ id: 'infw_btn_cancel',
	                        className: 'infw-btn-secondary',
	                        label: (0, _pexui._n)('yodlee.home.button_cancel') || (0, _pexui._n)('yodlee.tnc.button_cancel'),
	                        isPrimary: false,
	                        onClick: function onClick(evt) {
	                            return _this2.props.widget.onClose();
	                        }
	                    });
	                }
	            } else {
	                buttons.push({ id: 'infw_btn_cancel',
	                    label: (0, _pexui._n)('footer.cancel'),
	                    isPrimary: false,
	                    disabled: cancelDisabled,
	                    onClick: function onClick(evt) {
	                        return _this2.props.widget.onClose();
	                    }
	                });
	
	                buttons.push({ id: 'infw_btn_submit',
	                    label: (0, _pexui._n)('footer.submit'),
	                    isPrimary: true,
	                    disabled: submitDisabled,
	                    onClick: function onClick(evt) {
	                        return _this2.props.widget.onSubmit();
	                    }
	                });
	            }
	            return buttons;
	        }
	
	        // A sub class should overload this method to render the contents
	
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            return '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var page = this;
	
	            return _pexui.React.createElement(
	                'div',
	                { id: _dialog.ELEM_ID_CONTENT, className: 'infw-page' },
	                _pexui.React.createElement(_header.PageHeader, {
	                    visible: this.hasHeader(),
	                    title: this.getTitle(),
	                    onBack: this.hasBackButton() ? this.onBack.bind(this) : null,
	                    onClose: this.props.onClose
	                }),
	                _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-content' },
	                    this.renderContent()
	                ),
	                _pexui.React.createElement(_footer.PageFooter, {
	                    visible: this.hasFooter(),
	                    buttons: this.getFooterButtons(),
	                    hasHelp: this.hasHelp()
	                })
	            );
	        }
	    }]);
	
	    return BasePage;
	}(_pexui.React.Component);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RemoveButton = exports.Link = exports.RadioButon = exports.Button = exports.NavButton = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _busy = __webpack_require__(86);
	
	var NavButton = exports.NavButton = function NavButton(_ref) {
	    var id = _ref.id,
	        className = _ref.className,
	        style = _ref.style,
	        label = _ref.label,
	        onClick = _ref.onClick;
	    return _pexui.React.createElement(
	        'div',
	        { id: id,
	            className: className || "infw-btn-secondary",
	            style: style,
	            onClick: onClick },
	        label,
	        _pexui.React.createElement('span', { className: 'infw-icon-right',
	            style: { float: "right" } })
	    );
	};
	
	var Button = exports.Button = function Button(_ref2) {
	    var id = _ref2.id,
	        className = _ref2.className,
	        style = _ref2.style,
	        label = _ref2.label,
	        name = _ref2.name,
	        activeWhenBusy = _ref2.activeWhenBusy,
	        busyZone = _ref2.busyZone,
	        disabled = _ref2.disabled,
	        onClick = _ref2.onClick;
	
	    var theButton = _pexui.React.createElement(
	        'button',
	        {
	            id: id,
	            className: className || "infw-btn-secodary",
	            style: style,
	            name: name,
	            disabled: disabled,
	            'data-activeWhenBusy': activeWhenBusy // used by busy blocking
	            , 'data-busyZone': busyZone,
	            onClick: busyZone ? function (evt) {
	                (0, _busy.startBusy)(theButton);
	
	                if (typeof onClick === 'function') {
	                    onClick(evt);
	                }
	            } : onClick
	        },
	        label
	    );
	    return theButton;
	};
	
	var RadioButon = exports.RadioButon = function RadioButon(_ref3) {
	    var id = _ref3.id,
	        className = _ref3.className,
	        style = _ref3.style,
	        label = _ref3.label,
	        name = _ref3.name,
	        value = _ref3.value,
	        checked = _ref3.checked,
	        onClick = _ref3.onClick;
	    return _pexui.React.createElement(
	        'div',
	        { className: className, style: style },
	        _pexui.React.createElement('input', { id: id,
	            type: 'radio',
	            name: name,
	            value: value,
	            checked: checked || undefined,
	            onClick: onClick
	        }),
	        _pexui.React.createElement(
	            'span',
	            null,
	            label
	        )
	    );
	};
	
	var Link = exports.Link = function Link(_ref4) {
	    var id = _ref4.id,
	        className = _ref4.className,
	        style = _ref4.style,
	        label = _ref4.label,
	        icon = _ref4.icon,
	        activeWhenBusy = _ref4.activeWhenBusy,
	        busyZone = _ref4.busyZone,
	        _onClick = _ref4.onClick;
	
	    var theLink = _pexui.React.createElement(
	        'a',
	        {
	            id: id,
	            className: className,
	            style: style,
	            'data-activeWhenBusy': activeWhenBusy // used by busy blocking
	            , 'data-busyZone': busyZone,
	            onClick: function onClick(evt) {
	                evt.preventDefault();
	                if (busyZone) {
	                    (0, _busy.startBusy)(theLink);
	                }
	                if (typeof _onClick === 'function') {
	                    _onClick(evt);
	                }
	            } },
	        icon ? _pexui.React.createElement('span', { className: icon }) : '',
	        label
	    );
	    return theLink;
	};
	
	var RemoveButton = exports.RemoveButton = function RemoveButton(_ref5) {
	    var label = _ref5.label,
	        icon = _ref5.icon,
	        busyZone = _ref5.busyZone,
	        _onClick2 = _ref5.onClick;
	
	    var theRemoveButton = _pexui.React.createElement(
	        'div',
	        {
	            style: 'cursor:pointer;color:#1274b8',
	            'data-busyZone': busyZone,
	            tabIndex: 0,
	            onKeyDown: function onKeyDown(evt) {
	                if (evt.keyCode === 32) {
	                    evt.preventDefault();
	                    if (busyZone) {
	                        (0, _busy.startBusy)(theRemoveButton);
	                    }
	                    if (typeof _onClick2 === 'function') {
	                        _onClick2(evt);
	                    }
	                }
	            },
	            onClick: function onClick(evt) {
	                evt.preventDefault();
	                if (busyZone) {
	                    (0, _busy.startBusy)(theRemoveButton);
	                }
	                if (typeof _onClick2 === 'function') {
	                    _onClick2(evt);
	                }
	            } },
	        icon ? _pexui.React.createElement('span', { className: icon }) : '',
	        label
	    );
	    return theRemoveButton;
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.startBusy = startBusy;
	exports.stopBusy = stopBusy;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _consts = __webpack_require__(65);
	
	var consts = _interopRequireWildcard(_consts);
	
	var _spinner = __webpack_require__(87);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function cancelClickEvent(evt) {
	    if (evt.stopPropagation) {
	        evt.stopPropagation();
	    } else {
	        evt.cancelBubble = true; //IE
	    }
	}
	
	function startBusy(elemOrId) {
	    var busyZone = 'widget';
	    if (elemOrId) {
	        var elem = utils.getElement(elemOrId);
	        if (elem) {
	            (0, _spinner.showSpinner)(elem, { mode: 'embedded' });
	
	            busyZone = elem.getAttribute('data-busyZone');
	        }
	    }
	    var elemZone = findZoneElement(busyZone);
	
	    if (elemZone) {
	        elemZone.addEventListener('click', cancelClickEvent, true); // swallowing the event in capturing phase can effectly disable it.
	
	        goOverInputs(elemZone, function (elemInZone) {
	            var activeWhenBusy = elemInZone.getAttribute('data-activeWhenBusy');
	            var preDisabled = elemInZone.getAttribute('data-preDisabled');
	            if (!preDisabled && !(activeWhenBusy && (activeWhenBusy === '*' || activeWhenBusy === 'true' || activeWhenBusy === busyZone))) {
	
	                elemInZone.setAttribute('data-preDisabled', elemInZone.disabled ? 'true' : 'false');
	                elemInZone.disabled = true;
	            }
	        });
	    }
	}
	
	function stopBusy(elemOrId) {
	    var busyZone = 'widget';
	    if (elemOrId) {
	        var elem = utils.getElement(elemOrId);
	        if (elem) {
	            (0, _spinner.hideSpinner)(elem);
	            busyZone = elem.getAttribute('data-busyZone');
	        }
	    }
	    var elemZone = findZoneElement(busyZone);
	
	    if (elemZone) {
	        elemZone.removeEventListener('click', cancelClickEvent, true);
	
	        goOverInputs(elemZone, function (elemInZone) {
	            var savedText = elemInZone.getAttribute('data-text');
	            if (savedText) {
	                (0, _spinner.hideSpinner)(elemInZone);
	            }
	
	            var preDisabled = elemInZone.getAttribute('data-preDisabled');
	            if (preDisabled) {
	                elemInZone.disabled = preDisabled === 'true';
	                elemInZone.removeAttribute('data-preDisabled');
	            } else if (elemInZone.disabled) {
	                elemInZone.disabled = false;
	            }
	        });
	    }
	}
	
	function findZoneElement(zone) {
	    var elemZone = null;
	    if (!zone || zone === '*' || zone === 'widget') {
	        elemZone = document.getElementById(consts.ELEM_ID_WIDGET);
	    } else if (zone === 'page' || zone === 'body') {
	        elemZone = document.body;
	    } else {
	        elemZone = document.getElementById(zone);
	    }
	    return elemZone;
	}
	
	function goOverInputs(elemZone, cb) {
	    var elems = elemZone.getElementsByTagName('button');
	    for (var i = 0; i < elems.length; i++) {
	        cb(elems.item(i));
	    }
	    elems = elemZone.getElementsByTagName('a');
	    for (var _i = 0; _i < elems.length; _i++) {
	        cb(elems.item(_i));
	    }
	    elems = elemZone.getElementsByTagName('input');
	    for (var _i2 = 0; _i2 < elems.length; _i2++) {
	        var e = elems.item(_i2);
	        if (e.getAttribute('type') !== 'file' && e.getAttribute('type') !== 'hidden') {
	            cb(e);
	        }
	    }
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.spinnerStyles = undefined;
	exports.showSpinner = showSpinner;
	exports.hideSpinner = hideSpinner;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	function showSpinner(elem, opts) {
	    var element = (0, _utils.getElement)(elem);
	    if (opts.mode === 'overlay') {
	        return showOverlaySpinner(element, opts);
	    } else if (opts.mode === 'embedded') {
	        showEmbeddedSpinner(element, opts);
	    }
	}
	
	function hideSpinner(elemSpinner) {
	    var element = (0, _utils.getElement)(elemSpinner);
	    var savedText = element.getAttribute('data-text');
	    if (savedText) {
	        element.disabled = false;
	        element.innerText = savedText;
	        element.removeAttribute('data-text');
	    } else {
	        element.style.display = "none";
	    }
	}
	
	function showOverlaySpinner(elem, opts) {
	    var width = 50;
	    var height = 50;
	    var left = (elem.offsetWidth - width) / 2 + (opts.xOffset || 0);
	    var top = (elem.offsetHeight - height) / 2 + (opts.yOffset || 0);
	
	    var div = document.createElement('div');
	    var style = 'position: relative; z-index:99999; left:' + left + 'px; top:' + top + 'px; width:' + width + 'px; height:' + height + 'px;background-color:#fff';
	    div.setAttribute('style', style);
	    div.setAttribute('class', 'px-widget');
	
	    _pexui.ReactDOM.render(_pexui.React.createElement('div', { className: 'progress-circle progress-indeterminate dls-accent-white-01-bg' }), div);
	    elem.parentElement.insertBefore(div, elem);
	
	    return div;
	}
	
	function showEmbeddedSpinner(element) {
	    var height = element.style.height;
	    element.setAttribute('data-text', element.innerText);
	    element.innerHTML = '<div class="progress-circle progress-indeterminate progress-sm"></div>';
	    element.style.height = height; // keep the old size
	}
	
	var spinnerStyles = exports.spinnerStyles = "#spinner {display: -webkit-inline-box;display: -ms-inline-flexbox;display: inline-flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center;position: relative;width: 100%;height: 100vh;-webkit-transition: none;transition: none;}#spinner:before{position: absolute;left:50%;display: block;content: '';border-style: solid;border-color: rgba(204, 204, 204, 0.25);border-left-color: #1274b8;-webkit-transform: translateZ(0);transform: translateZ(0);border-radius: 50%;width: 50px;height: 50px;border-width: 4px;will-change: transform;-webkit-animation: spinner-indeterminate 0.8s linear infinite;animation: spinner-indeterminate 0.8s linear infinite;}@-webkit-keyframes spinner-indeterminate {0% {-webkit-transform: rotate(0deg);transform: rotate(0deg);}100% {-webkit-transform: rotate(360deg);transform: rotate(360deg);}}@keyframes spinner-indeterminate {0% {-webkit-transform: rotate(0deg);transform: rotate(0deg);}100% {-webkit-transform: rotate(360deg);transform: rotate(360deg);}}";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ErrorDialog = exports.MessageDialog = exports.ExitYodleeDialog = exports.ExitConfirmDialog = exports.ConfirmDialog = exports.SubmitDialog = exports.Dialog = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.showModalPromise = showModalPromise;
	exports.messageBox = messageBox;
	exports.showError = showError;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _uicomps = __webpack_require__(85);
	
	var _html = __webpack_require__(89);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Promise = utils.Promise;
	
	function showModalPromise(comp, level) {
	    return new Promise(function (resolve, reject) {
	        var oldOnClose = comp.props.onClose;
	        comp.props.onClose = function (val) {
	            if (typeof oldOnClose === 'function') {
	                oldOnClose(val);
	            }
	
	            resolve(val);
	        };
	
	        (0, _pexui.showModal)(comp, level);
	    }); // triggering the promise
	}
	
	/**
	 * props:{
	 *   id:    elem_id,
	 *   className: styles class,
	 *   style: style object,
	 *   title: string,
	 *   closeAction: string (the choice string to send back),
	 *   onClose: a callback of function (choice)
	 *   message: string,
	 *   buttons: [{
	 *      label: 'OK',
	 *      isPrimary: true/false,
	 *      value: 'ok'
	 *   }]
	 * }
	 */
	
	var Dialog = exports.Dialog = function (_React$Component) {
	    _inherits(Dialog, _React$Component);
	
	    function Dialog(props) {
	        _classCallCheck(this, Dialog);
	
	        props.onClose = props.onClose || props.onSelect; // compatible to old interface
	        props.className = props.className || "infw-dialog-frame";
	        props.style = props.style || {};
	
	        if (props.width) {
	            var buttons = props.buttons || [];
	            var maxLabelLen = utils.reduceArray(buttons, function (maxlen, button) {
	                return Math.max((button.label || '').length, maxlen);
	            }, 0);
	            if (maxLabelLen > 10) {
	                props.width += 50;
	            }
	
	            props.style.width = props.width + 'px';
	        }
	        if (props.height) {
	            props.style.height = props.height + 'px';
	        }
	
	        var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));
	
	        _this.value = null;
	        _this.level = _this.props.level || _pexui.LEVEL_DIALOG;
	        return _this;
	    }
	
	    _createClass(Dialog, [{
	        key: 'show',
	        value: function show() {
	            return showModalPromise(this, this.level);
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            (0, _pexui.hideModal)(this.level);
	
	            if (typeof this.props.onClose === 'function') {
	                this.props.onClose(this.value);
	            }
	        }
	    }, {
	        key: 'onButtonClick',
	        value: function onButtonClick(value) {
	            this.value = value;
	            this.closeDialog();
	        }
	    }, {
	        key: 'renderCaption',
	        value: function renderCaption() {
	            var _this2 = this;
	
	            var captionBarCloseButton = this.props.closeAction ? _pexui.React.createElement(
	                'div',
	                { className: 'infw-icon-close-holder' },
	                _pexui.React.createElement('span', { id: 'infw_icon_dlg_close',
	                    className: 'infw-icon-close',
	                    onClick: function onClick() {
	                        return _this2.onButtonClick(_this2.props.closeAction);
	                    }
	                })
	            ) : '';
	
	            //style={{ 'font-family':'BentonSans', color: '#002663','font-size': '1.5rem'}}
	            if (this.props.title || this.props.closeAction) {
	                return _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-dialog-title-bar' },
	                    _pexui.React.createElement(
	                        'div',
	                        { className: 'infw-dialog-title' },
	                        this.props.title || ' '
	                    ),
	                    captionBarCloseButton
	                );
	            } else {
	                return '';
	            }
	        }
	    }, {
	        key: 'renderBody',
	        value: function renderBody() {
	            var content = [];
	            if (this.props.icon) {
	                content.push(_pexui.React.createElement(
	                    'div',
	                    { className: 'infw-dialog-icons', id: 'infw-dialog-icons' },
	                    _pexui.React.createElement('span', { className: this.props.icon })
	                ));
	            }
	
	            if (this.props.subTitle) {
	                content.push(_pexui.React.createElement(_html.Html, { className: 'infw-dialog-subtitle', id: 'infw-dialog-subtitle', content: this.props.subTitle }));
	            }
	
	            if (this.props.message) {
	                content.push(_pexui.React.createElement(_html.Html, { className: 'infw-dialog-text', id: 'infw-dialog-text', content: this.props.message }));
	            }
	
	            return _pexui.React.createElement(
	                'div',
	                { className: 'infw-dialog-body', role: 'dialog', 'aria-labelledby': 'infw-dialog-subtitle infw-dialog-text infw-dialog-icons' },
	                content
	            );
	        }
	    }, {
	        key: 'renderButtons',
	        value: function renderButtons() {
	            var _this3 = this;
	
	            var buttons = this.props.buttons || [];
	            var maxLabelLen = utils.reduceArray(buttons, function (maxlen, button) {
	                return Math.max((button.label || '').length, maxlen);
	            }, 0);
	            var smallButton = maxLabelLen < 10;
	            var buttonLayout = void 0;
	            var className = "infw-dialog-btn-box";
	            if (buttons.length > 1 && !buttons[0].isPrimary && buttons[1].isPrimary) {
	                className = className + ' infw-sm-reverse';
	            }
	
	            if (maxLabelLen < 18) {
	                buttonLayout = buttons ? buttons.length === 1 ? 'col-md-4 col-md-offset-4' : 'col-md-4 col-md-offset-1' : '';
	            } else {
	                buttonLayout = buttons ? buttons.length === 1 ? 'col-md-8 col-md-offset-2' : 'col-md-6' : '';
	            }
	            var buttonComps = buttons.map(function (button) {
	                //buttonComps.push(<div className="col-md-1"/>);
	                return _pexui.React.createElement(
	                    'div',
	                    { className: buttonLayout, 'aria-labelledby': button.id },
	                    _pexui.React.createElement(_uicomps.Button, {
	                        id: button.id,
	                        className: button.isPrimary ? smallButton ? 'infw-btn-primary-small' : 'infw-btn-primary' : smallButton ? 'infw-btn-secondary-small' : 'infw-btn-secondary',
	                        onClick: function onClick() {
	                            return _this3.onButtonClick(button.value);
	                        },
	                        label: button.label }),
	                    _pexui.React.createElement(_html.Html, { className: 'infw-dialog-btn-desc', content: button.desc, hideEmpty: true })
	                );
	            });
	
	            return _pexui.React.createElement(
	                'div',
	                { className: className },
	                buttonComps
	            );
	        }
	    }, {
	        key: 'renderFooter',
	        value: function renderFooter() {
	            return '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _pexui.React.createElement(
	                'div',
	                { id: this.props.id,
	                    className: this.props.className, 'aria-modal': true, role: 'dialog'
	                },
	                this.renderCaption(),
	                this.renderBody(),
	                this.renderButtons(),
	                this.renderFooter()
	            );
	        }
	    }]);
	
	    return Dialog;
	}(_pexui.React.Component);
	
	;
	
	var SubmitDialog = exports.SubmitDialog = function (_Dialog) {
	    _inherits(SubmitDialog, _Dialog);
	
	    function SubmitDialog(props) {
	        _classCallCheck(this, SubmitDialog);
	
	        return _possibleConstructorReturn(this, (SubmitDialog.__proto__ || Object.getPrototypeOf(SubmitDialog)).call(this, (0, _pexui.extend)({
	            role: "dialog",
	            aria: {
	                labelledby: 'infw_dialog_submit',
	                modal: true
	            },
	            id: 'infw_dialog_submit',
	            width: 600,
	            height: 220,
	            message: (0, _pexui._n)('submit.message'),
	            icon: (0, _pexui._n)('submit.dialog.icon'),
	            buttons: [{ id: 'infw_btn_dlg_no', label: (0, _pexui._n)('submit.no.label'), isPrimary: false, value: 'no', desc: (0, _pexui._n)('submit.no.desc') }, { id: 'infw_btn_dlg_yes', label: (0, _pexui._n)('submit.yes.label'), isPrimary: true, value: 'yes', desc: (0, _pexui._n)('submit.yes.desc') }] }, props)));
	    }
	
	    return SubmitDialog;
	}(Dialog);
	
	var ConfirmDialog = exports.ConfirmDialog = function (_Dialog2) {
	    _inherits(ConfirmDialog, _Dialog2);
	
	    function ConfirmDialog(props) {
	        _classCallCheck(this, ConfirmDialog);
	
	        return _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).call(this, (0, _pexui.extend)({
	            role: "dialog",
	            aria: {
	                labelledby: 'infw_dialog_confirm',
	                modal: true
	            },
	            id: 'infw_dialog_confirm',
	            width: 500,
	            height: 200,
	            subTitle: (0, _pexui._n)('submit.message'),
	            icon: "icon-xl infw-icon-warning",
	            buttons: [{ id: 'infw_btn_dlg_no', label: (0, _pexui._n)('no'), isPrimary: false, value: 'no' }, { id: 'infw_btn_dlg_yes', label: (0, _pexui._n)('yes'), isPrimary: true, value: 'yes' }] }, props)));
	    }
	
	    return ConfirmDialog;
	}(Dialog);
	
	var ExitConfirmDialog = exports.ExitConfirmDialog = function (_ConfirmDialog) {
	    _inherits(ExitConfirmDialog, _ConfirmDialog);
	
	    function ExitConfirmDialog(props) {
	        _classCallCheck(this, ExitConfirmDialog);
	
	        return _possibleConstructorReturn(this, (ExitConfirmDialog.__proto__ || Object.getPrototypeOf(ExitConfirmDialog)).call(this, (0, _pexui.extend)({
	            role: "dialog",
	            aria: {
	                labelledby: 'infw_dialog_exit_widget',
	                modal: true
	            },
	            id: 'infw_dialog_exit_widget',
	            subTitle: (0, _pexui._n)('exit.title'),
	            icon: (0, _pexui._n)('exit.dialog.icon')
	        }, props)));
	    }
	
	    return ExitConfirmDialog;
	}(ConfirmDialog);
	
	var ExitYodleeDialog = exports.ExitYodleeDialog = function (_Dialog3) {
	    _inherits(ExitYodleeDialog, _Dialog3);
	
	    function ExitYodleeDialog(props) {
	        _classCallCheck(this, ExitYodleeDialog);
	
	        return _possibleConstructorReturn(this, (ExitYodleeDialog.__proto__ || Object.getPrototypeOf(ExitYodleeDialog)).call(this, (0, _pexui.extend)({
	            role: "dialog",
	            aria: {
	                labelledby: 'infw_dialog_exit_yodlee',
	                modal: true
	            },
	            id: 'infw_dialog_exit_yodlee',
	            width: 500,
	            height: 200,
	            icon: (0, _pexui._n)('exit.yodlee.icon'),
	            subTitle: (0, _pexui._n)('exit.yodlee.title'),
	            message: (0, _pexui._n)('exit.yodlee.message'),
	            buttons: [{ id: 'infw_btn_exit_yodlee_no', label: (0, _pexui._n)('exit.yodlee.no.label'), isPrimary: false, value: 'no' }, { id: 'infw_btn_exit_yodlee_yes', label: (0, _pexui._n)('exit.yodlee.yes.label'), isPrimary: true, value: 'yes' }] }, props)));
	    }
	
	    return ExitYodleeDialog;
	}(Dialog);
	
	var MessageDialog = exports.MessageDialog = function (_Dialog4) {
	    _inherits(MessageDialog, _Dialog4);
	
	    function MessageDialog(props) {
	        _classCallCheck(this, MessageDialog);
	
	        return _possibleConstructorReturn(this, (MessageDialog.__proto__ || Object.getPrototypeOf(MessageDialog)).call(this, (0, _pexui.extend)({
	            role: "dialog",
	            aria: {
	                labelledby: 'infw_dialog_message_box',
	                modal: true
	            },
	            id: 'infw_dialog_message_box',
	            width: 500,
	            height: 300,
	            icon: (0, _pexui._n)("message.dialog.icon"),
	            message: "",
	            buttons: [{ id: 'infw_btn_dlg_ok', label: (0, _pexui._n)('button_ok.label'), isPrimary: true, value: 'ok' }]
	        }, props)));
	    }
	
	    return MessageDialog;
	}(Dialog);
	
	function messageBox(message) {
	    var height = 180 + 20 * Math.ceil(message.length / 50);
	    return showModalPromise(_pexui.React.createElement(MessageDialog, { message: message, height: height }));
	}
	
	var ErrorDialog = exports.ErrorDialog = function (_Dialog5) {
	    _inherits(ErrorDialog, _Dialog5);
	
	    function ErrorDialog(props) {
	        _classCallCheck(this, ErrorDialog);
	
	        return _possibleConstructorReturn(this, (ErrorDialog.__proto__ || Object.getPrototypeOf(ErrorDialog)).call(this, (0, _pexui.extend)({
	            role: "dialog",
	            aria: {
	                labelledby: 'infw_dialog_error',
	                modal: true
	            },
	            id: 'infw_dialog_error',
	            width: 500,
	            height: 300,
	            icon: (0, _pexui._n)('error.dialog.icon'),
	            message: "Error",
	            buttons: [{ id: 'infw_btn_dlg_ok', label: (0, _pexui._n)('button_ok.label'), isPrimary: true, value: 'ok' }]
	        }, props)));
	    }
	
	    return ErrorDialog;
	}(Dialog);
	
	function showError(err) {
	    err = '' + err;
	    if (/^HTTP \d+/.test(err)) {
	        err = (0, _pexui._n)("error.service.message");
	    }
	    var height = 180 + 20 * Math.ceil(err.length / 50);
	
	    return showModalPromise(_pexui.React.createElement(ErrorDialog, { message: err, height: height }));
	}
	
	module.exports.showModal = _pexui.showModal;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Html = Html;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Promise = utils.Promise;
	
	// A display of HTML content
	function Html(_ref) {
	    var ref = _ref.ref,
	        tag = _ref.tag,
	        id = _ref.id,
	        className = _ref.className,
	        style = _ref.style,
	        content = _ref.content,
	        value = _ref.value,
	        hideEmpty = _ref.hideEmpty,
	        onLoad = _ref.onLoad,
	        onError = _ref.onError;
	
	    tag = tag || 'div';
	    content = content || '';
	    //style = extend({
	    //    'overflow-y': 'auto'
	    //}, style);
	
	    var isPromise = false;
	    var isPlain = false;
	    if (utils.isContentId(content) || /^\s*url\((.*)\)\s*$/.test(content)) {
	        content = utils.getHtmlContent(content, value);
	        isPromise = content instanceof Promise;
	        if (!isPromise) {
	            isPlain = !utils.isHtml(content);
	        }
	    } else {
	        content = utils.evalExpr(content, value);
	        isPlain = !utils.isHtml(content);
	    }
	
	    // hideEmpty: hide the component if the content is empty
	    if (!isPromise && hideEmpty && !content) {
	        style = style || {};
	        style.display = "none";
	    }
	
	    var elem = _pexui.React.createElement(tag, { id: id, className: className, style: style, ref: ref }, isPlain ? content : '');
	
	    if (isPromise) {
	        content.then(function (resp) {
	            elem.innerHTML = resp.data;
	            if (hideEmpty && !resp.data) {
	                elem.style.display = 'none';
	            }
	
	            if (typeof onLoad === 'function') {
	                onLoad(elem);
	            }
	        }, onError);
	    } else {
	        if (!isPlain) {
	            elem.innerHTML = content;
	        }
	
	        // immediately inovke the callback
	        if (typeof onLoad === 'function') {
	            setTimeout(function () {
	                onLoad(elem);
	            }, 100);
	        }
	    }
	
	    return elem;
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PageHeader = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var PageHeader = exports.PageHeader = function PageHeader(_ref) {
	    var visible = _ref.visible,
	        title = _ref.title,
	        onBack = _ref.onBack,
	        onClose = _ref.onClose;
	
	    if (visible) {
	        var backButton = onBack ? _pexui.React.createElement(
	            "div",
	            { className: "infw-icon-back-holder" },
	            _pexui.React.createElement("span", { className: "infw-icon-left",
	                onClick: function onClick(evt) {
	                    evt.preventDefault();
	                    onBack();
	                },
	                title: (0, _pexui._n)("footer.back") })
	        ) : _pexui.React.createElement("div", { className: "infw-icon-back-holder" });
	        var closeButton = onClose ? _pexui.React.createElement(
	            "div",
	            { className: "infw-icon-close-holder" },
	            _pexui.React.createElement("span", { className: "infw-icon-close",
	                onClick: onClose })
	        ) : false;
	        return _pexui.React.createElement(
	            "div",
	            { className: "infw-caption-bar",
	                style: { margin: '0px' } },
	            backButton,
	            _pexui.React.createElement(
	                "div",
	                { className: "infw-caption-bar-inner" },
	                _pexui.React.createElement(
	                    "span",
	                    { className: "infw-caption-text" },
	                    title
	                )
	            ),
	            closeButton
	        );
	    } else {
	        return '';
	    };
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PageFooter = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _uicomps = __webpack_require__(85);
	
	var _faq = __webpack_require__(92);
	
	var PageFooter = exports.PageFooter = function PageFooter(_ref) {
	    var visible = _ref.visible,
	        buttons = _ref.buttons,
	        hasHelp = _ref.hasHelp;
	
	    if (visible) {
	
	        var buttonSize = "col-xs-12 col-md-4";
	        var firstButtonOffset = buttons.length <= 1 ? ' col-md-offset-8' : buttons.length === 2 ? ' col-md-offset-4' : '';
	        if (buttons.length === 1 && (buttons[0].className === 'infw-btn-primary' || buttons[0].className === 'infw-btn-secondary')) {
	            firstButtonOffset = ' col-md-offset-6';
	            buttonSize = "col-xs-12 col-md-6";
	        }
	
	        return _pexui.React.createElement(
	            'div',
	            { className: 'infw-footer' },
	            _pexui.React.createElement(
	                'div',
	                { className: 'infw-footer-help' },
	                hasHelp ? _pexui.React.createElement(_faq.FaqHelpLink, { id: 'infw_link_help' }) : ''
	            ),
	            _pexui.React.createElement(
	                'div',
	                { className: 'infw-footer-buttons' },
	                buttons.map(function (button, index) {
	                    return _pexui.React.createElement(
	                        'div',
	                        null,
	                        _pexui.React.createElement(_uicomps.Button, {
	                            id: button.id,
	                            label: button.label,
	                            className: (button.className || (button.isPrimary ? "infw-btn-primary-small" : "infw-btn-secondary-small")) + ' margin-1',
	                            disabled: button.disabled ? true : false,
	                            busyZone: button.busyZone,
	                            onClick: button.onClick })
	                    );
	                })
	            )
	        );
	    } else {
	        return '';
	    }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FaqHelpLink = exports.questionAnswers = exports.questionsPanelCache = exports.faqList = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _win = __webpack_require__(93);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _FaqHelpPage = __webpack_require__(94);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	//questionsPanel:   this is the list of question links that will show up when the user clicks on a topic from the list
	//topic:  an item in the list that is mapped to a set of questions and answers
	
	var faqList = exports.faqList = [];
	var questionsPanelCache = exports.questionsPanelCache = [];
	var questionAnswers = exports.questionAnswers = [];
	
	var FaqHelpLink = exports.FaqHelpLink = function FaqHelpLink(_ref) {
	    var id = _ref.id,
	        className = _ref.className,
	        style = _ref.style;
	
	    // external FAQ link support is added for eapply
	    var externalFaqLink = (0, _pexui._n)('link_help.link');
	    if (externalFaqLink) {
	        // simple external Faq link
	        return _pexui.React.createElement(
	            'a',
	            { id: id, className: className,
	                style: style,
	                href: externalFaqLink,
	                onClick: function onClick(evt) {
	                    (0, _track.trackClick)("Click_HelpFAQ");
	                },
	                target: '_blank' },
	            (0, _pexui._n)("link_help.label")
	        );
	    } else {
	        // built-in Faq
	        var stylesheets = [(0, _pexui.joinUrl)(utils.getBaseUri(), 'infowidget/styles/dls-widget.min.css'), (0, _pexui.joinUrl)(utils.getBaseUri(), 'infowidget/styles/pex_getinfo_widget.css')];
	        var onStart = function onStart(evt) {
	            evt.preventDefault();
	
	            (0, _track.trackClick)("Click_HelpFAQ");
	            (0, _win.showInNewWindow)(_FaqHelpPage.FaqHelpPage, null, {
	                title: 'FAQ',
	                stylesheets: stylesheets
	            });
	        };
	        var helpContentUrl = utils.getUrlFromResource('link_help.content');
	
	        return _pexui.React.createElement(
	            'a',
	            { id: id,
	                className: className,
	                style: style,
	                href: helpContentUrl,
	                onClick: onStart },
	            (0, _pexui._n)("link_help.label")
	        );
	    }
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.showInNewWindow = showInNewWindow;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Show a Comonent in new browser window
	 * @param {function} ComponentFactory
	 * @param {object} opts 
	 *  {
	 *    title
	 *    stylesheets
	 *    javascripts
	 *  }
	 */
	function showInNewWindow(ComponentFactory, props, opts) {
	
	    var html = '<!DOCTYPE html>\n' + '<html lang="en"><head>\n' + '<meta content="width=device-width, initial-scale=1.0, minimum-scale=1.0" name="viewport" id="viewport">\n' + '<meta http-equiv="X-UA-Compatible" content="IE=edge">\n';
	    if (opts) {
	        if (opts.title) {
	            html += '<title>' + opts.title + '</title>\n';
	        }
	        if (opts.stylesheets && Array.isArray(opts.stylesheets)) {
	            for (var i = 0; i < opts.stylesheets.length; i++) {
	                html += '<link type="text/css" rel="stylesheet" href="' + opts.stylesheets[i] + '" crossorigin="anonymous">\n';
	            }
	        }
	        if (opts.javascripts && Array.isArray(opts.javascripts)) {
	            for (var _i = 0; _i < opts.javascripts.length; _i++) {
	                html += '<script type="text/javascript" src="' + opts.javascripts[_i] + '"></script>\n';
	            }
	        }
	        // single script tag
	        if (opts.script) {
	            html += '<script type="text/javascript">\n' + opts.script + '</script>\n';
	        }
	    }
	
	    html += '</head>\n';
	    html += '<body style="margin:0"' + (opts.onload ? ' onload="' + opts.onload + '"' : '') + '>Loading...</body></html>';
	
	    var browserWindow = window.open("", "FAQ", "", true);
	    var browserDocument = browserWindow.document;
	    browserDocument.write(html);
	
	    var showIt = function showIt() {
	        if (browserDocument.createElement && browserDocument.body) {
	            // rendering in the new document instead
	            var savedDoc = _pexui.ReactLite.currentDocument;
	            _pexui.ReactLite.currentDocument = browserDocument;
	            try {
	                var comp = _pexui.React.createElement(ComponentFactory, props);
	                comp.parentWindowInstance = browserWindow;
	                _pexui.ReactDOM.render(comp, browserDocument.body);
	            } catch (err) {
	                console.error(err);
	            }
	            _pexui.ReactLite.currentDocument = savedDoc;
	        } else {
	            console.log("New window not ready, try later.");
	            setTimeout(showIt, 500);
	        }
	    };
	
	    showIt();
	}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FaqHelpPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _ExpandableFAQ = __webpack_require__(95);
	
	var _ShowAllFAQs = __webpack_require__(96);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaqHelpPage = exports.FaqHelpPage = function (_React$Component) {
	    _inherits(FaqHelpPage, _React$Component);
	
	    function FaqHelpPage(props) {
	        _classCallCheck(this, FaqHelpPage);
	
	        var _this = _possibleConstructorReturn(this, (FaqHelpPage.__proto__ || Object.getPrototypeOf(FaqHelpPage)).call(this, props));
	
	        _this.state = {
	            faqData: null,
	            hasErrors: false
	        };
	
	        _this.messages = [];
	        _this.parentWindowInstance;
	        return _this;
	    }
	
	    _createClass(FaqHelpPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            //Build the FAQ content array from the faq JSON file
	
	            var contentUrl = utils.getUrlFromResource('link_help.content');
	            utils.ajaxPromise({ url: contentUrl,
	                method: 'GET' }).then(function (resp) {
	
	                _this2.setState({ faqData: JSON.parse(resp.data) });
	            }).catch(function (err) {
	                _this2.showError(err);
	            });
	        }
	    }, {
	        key: 'showError',
	        value: function showError(err) {
	            this.messages.push(utils.convertError(err).message);
	            this.setState({ hasErrors: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var faqData = this.state.faqData;
	            var previewCount = faqData ? faqData.previewCount : 0;
	            var title = faqData ? faqData.title : 'Loading...';
	            var faqs = faqData && faqData.content ? faqData.content.map(function (item, index) {
	                return _pexui.React.createElement(_ExpandableFAQ.ExpandableFAQ, { key: index, index: index, previewCount: previewCount, item: item, windowHandler: _this3.parentWindowInstance });
	            }) : '';
	            var showAll = previewCount && faqData && faqData.content && faqData.content.length > previewCount ? _pexui.React.createElement(_ShowAllFAQs.ShowAllFAQs, { windowHandler: this.parentWindowInstance }) : "";
	
	            return _pexui.React.createElement(
	                'div',
	                { className: 'infw-faq-page' },
	                _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-faq-content' },
	                    _pexui.React.createElement(
	                        'div',
	                        { className: 'infw-faq-title' },
	                        title
	                    ),
	                    faqs,
	                    showAll
	                )
	            );
	        }
	    }]);
	
	    return FaqHelpPage;
	}(_pexui.React.Component);
	
	;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ExpandableFAQ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _uicomps = __webpack_require__(85);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandableFAQ = exports.ExpandableFAQ = function (_React$Component) {
	    _inherits(ExpandableFAQ, _React$Component);
	
	    function ExpandableFAQ(props) {
	        _classCallCheck(this, ExpandableFAQ);
	
	        var _this = _possibleConstructorReturn(this, (ExpandableFAQ.__proto__ || Object.getPrototypeOf(ExpandableFAQ)).call(this, props));
	
	        _this.index = props.index;
	        _this.previewCount = props.previewCount;
	        _this.question = props.item.question;
	        _this.answer = props.item.answer;
	        _this.windowHandler = props.windowHandler;
	        return _this;
	    }
	
	    _createClass(ExpandableFAQ, [{
	        key: 'expandAnswer',
	        value: function expandAnswer(elementId) {
	            if (!this.windowHandler) return;
	
	            var answerDiv = this.windowHandler.document.getElementById(elementId);
	            if (!answerDiv) return;
	
	            var formattedContent = this.answer.map(function (ans) {
	                return '<p>' + ans + '</p>';
	            }).join('');
	            answerDiv.innerHTML = '<p>' + formattedContent + '</p>';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _pexui.React.createElement(
	                'div',
	                { className: 'infw-faq-item',
	                    style: { display: this.previewCount && this.index >= this.previewCount ? "none" : "block" } },
	                _pexui.React.createElement(_uicomps.Link, { id: 'faq_' + this.index, className: 'infw-faq-question', label: this.question, onClick: function onClick() {
	                        return _this2.expandAnswer('answer_' + _this2.index);
	                    } }),
	                _pexui.React.createElement(
	                    'div',
	                    { id: 'answer_' + this.index, className: 'infw-faq-answer' },
	                    this.answer.length === 1 && this.answer[0].length <= 100 ? this.answer[0] : this.answer[0].substr(0, 100) + '...'
	                )
	            );
	        }
	    }]);
	
	    return ExpandableFAQ;
	}(_pexui.React.Component);
	
	;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShowAllFAQs = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _uicomps = __webpack_require__(85);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShowAllFAQs = exports.ShowAllFAQs = function (_React$Component) {
	  _inherits(ShowAllFAQs, _React$Component);
	
	  function ShowAllFAQs(props) {
	    _classCallCheck(this, ShowAllFAQs);
	
	    var _this = _possibleConstructorReturn(this, (ShowAllFAQs.__proto__ || Object.getPrototypeOf(ShowAllFAQs)).call(this, props));
	
	    _this.windowHandler = props.windowHandler;
	    return _this;
	  }
	
	  _createClass(ShowAllFAQs, [{
	    key: 'displayAllFaqs',
	    value: function displayAllFaqs() {
	      if (!this.windowHandler) return;
	
	      var seeAllDiv = this.windowHandler.document.getElementById('infw_faq_seeall');
	      var faqItems = this.windowHandler.document.querySelectorAll('div.infw-faq-item');
	
	      if (!seeAllDiv || !faqItems) return;
	
	      for (var faqIndex = 0; faqIndex < faqItems.length; faqIndex++) {
	        var faqItem = faqItems.item(faqIndex);
	        faqItem.style.display = 'block';
	      }
	      seeAllDiv.style.display = 'none';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _pexui.React.createElement(
	        'div',
	        { id: 'infw_faq_seeall', className: 'infw-faq-seeall' },
	        _pexui.React.createElement(_uicomps.Link, { className: 'a',
	          label: (0, _pexui._n)('link_help.seeall.label'),
	          onClick: function onClick() {
	            return _this2.displayAllFaqs();
	          }
	        })
	      );
	    }
	  }]);
	
	  return ShowAllFAQs;
	}(_pexui.React.Component);
	
	;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FilesList = undefined;
	exports.FileButton = FileButton;
	
	var _pexui = __webpack_require__(2);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _flow = __webpack_require__(10);
	
	var _uicomps = __webpack_require__(85);
	
	var _busy = __webpack_require__(86);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Decides if the file size exceeds limit
	 * @param {*} size  size of file in bytes
	 * @param {number} limit  limit of file in MB
	 * @returns {boolean}
	 */
	function fileSizeExceedsLimit(size, limit) {
	    if (typeof size !== 'undefined') {
	        var s = parseInt(size);
	        return s > limit * 1048576;
	    }
	    return false;
	}
	
	/**
	 *
	 * @param file
	 *
	 * Do any prechecks if possible but the server side code will do the final check
	 * can not prevent everything from the client in case there is some way to bypass these
	 */
	function checkForFileErrors(node, file, on_error) {
	    // clean the previous error messages.
	    node.messages = [];
	
	    var errors = false;
	
	    var addError = function addError(errorKey) {
	        // '!' means a user-facing message, don't convert it again.
	        on_error('!' + (0, _pexui._n)(errorKey), errorKey);
	        errors = true;
	    };
	
	    //total file size error
	    var totalSize = node.files.reduce(function (totalFileSize, f) {
	        return totalFileSize += f.size;
	    }, file.size);
	    if (fileSizeExceedsLimit(totalSize, 30)) {
	        _flow.flow.lastError = '50320';
	        addError('error.50320.message');
	    }
	    //duplicate file error
	    var duplicate = node.files.some(function (f) {
	        return f.originalName === file.originalName;
	    });
	    if (duplicate) {
	        _flow.flow.lastError = 'dupfile';
	        addError('error.duplicate.message');
	    }
	    //file size error
	    if (fileSizeExceedsLimit(file.size, 10)) {
	        _flow.flow.lastError = '50300';
	        addError('error.50300.message');
	    }
	
	    return errors;
	}
	
	function uploadAFile(node, file, params, on_success, on_error) {
	    _flow.flow.lastChannel = 'DOCUPLOAD';
	
	    if (!checkForFileErrors(node, file, on_error)) {
	        _docuploadsvc.DocUploadService.upload(file, params, node.code).then(function (resp) {
	            (0, _busy.stopBusy)();
	            var respObj = resp.obj;
	            _flow.flow.docUploadTids[node.code] = respObj.docupld_tid;
	
	            if (typeof on_success === 'function') {
	                on_success(resp.file, respObj);
	            }
	        }).catch(function (err) {
	            (0, _busy.stopBusy)();
	
	            if (typeof on_error === 'function') {
	                on_error(err);
	            }
	        });
	    } else {
	        (0, _busy.stopBusy)();
	    }
	}
	
	function removeAFile(files, file, on_change, on_error, code, node) {
	    _flow.flow.lastChannel = 'DOCUPLOAD';
	    var req = _flow.flow.req;
	
	    _docuploadsvc.DocUploadService.removeFile({
	        transaction_id: req.transaction_id,
	        originator_id: req.originator_id,
	        docupld_request_id: req.transaction_id,
	        market: req.market,
	        account_number: req.document_data.process_control_number || null,
	        docupld_fid: file.fid,
	        docupld_tid: _flow.flow.docUploadTids[code] || '',
	        docupld_token: _flow.flow.docupld_token || '',
	        customer_id: node.account.customer_id || '',
	        organization_id: node.account.organization_id || '',
	        offer_details_code: req.document_data.offer_details_code,
	        document_type: node.widgetOption ? node.widgetOption.document_type : ''
	    }, code).then(function (resp) {
	        (0, _busy.stopBusy)();
	
	        utils.deleteArray(files, function (f) {
	            return f.fid === file.fid;
	        });
	
	        if (typeof on_change === 'function') {
	            on_change();
	        }
	    }, function (err) {
	        (0, _busy.stopBusy)();
	
	        if (typeof on_error === 'function') {
	            on_error(err);
	        }
	    });
	}
	
	function FileButton(_ref) {
	    var node = _ref.node,
	        id = _ref.id,
	        className = _ref.className,
	        label = _ref.label,
	        style = _ref.style,
	        params = _ref.params,
	        busyZone = _ref.busyZone,
	        onUploaded = _ref.onUploaded,
	        onError = _ref.onError;
	
	    var btnIdFile = 'infw_btn_file_' + utils.randomString(8);
	    var buttonRegualr = _pexui.React.createElement(_uicomps.Button, {
	        id: id,
	        className: className,
	        label: label,
	        style: style,
	        busyZone: busyZone,
	        onClick: function onClick() {
	            (0, _pexui.clickOn)(btnIdFile);
	        }
	    });
	
	    return _pexui.React.createElement(
	        'span',
	        null,
	        buttonRegualr,
	        _pexui.React.createElement('input', {
	            type: 'file',
	            id: btnIdFile,
	            style: { display: 'none' },
	            onChange: function onChange(evt) {
	                (0, _busy.startBusy)(buttonRegualr);
	                uploadAFile(node, evt.target.files.length > 0 ? evt.target.files[0] // globals.onFilePicker is for unit test
	                : typeof globals.onFilePicker === 'function' ? globals.onFilePicker.call(evt.target) : null, params, onUploaded, onError);
	            }
	        })
	    );
	}
	
	FileButton.propTypes = {
	    label: _pexui.React.PropTypes.string.isRequired,
	    className: _pexui.React.PropTypes.string,
	    style: _pexui.React.PropTypes.object,
	    busyZone: _pexui.React.PropTypes.string,
	    onUploaded: _pexui.React.PropTypes.func,
	    onError: _pexui.React.PropTypes.func
	};
	
	var FilesList = exports.FilesList = function FilesList(_ref2) {
	    var node = _ref2.node,
	        withRemove = _ref2.withRemove,
	        on_change = _ref2.on_change,
	        on_error = _ref2.on_error;
	    var code = node.code,
	        files = node.files;
	
	    if (files) {
	        return _pexui.React.createElement(
	            'table',
	            { style: { width: '100%' } },
	            files.map(function (file) {
	                var icon = false;
	                if (file.type === 'file') {
	                    if (/\.pdf$/.test(file.originalName)) {
	                        icon = _pexui.React.createElement('span', { className: 'dls-icon-pdf' });
	                    } else {
	                        icon = _pexui.React.createElement('span', { className: 'dls-icon-document' });
	                    }
	                }
	                return _pexui.React.createElement(
	                    'tr',
	                    { className: 'border-tb' },
	                    _pexui.React.createElement(
	                        'td',
	                        { className: 'text-align-left' },
	                        icon,
	                        file.originalName
	                    ),
	                    _pexui.React.createElement(
	                        'td',
	                        { className: 'text-align-right infw-file-list' },
	                        file.completedTime ? _pexui.React.createElement(
	                            'span',
	                            null,
	                            _pexui.React.createElement('span', {
	                                className: file.type === 'info' || file.successCode === 'INGESTED' ? 'infw-icon-success' : 'infw-icon-error'
	                            }),
	                            _pexui.React.createElement(
	                                'span',
	                                null,
	                                file.type === 'info' ? (0, _pexui._n)('completed_on') : file.successCode === 'INGESTED' ? (0, _pexui._n)('uploaded_on') : file.message
	                            ),
	                            _pexui.React.createElement(
	                                'div',
	                                { className: 'infw-file-message text-align-center' },
	                                (0, _pexui._n)('upload_file_message')
	                            )
	                        ) : _pexui.React.createElement(
	                            'span',
	                            null,
	                            withRemove ? _pexui.React.createElement(_uicomps.RemoveButton, {
	                                icon: 'infw-icon-remove',
	                                label: (0, _pexui._n)('link_removefile.label'),
	                                busyZone: 'widget',
	                                onClick: function onClick() {
	                                    removeAFile(files, file, on_change, on_error, code, node);
	                                }
	                            }) : false
	                        )
	                    )
	                );
	            })
	        );
	    } else {
	        return '';
	    }
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChoiceSection = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var _uicomps = __webpack_require__(85);
	
	var getChoiceTitle = function getChoiceTitle(choiceNodes) {
	    var value = "";
	    choiceNodes.forEach(function (node2, index) {
	        if (index == 0) {
	            value = getNodeTitle(node2);
	        } else {
	            value = value + " & " + getNodeTitle(node2);
	        }
	    });
	    return value;
	};
	
	var getNodeTitle = function getNodeTitle(node) {
	    var value = '';
	    if (node.choices) {
	        node.choices.forEach(function (choice, index) {
	            if (index == 0) {
	                value = getChoiceTitle(choice);
	            } else {
	                value = value + ' ' + (0, _pexui._n)('widget.doc_options.or') + ' ' + getChoiceTitle(choice);
	            }
	        });
	    } else if (node.widgetOption) {
	        value = (0, _pexui._n)(node.widgetOption.content_id + '.title', { business_name: node.account.organization_name || '' });
	    }
	    return value;
	};
	
	var ChoiceSection = exports.ChoiceSection = function ChoiceSection(_ref) {
	    var page = _ref.page,
	        flow = _ref.flow,
	        node = _ref.node,
	        className = _ref.className,
	        style = _ref.style;
	
	    var widget = page.props.widget;
	    var contents = [];
	
	    node.choices.forEach(function (choice, index) {
	        if (index > 0) {
	            contents.push(_pexui.React.createElement('br', null));
	        }
	        contents.push(_pexui.React.createElement(_uicomps.RadioButon, {
	            label: getChoiceTitle(choice),
	            name: 'doc_choice',
	            onClick: function onClick() {
	                flow.setCurrentNode(node);
	                flow.down(index);
	                page.setState({ level: page.state.level + 1 });
	            } }));
	    });
	
	    return _pexui.React.createElement(
	        'div',
	        { className: className, style: style },
	        _pexui.React.createElement(
	            'div',
	            { className: 'text-align-left' },
	            (0, _pexui._n)('DocUpload.choice.message')
	        ),
	        _pexui.React.createElement('br', null),
	        _pexui.React.createElement(
	            'div',
	            { className: 'text-align-left' },
	            contents
	        )
	    );
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RequiredDocSection = exports.YodleePane = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _uicomps = __webpack_require__(85);
	
	var _html = __webpack_require__(89);
	
	var _files = __webpack_require__(97);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _flow = __webpack_require__(10);
	
	var _consts = __webpack_require__(65);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _busy = __webpack_require__(86);
	
	var _docupload = __webpack_require__(100);
	
	var _docusign = __webpack_require__(101);
	
	var _linkedin = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getPanelTitle = function getPanelTitle(node) {
	    if (node.choices) {
	        return (0, _pexui._n)('choice_title');
	    } else {
	        return getNodeTitle(node);
	    }
	};
	
	var YodleePane = exports.YodleePane = function YodleePane(_ref) {
	    var page = _ref.page,
	        node = _ref.node,
	        widget = _ref.widget,
	        flow = _ref.flow,
	        className = _ref.className;
	
	    var yodleeOnly = flow.isYodleeOnly();
	
	    return _pexui.React.createElement(
	        'div',
	        { className: className },
	        _pexui.React.createElement(_uicomps.Button, { id: utils.getUniqueId('infw_btn_yodlee', node),
	            className: yodleeOnly ? 'infw-btn-primary' : 'infw-btn-secondary',
	            label: (0, _pexui._n)('Yodlee.button_label'),
	            onClick: function onClick() {
	                (0, _track.trackClick)('VerifyNow');
	                node.messages = [];
	                flow.setCurrentNode(node);
	                widget.nav("yodlee");
	            }
	        }),
	        _pexui.React.createElement(_html.Html, { className: 'infw-btn-desc', hideEmpty: true,
	            content: 'Yodlee.button_desc' })
	    );
	};
	
	var RequiredDocSection = exports.RequiredDocSection = function RequiredDocSection(_ref2) {
	    var page = _ref2.page,
	        flow = _ref2.flow,
	        node = _ref2.node,
	        className = _ref2.className,
	        style = _ref2.style;
	
	    var widget = page.props.widget;
	
	    // showing the completed files list
	    var uploadedFiles = _pexui.React.createElement(_files.FilesList, { files: node.files,
	        node: node,
	        withRemove: true,
	        withComment: true,
	        on_change: function on_change() {
	            node.messages = [];
	            (0, _track.track)("AddFile:Removed", { contentName: (0, _flow.getTrackLabel)(node) });
	            page.forceUpdate();
	        },
	        on_error: function on_error(err) {
	            flow.addNodeMessage(node, err);
	            page.forceUpdate();
	        } });
	
	    // showing messages
	    if (!node.widgetOption) {
	        node.messages.push('!Unknown We need code ' + node.code);
	    }
	
	    var hasErrors = false;
	    var messages = node.messages ? node.messages.map(function (m) {
	        if (m.charAt(0) === '!') {
	            hasErrors = true;
	            return _pexui.React.createElement(
	                'div',
	                { style: { color: '#B42C01' }, 'aria-live': 'polite' },
	                _pexui.React.createElement('span', {
	                    className: 'infw-icon-warning',
	                    role: 'alert',
	                    'aria-label': (0, _pexui._n)('icon_warning') }),
	                m.substring(1)
	            );
	        } else {
	            return _pexui.React.createElement(
	                'div',
	                null,
	                m
	            );
	        }
	    }) : [];
	
	    // operation panes (horizontal layout in current design)
	    var contents = [];
	    // fix for broken page on a non-well configured we need code.
	    var docOptions = node && node.widgetOption && node.widgetOption.docOptions || [];
	    if (node.done) {
	        var hasYodleeCompleted = utils.inArray(docOptions, 'Yodlee') && utils.findArray(node.files, function (file) {
	            return file.type === 'info';
	        }) !== null;
	    } else {
	        // hiding the operation panes if done
	        var shownDocOptions = docOptions;
	        // if some files have been attached/uploaded, show the DocUpload pane only.
	        if (node.files.length > 0) {
	            shownDocOptions = utils.inArray(docOptions, 'DocUpload') ? ['DocUpload'] : [];
	        }
	        var _className = shownDocOptions.length === 1 ? "col-md-6 col-md-offset-3" : "col-md-5";
	
	        shownDocOptions.forEach(function (docOption, index) {
	            if (index > 0) {
	                contents.push(_pexui.React.createElement(
	                    'div',
	                    { className: 'col-md-2 text-align-center' },
	                    _pexui.React.createElement(
	                        'div',
	                        { style: { width: '100%', 'margin-top': '12px' } },
	                        (0, _pexui._n)('widget.doc_options.or')
	                    )
	                ));
	            }
	
	            switch (docOption) {
	                case 'DocUpload':
	                    contents.push(_pexui.React.createElement(_docupload.DocUploadPane, { page: page, node: node, widget: widget, flow: flow, className: _className }));
	                    break;
	                case 'Yodlee':
	                    contents.push(_pexui.React.createElement(YodleePane, { page: page, node: node, widget: widget, flow: flow, className: _className }));
	                    break;
	                case 'LinkedIn':
	                    contents.push(_pexui.React.createElement(_linkedin.LinkedInPane, { page: page, node: node, widget: widget, flow: flow, className: _className }));
	                    break;
	                case 'DocuSign':
	                    contents.push(_pexui.React.createElement(_docusign.DocuSignPane, { page: page, node: node, widget: widget, flow: flow, className: _className }));
	                    break;
	            }
	        });
	
	        if (!hasErrors) {
	            (0, _track.track)('', {
	                contentName: (0, _flow.getTrackLabel)(node),
	                selfServiceStart: true,
	                events: !_globals2.default.event51Sent ? _consts.SUCCESSFUL_FIRST_LOAD_EVENT : null,
	                noRepeat: true
	            });
	        }
	    }
	
	    return _pexui.React.createElement(
	        'div',
	        { className: className, style: style },
	        _pexui.React.createElement(_html.Html, { className: 'infw-section-desc', content: node.widgetOption.content_id + '.desc' }),
	        uploadedFiles,
	        _pexui.React.createElement(
	            'div',
	            { className: 'text-align-left', style: 'padding: 2px;' },
	            messages
	        ),
	        _pexui.React.createElement(
	            'div',
	            { className: 'infw-content-container' },
	            contents
	        )
	    );
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocUploadPane = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _flow = __webpack_require__(10);
	
	var _track = __webpack_require__(11);
	
	var _uicomps = __webpack_require__(85);
	
	var _html = __webpack_require__(89);
	
	var _files = __webpack_require__(97);
	
	var _busy = __webpack_require__(86);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var shouldShowUploadButton = function shouldShowUploadButton(node) {
	  var uploadCompleted = utils.findArray(node.files, function (file) {
	    return !file.completedTime;
	  }) == null;
	  return !uploadCompleted;
	};
	
	var DocUploadPane = exports.DocUploadPane = function DocUploadPane(_ref) {
	  var page = _ref.page,
	      node = _ref.node,
	      widget = _ref.widget,
	      flow = _ref.flow,
	      className = _ref.className;
	  var req = flow.req;
	
	  var docType = node.widgetOption ? node.widgetOption.document_type : '';
	  var showsUploadButton = shouldShowUploadButton(node);
	
	  var uploadParams = {
	    message_id: utils.randomString(12),
	    transaction_id: req.transaction_id,
	    originator_id: req.originator_id,
	    docupld_request_id: req.transaction_id,
	    market: req.market,
	    account_number: req.document_data.process_control_number,
	    business_unit_code: req.document_data.business_unit_code,
	    customer_id: node.account.customer_id || '',
	    organization_id: node.account.organization_id || '',
	    offer_details_code: req.document_data.offer_details_code,
	    document_type: docType, // 'UNAUDITED FINANCIALS',
	    docupld_tid: flow.docUploadTids[node.code] || '',
	    docupld_token: flow.docupld_token || '',
	    personal_info: req.personal_info || '',
	    member_number: req.account_number || '',
	    is_single_sign_on: req.is_single_sign_on || false
	  };
	
	  var onAttachSuccess = function onAttachSuccess(file, resp) {
	    if (resp.response_code !== 0) {
	      throw new Error('response_code should be 0!');
	    }
	    var finalArrayItem = resp.file_list.slice(-1)[0];
	    var docupld_fid = finalArrayItem ? finalArrayItem.docupld_fid : '';
	    var updatedName = finalArrayItem ? finalArrayItem.name : '';
	
	    node.files.push({
	      type: 'file',
	      size: file.size,
	      originalName: file.name,
	      updatedName: updatedName,
	      fid: docupld_fid,
	      completedTime: null
	    });
	    node.messages = [];
	
	    flow.setCurrentNode(node);
	    (0, _busy.stopBusy)();
	
	    // attached
	    (0, _track.track)('AddFile:Attached', { contentName: (0, _flow.getTrackLabel)(node) });
	    page.forceUpdate();
	  };
	
	  var onAttachError = function onAttachError(err, errorKey) {
	    flow.addNodeMessage(node, err, errorKey);
	    flow.setCurrentNode(node);
	    (0, _busy.stopBusy)();
	    page.forceUpdate();
	  };
	
	  var onUploadClicked = function onUploadClicked() {
	    flow.lastChannel = 'DOCUPLOAD';
	    node.messages = [];
	    _docuploadsvc.DocUploadService.confirmUpload(_defineProperty({
	      transaction_id: req.transaction_id,
	      originator_id: req.originator_id,
	      account_number: req.document_data.process_control_number,
	      market: req.market,
	      document_type: docType, // 'TAX TRANSCRIPT',
	      docupld_tid: flow.docUploadTids[node.code],
	      docupld_request_id: req.transaction_id,
	      docupld_token: flow.docupld_token,
	      customer_id: node.account.customer_id || '',
	      organization_id: node.account.organization_id || '',
	      offer_details_code: req.document_data.offer_details_code
	    }, 'document_type', node.widgetOption ? node.widgetOption.document_type : ''), node.code).then(function (resp) {
	      (0, _busy.stopBusy)();
	      if (resp.submit_statuses && Array.isArray(resp.submit_statuses) && resp.submit_statuses.length > 0) {
	        resp.submit_statuses.forEach(function (statusItem) {
	          if (statusItem.hasOwnProperty('file_name')) {
	            var fileName = statusItem.file_name;
	            node.files.forEach(function (file) {
	              if (utils.filenameMatches(file.updatedName, fileName)) {
	                file.successCode = statusItem.success_code || statusItem.error_code || 'error';
	                file.message = statusItem.message || '';
	                file.artifactUrn = statusItem.artifact_urn;
	                file.completedTime = new Date();
	              }
	            });
	          }
	        });
	
	        flow.raiseInvokerEvent('docUploadResponse', {
	          transaction_id: req.transaction_id,
	          process_control_number: req.document_data.process_control_number,
	          submission_channel_code: 'DOCUPLD',
	          documents_requested_code: node.code,
	          received_timestamp: utils.getTimestamp(),
	          customer_id: node.account.customer_id, // In case of CPS
	          organization_id: node.account.organization_id, // In case of OPEN
	          docupload_response: resp.submit_statuses
	        });
	      } else {
	        var submit_statuses = [];
	        node.files.forEach(function (file) {
	          if (!file.completedTime) {
	            file.successCode = 'INGESTED';
	            file.message = '';
	            file.completedTime = new Date();
	
	            submit_statuses.push({
	              success_code: 'INGESTED',
	              file_name: file.updatedName
	            });
	          }
	        });
	
	        flow.raiseInvokerEvent('docUploadResponse', {
	          transaction_id: req.transaction_id,
	          process_control_number: req.document_data.process_control_number,
	          submission_channel_code: 'DOCUPLD',
	          documents_requested_code: node.code,
	          received_timestamp: utils.getTimestamp(),
	          customer_id: node.account.customer_id, // In case of CPS
	          organization_id: node.account.organization_id, // In case of OPEN
	          docupload_response: submit_statuses
	        });
	      }
	
	      (0, _track.track)('AddFile:Success', {
	        contentName: (0, _flow.getTrackLabel)(node)
	      });
	
	      page.forceUpdate();
	    }, function (err) {
	      node.files = (node.files || []).filter(function (file) {
	        return !!file.completedTime;
	      });
	      (0, _track.setTrackOpts)('AddFile', {
	        contentName: (0, _flow.getTrackLabel)(node)
	      });
	
	      flow.addNodeMessage(node, err);
	      flow.setCurrentNode(node);
	      (0, _busy.stopBusy)();
	      page.forceUpdate();
	    });
	  };
	
	  return _pexui.React.createElement(
	    'div',
	    { className: className },
	    showsUploadButton ? _pexui.React.createElement(_uicomps.Button, {
	      id: utils.getUniqueId('infw_btn_upload', node),
	      className: 'infw-btn-secondary margin-b',
	      label: (0, _pexui._n)('document.upload'),
	      busyZone: 'widget',
	      onClick: onUploadClicked
	    }) : '',
	    [_pexui.React.createElement(_files.FileButton, {
	      id: utils.getUniqueId('infw_btn_attach', node),
	      className: 'infw-btn-secondary',
	      label: node.files.length > 0 ? (0, _pexui._n)('button_morefile.label') : (0, _pexui._n)('button_attachfile.label'),
	      node: node,
	      params: uploadParams,
	      onUploaded: onAttachSuccess,
	      onError: onAttachError
	    }), _pexui.React.createElement(_html.Html, {
	      className: 'infw-btn-desc',
	      hideEmpty: true,
	      content: 'DocUpload.button_desc'
	    })]
	  );
	};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DocuSignPane = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _uicomps = __webpack_require__(85);
	
	var _dialog = __webpack_require__(88);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _msgsvc = __webpack_require__(102);
	
	var _busy = __webpack_require__(86);
	
	var _html = __webpack_require__(89);
	
	var _spinner = __webpack_require__(87);
	
	var _flow = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var LINKEDIN_LOAD_TIMEOUT = 60000; // 1 minute
	var BUTTON_DISABLED_SECONDS = 10; // 10 seconds
	var windowWatcher = null;
	var envelopeId = null;
	
	var DocuSignPane = exports.DocuSignPane = function DocuSignPane(_ref) {
	    var page = _ref.page,
	        node = _ref.node,
	        widget = _ref.widget,
	        flow = _ref.flow,
	        className = _ref.className;
	
	    var docuSignHandler = function docuSignHandler(e) {
	        var data = e.data;
	
	        if (windowWatcher) {
	            clearInterval(windowWatcher);
	            windowWatcher = null;
	        }
	
	        (0, _busy.stopBusy)();
	
	        // event=signing_complete
	        var respObj = utils.parseUrlParams(data.substr(18));
	
	        if (respObj && respObj.event === 'signing_complete') {
	            node.files.push({
	                type: 'info',
	                name: (0, _pexui._n)('DocuSign.success.message'),
	                completedTime: new Date()
	            });
	
	            (0, _track.track)("DocuSign:Success", { contentName: (0, _flow.getTrackLabel)(node) });
	
	            _docuploadsvc.DocUploadService.log2Server({
	                "transaction_id": flow.req.transaction_id,
	                "type": "DOCUSIGN",
	                "event": respObj.event
	            });
	
	            flow.raiseInvokerEvent('docusignResponse', {
	                "transaction_id": flow.req.transaction_id,
	                "process_control_number": flow.req.document_data.process_control_number,
	                "submission_channel_code": "DOCUSIGN",
	                "documents_requested_code": node.code,
	                "received_timestamp": utils.getTimestamp(),
	                "docusign_response": {
	                    "envelope_id": envelopeId
	                }
	            });
	
	            page.forceUpdate();
	        } else {
	            var errorCode = respObj && respObj.event || 'service';
	            var errorKey = 'error.' + errorCode + '.message';
	            var errorMessage = (0, _pexui._n)(errorKey);
	
	            _docuploadsvc.DocUploadService.log2Server({
	                "transaction_id": flow.req.transaction_id,
	                "type": "DOCUSIGN",
	                "error": errorMessage
	            });
	
	            (0, _track.setTrackOpts)("DocuSign", { productsOption: node.code });
	            flow.lastError = errorCode;
	            flow.addNodeMessage(node, "!" + errorMessage, errorKey);
	            page.forceUpdate();
	        }
	    };
	
	    var gotoDocuSign = function gotoDocuSign(evt) {
	        flow.lastChannel = 'DOCUSIGN';
	
	        node.messages = [];
	        node.docuSignUrl = null;
	
	        var widgetRequest = flow.req;
	        var returnURL = (0, _pexui.joinUrl)(utils.getSameDomainBaseUrl(), 'infowidget/docusign/docusignresponse.html#');
	
	        var isIE = false;
	        var timeCounter = 0;
	        // using var instead of let in order to be accessible from an asynchronous callback.
	        var docuSignWnd = null;
	
	        if (utils.isGoodBrowser()) {
	            docuSignWnd = window.open("", "_blank");
	            // Create spinner
	            docuSignWnd.document.write("<head><style>" + _spinner.spinnerStyles + "</style><head>");
	            docuSignWnd.document.write("<div id='spinner'<div>");
	        } else {
	            isIE = true;
	            var holder = document.getElementById('px_d_iframe_holder');
	            if (holder) {
	                _pexui.ReactDOM.render(_pexui.React.createElement('iframe', { name: 'l_frame',
	                    src: (0, _pexui.joinUrl)(utils.getSameDomainBaseUrl(), 'infowidget/docusign/comm.html'),
	                    width: '300', height: '20',
	                    frameborder: '0'
	                }), holder);
	            } else {
	                console.error("Fail to find px_d_iframe_holder");
	            }
	        }
	
	        _docuploadsvc.DocUploadService.getDocuSignUrl(widgetRequest, returnURL).then(function (resp) {
	            var docuSignUrl = resp.docusign_url;
	            envelopeId = resp.envelope_id;
	
	            (0, _msgsvc.registerMessageHandler)(['docusign_response'], docuSignHandler);
	
	            // check if the window is closed every 1 second
	            windowWatcher = setInterval(function () {
	                var windowClosed = !isIE && docuSignWnd && docuSignWnd.closed;
	                var timeOut = isIE && ++timeCounter > BUTTON_DISABLED_SECONDS;
	                if (windowClosed || timeOut) {
	                    clearInterval(windowWatcher);
	                    windowWatcher = null;
	                    (0, _busy.stopBusy)();
	
	                    if (windowClosed) {
	                        var errorKey = 'error.921.message';
	                        var errorMessage = (0, _pexui._n)(errorKey) || 'User cancelled, please try again';
	
	                        (0, _track.setTrackOpts)("DocuSign", { contentName: (0, _flow.getTrackLabel)(node) });
	                        flow.lastError = '921';
	                        flow.addNodeMessage(node, "!" + errorMessage, errorKey);
	                        page.forceUpdate();
	                    }
	                }
	            }, 1000);
	
	            if (docuSignWnd) {
	                docuSignWnd.document.location.href = docuSignUrl;
	            } else {
	                setTimeout(function () {
	                    window.open(docuSignUrl, "_blank");
	                }, 1000);
	            }
	
	            (0, _track.track)("DocuSign:Open", { contentName: (0, _flow.getTrackLabel)(node) });
	        }).catch(function (err) {
	            console.log(err);
	            // fix: closing the newly opened tab in negative scenario.
	            if (docuSignWnd && !docuSignWnd.closed) {
	                docuSignWnd.close();
	            }
	
	            (0, _busy.stopBusy)();
	
	            flow.addNodeMessage(node, err);
	            flow.setCurrentNode(node);
	            page.forceUpdate();
	        });
	    };
	
	    return _pexui.React.createElement(
	        'div',
	        { className: className },
	        _pexui.React.createElement(_uicomps.Button, {
	            id: utils.getUniqueId('infw_btn_docusign', node),
	            className: 'infw-btn-secondary',
	            label: (0, _pexui._n)('DocuSign.button_label'),
	            busyZone: 'widget',
	            onClick: gotoDocuSign }),
	        node.docuSignUrl ? _pexui.React.createElement(
	            'div',
	            { className: 'infw-btn-desc' },
	            _pexui.React.createElement(
	                'span',
	                null,
	                (0, _pexui._n)('DocuSign.link_desc')
	            ),
	            _pexui.React.createElement(
	                'a',
	                { id: 'infw_link_docusign', href: node.docuSignUrl, target: '_blank' },
	                'the link'
	            ),
	            '.'
	        ) : _pexui.React.createElement(_html.Html, { className: 'infw-btn-desc',
	            content: 'DocuSign.button_desc' }),
	        _pexui.React.createElement('div', { id: 'px_d_iframe_holder' })
	    );
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.messageHandler = messageHandler;
	exports.registerMessageHandler = registerMessageHandler;
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var handlers = {},
	    messageHandlerRegistered = false;
	
	function messageHandler(e) {
	    for (var keyword in handlers) {
	        if (handlers.hasOwnProperty(keyword)) {
	            var dataString = utils.formatYodleeData(e.data);
	            if (dataString.indexOf(keyword) !== -1) {
	                var handler = handlers[keyword];
	                if (typeof handler === 'function') {
	                    handler(e);
	                    break;
	                }
	            }
	        }
	    }
	}
	
	// register DOM window message handler for notifications from the Yodlee response/error page inside the iframe.
	function registerMessageHandler(keywords, handler) {
	
	    for (var i = 0; i < keywords.length; i++) {
	        var keyword = keywords[i];
	        handlers[keyword] = handler;
	    }
	
	    // start to listen
	    if (!messageHandlerRegistered) {
	        utils.registerMessageHandler(messageHandler);
	        messageHandlerRegistered = true;
	    }
	}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showLinkedIn = exports.LinkedInPane = exports.LinkedInForm = undefined;
	
	var _pexui = __webpack_require__(2);
	
	var _msgsvc = __webpack_require__(102);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _flow = __webpack_require__(10);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _uicomps = __webpack_require__(85);
	
	var _html = __webpack_require__(89);
	
	var _busy = __webpack_require__(86);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LINKEDIN_LOAD_TIMEOUT = 60000; // 1 minute
	var BUTTON_DISABLED_SECONDS = 10; // 10 seconds
	var windowWatcher = null;
	var linkedInWnd = null;
	
	/**
	 * The LinkedIn login page allows to be shown only in a standalone window/tab.
	 * We use a form to submit to a blank page.
	 */
	var LinkedInForm = exports.LinkedInForm = function LinkedInForm() {
	  var appsrc = 'getinfowidget';
	  var geo = _flow.flow.req.market;
	  var linkedInUrl = _globals2.default.config.linkedInURL || '';
	  if (linkedInUrl) {
	    var callbackUrl = (0, _pexui.joinUrl)(utils.getSameDomainBaseUrl(), 'linkedin/linkedinresponse.html');
	    var errorUrl = (0, _pexui.joinUrl)(utils.getSameDomainBaseUrl(), 'linkedin/linkedinerror.html');
	
	    return _pexui.React.createElement(
	      'form',
	      {
	        id: 'infw_linkedin_form',
	        name: 'samlPost',
	        method: 'post',
	        action: linkedInUrl,
	        target: '_blank'
	      },
	      _pexui.React.createElement('input', { type: 'hidden', name: 'appsrc', value: appsrc }),
	      _pexui.React.createElement('input', { type: 'hidden', name: 'geo', value: geo }),
	      _pexui.React.createElement('input', { type: 'hidden', name: 'callbackURL', value: callbackUrl }),
	      _pexui.React.createElement('input', { type: 'hidden', name: 'errorURL', value: errorUrl })
	    );
	  }
	  return _pexui.React.createElement(
	    'div',
	    null,
	    (0, _pexui._n)('LinkedIn.unavailable.message')
	  );
	};
	
	/**
	 * The LinkedIn Pane shown in widget
	 */
	var LinkedInPane = exports.LinkedInPane = function LinkedInPane(_ref) {
	  var page = _ref.page,
	      node = _ref.node,
	      widget = _ref.widget,
	      flow = _ref.flow,
	      className = _ref.className;
	
	  var linkedInDone = node.files.length > 0 && node.files[0].type === 'info';
	  if (linkedInDone) {
	    return _pexui.React.createElement('div', { className: className });
	  }
	  return _pexui.React.createElement(
	    'div',
	    { className: className },
	    _pexui.React.createElement(_uicomps.Button, {
	      id: utils.getUniqueId('infw_btn_linkedin', node),
	      className: 'infw-btn-secondary',
	      label: (0, _pexui._n)('button_linkedin.label'),
	      busyZone: 'widget',
	      onClick: function onClick(evt) {
	        evt.preventDefault();
	        node.messages = [];
	        flow.setCurrentNode(node);
	
	        showLinkedIn(page, node);
	      }
	    }),
	    _pexui.React.createElement(_html.Html, {
	      className: 'infw-btn-desc',
	      hideEmpty: true,
	      content: 'LinkedIn.button_desc'
	    }),
	    _pexui.React.createElement(LinkedInForm, null),
	    _pexui.React.createElement('div', { id: 'px_l_iframe_holder' })
	  );
	};
	
	var showLinkedIn = exports.showLinkedIn = function showLinkedIn(page, node) {
	  //
	  // Message handler for LinkedIn response/error.
	  //
	  var LinkedInHandler = function LinkedInHandler(e) {
	    var data = e.data;
	
	
	    if (windowWatcher) {
	      clearInterval(windowWatcher);
	      windowWatcher = null;
	    }
	
	    (0, _busy.stopBusy)();
	
	    if (utils.beginsWith(data, 'linkedin_success')) {
	      // linkedin_success:profileid=Gy0G_EZwAv#!
	      var respObj = utils.parseUrlParams(data.substr(17));
	
	      node.files.push({
	        type: 'info',
	        name: (0, _pexui._n)('LinkedIn.success.message'),
	        completedTime: new Date()
	      });
	
	      (0, _track.track)('LinkedIn:Success', { contentName: (0, _flow.getTrackLabel)(node) });
	
	      _docuploadsvc.DocUploadService.log2Server({
	        transaction_id: _flow.flow.req.transaction_id,
	        log_type: 'INFO',
	        originator_id: _flow.flow.req.originator_id,
	        country_code: _flow.flow.req.market,
	        process_control_number: _flow.flow.req.document_data.process_control_number,
	        log_message: 'LinkedIn completed successfully: profileId=' + respObj.profileid
	      });
	
	      _flow.flow.raiseInvokerEvent('linkedInResponse', {
	        transaction_id: _flow.flow.req.transaction_id,
	        process_control_number: _flow.flow.req.document_data.process_control_number,
	        submission_channel_code: 'LINKEDIN',
	        documents_requested_code: node.code,
	        received_timestamp: utils.getTimestamp(),
	        linkedin_response: {
	          profileid: respObj.profileid
	        }
	      });
	
	      page.forceUpdate();
	    } else if (utils.beginsWith(data, 'linkedin_error')) {
	      var error = utils.parseUrlParams(data.substr(15));
	      var errorKey = 'error.' + error.errorCode + '.message';
	      var errorLogMessage = 'errorCode=' + error.errorCode + ' errorDesc=' + error.errorDesc;
	
	      _docuploadsvc.DocUploadService.log2Server({
	        transaction_id: _flow.flow.req.transaction_id,
	        log_type: 'ERROR',
	        originator_id: _flow.flow.req.originator_id,
	        country_code: _flow.flow.req.market,
	        process_control_number: _flow.flow.req.document_data.process_control_number,
	        log_message: 'Error from LinkedIn: ' + errorLogMessage
	      });
	
	      (0, _track.setTrackOpts)('LinkedIn', { productsOption: node.code });
	      _flow.flow.lastError = error.errorCode;
	
	      var errorMessage = (0, _pexui._n)(errorKey) || error.errorDesc;
	
	      _flow.flow.addNodeMessage(node, '!' + errorMessage, errorKey);
	      page.forceUpdate();
	    }
	  };
	
	  _flow.flow.lastChannel = 'LINKEDIN';
	
	  (0, _msgsvc.registerMessageHandler)(['linkedin_success', 'linkedin_error'], LinkedInHandler);
	
	  node.messages = [];
	
	  var form = utils.getElement('infw_linkedin_form');
	  if (form) {
	    var isIE = false;
	    var timeCounter = 0;
	
	    // IE 11 has a defect not to submit correctly in a new window, use target="_blank" instead
	    if (utils.isGoodBrowser()) {
	      var left = (screen.width - 546) / 2;
	      linkedInWnd = window.open('', 'linkedInWindow', 'width=546,height=625,left=' + left + ',top=100,status=yes');
	      form.target = 'linkedInWindow';
	    } else {
	      // IE doesn't allow to send messages between browser windows/tabs running in different domains.
	      // We use a mediator page comm.html inside an iframe to communicate in the middle.
	      // widget (invoker domain) <-(inter-frame message)-> comm.html(widget domain) <-(localStorage)-> linkedinresponse.html / linkedinerror.html(widget domain)
	      isIE = true;
	      var holder = document.getElementById('px_l_iframe_holder');
	      if (holder) {
	        _pexui.ReactDOM.render(_pexui.React.createElement('iframe', {
	          name: 'l_frame',
	          src: (0, _pexui.joinUrl)(utils.getSameDomainBaseUrl(), 'linkedin/comm.html'),
	          width: '300',
	          height: '20',
	          frameBorder: '0'
	        }), holder);
	      } else {
	        console.error('Fail to find px_l_iframe_holder');
	      }
	    }
	
	    // check if the window is closed every 1 second
	    windowWatcher = setInterval(function () {
	      var windowClosed = !isIE && linkedInWnd && linkedInWnd.closed;
	      var timeOut = isIE && ++timeCounter > BUTTON_DISABLED_SECONDS;
	      if (windowClosed || timeOut) {
	        clearInterval(windowWatcher);
	        windowWatcher = null;
	        (0, _busy.stopBusy)();
	
	        if (windowClosed) {
	          var errorKey = 'error.921.message';
	          var errorMessage = (0, _pexui._n)(errorKey) || 'User cancelled, please try again';
	
	          (0, _track.setTrackOpts)('LinkedIn', { contentName: (0, _flow.getTrackLabel)(node) });
	          _flow.flow.lastError = '921';
	          _flow.flow.addNodeMessage(node, '!' + errorMessage, errorKey);
	          page.forceUpdate();
	        }
	      }
	    }, 1000);
	
	    (0, _track.track)('LinkedIn:Login', { contentName: (0, _flow.getTrackLabel)(node) });
	    // form.target = 'linkedInWindow';
	    form.submit();
	  } else {
	    console.error('Fail to find element infw_linkedin_form.');
	    (0, _busy.stopBusy)();
	  }
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YodleePage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _yodleebase = __webpack_require__(105);
	
	var _dialog = __webpack_require__(88);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _track = __webpack_require__(11);
	
	var _print = __webpack_require__(106);
	
	var _busy = __webpack_require__(86);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _flow = __webpack_require__(10);
	
	var _html = __webpack_require__(89);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Promise = utils.Promise;
	
	
	var prependLeadingNumber = function prependLeadingNumber(astr, num) {
	  // already lead by a number, which could be inside a decorating tag such as <b>
	  if (/^\s*(\<[^\>]+\>)?\s*\d+/.test(astr)) {
	    return astr;
	  }
	  return '<span class="infw-how-leading-num infw-show-sm">' + num + '. </span>' + astr;
	};
	
	var HowToStep = function HowToStep(_ref) {
	  var stepNumber = _ref.stepNumber,
	      icon = _ref.icon;
	  return _pexui.React.createElement(
	    'div',
	    {
	      id: 'infw_yodlee_how_section_' + stepNumber,
	      className: 'infw-yodlee-how-section',
	      role: 'listitem'
	    },
	    _pexui.React.createElement(
	      'div',
	      { className: 'infw-list-item' },
	      _pexui.React.createElement(
	        'div',
	        { className: 'infw-yodlee-how-icons-area' },
	        _pexui.React.createElement(
	          'div',
	          { className: 'infw-yodlee-how-badge' },
	          _pexui.React.createElement(
	            'span',
	            {
	              id: 'infw_yodlee_how_badge_' + stepNumber,
	              className: 'infw-circle-badge-icon',
	              'aria-hidden': 'true'
	            },
	            '' + stepNumber
	          )
	        ),
	        _pexui.React.createElement(
	          'div',
	          {
	            className: 'infw-yodlee-how-icon',
	            'aria-hidden': 'true'
	          },
	          _pexui.React.createElement('span', {
	            id: 'infw_yodlee_how_icon_' + stepNumber,
	            className: 'icon-md dls-accent-blue-02 ' + icon
	          })
	        )
	      ),
	      _pexui.React.createElement(
	        'div',
	        { className: 'infw-yodlee-how-text-area' },
	        _pexui.React.createElement(_html.Html, {
	          tag: 'p',
	          id: 'infw_yodlee_home_item_' + stepNumber,
	          className: 'infw-list-text-rws',
	          content: prependLeadingNumber((0, _pexui._n)('yodlee.home.item.' + stepNumber), stepNumber)
	        }),
	        _pexui.React.createElement(_html.Html, {
	          tag: 'p',
	          id: 'infw_yodlee_home_desc_' + stepNumber,
	          className: 'infw-yodlee-step-desc',
	          content: 'yodlee.home.desc.' + stepNumber,
	          hideEmpty: true
	        })
	      )
	    )
	  );
	};
	
	var defaultIcons = ['dls-icon-bank', 'dls-icon-lock', 'dls-icon-time'];
	
	var howToSteps = function howToSteps(props) {
	  var contents = [];
	  var stepNumber = 1;
	  while ((0, _pexui._n)('yodlee.home.item.' + stepNumber)) {
	    contents.push(_pexui.React.createElement(HowToStep, {
	      stepNumber: stepNumber,
	      icon: (0, _pexui._n)('yodlee.home.icon.' + stepNumber) || (stepNumber <= 3 ? defaultIcons[stepNumber - 1] : '')
	    }));
	    ++stepNumber;
	  }
	  return contents;
	};
	
	var YodleePage = exports.YodleePage = function (_YodleeBasePage) {
	  _inherits(YodleePage, _YodleeBasePage);
	
	  function YodleePage(props) {
	    _classCallCheck(this, YodleePage);
	
	    var _this = _possibleConstructorReturn(this, (YodleePage.__proto__ || Object.getPrototypeOf(YodleePage)).call(this, props));
	
	    _this.state = {
	      tncConfirmed: false
	    };
	    return _this;
	  }
	
	  _createClass(YodleePage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _flow.flow.lastChannel = 'YODLEE';
	      (0, _track.track)('Yodlee:TnC', { contentName: (0, _flow.getTrackLabel)(_flow.flow.currNode) });
	    }
	  }, {
	    key: 'onConfirm',
	    value: function onConfirm(evt) {
	      this.setState({ tncConfirmed: evt.target.checked });
	    }
	  }, {
	    key: 'getTnCText',
	    value: function getTnCText() {
	      var text = utils.getElement('infw_yodlee_tnc').innerText;
	      // text = text.replace(/[^\w\.,]/g, ' ');
	      return text;
	    }
	  }, {
	    key: 'handleTncCheckbox',
	    value: function handleTncCheckbox(_ref2) {
	      var keyCode = _ref2.keyCode;
	
	      var spacebarKeyCode = 32;
	
	      if (keyCode === spacebarKeyCode) {
	        setTimeout(function () {
	          return document.getElementById('infw_check_yodlee_tnc').focus();
	        }, 500);
	      }
	    }
	  }, {
	    key: 'onPrint',
	    value: function onPrint(evt) {
	      evt.preventDefault();
	
	      (0, _track.trackClick)('Click_Print');
	
	      (0, _print.printElements)(['infw_yodlee_howto', 'infw_yodlee_tnc'], '.infw-circle-badge-icon{display:none;}\n         #infw_yodlee_howto p.body-1.margin-0-b.printable{font-weight:bold;font-size:150%;}\n        ');
	    }
	  }, {
	    key: 'submitYodleeRequest',
	    value: function submitYodleeRequest() {
	      var _this2 = this;
	
	      (0, _track.trackClick)('TnCContinue');
	      if (this.state.tncConfirmed) {
	        _flow.flow.lastNodeForYodlee = _flow.flow.currNode;
	        _flow.flow.lastNodeForYodlee.messages = [];
	        _flow.flow.yodleeAttributes = ''; // clean any previous value
	        _flow.flow.tnc = '';
	
	        var tnc = this.getTnCText();
	
	        // in parallel
	        var callSaveTnc = _docuploadsvc.DocUploadService.saveTnCAcceptance(_flow.flow.req.transaction_id, _flow.flow.req.originator_id, _flow.flow.req.document_data.process_control_number, 'YODLEE', tnc, true);
	
	        // TODO - uncomment when yodleeOptOut screen is implemented
	        // const isCheckingOptInStatus = flow.isRecurr && flow.is_sso_flow;
	        var isCheckingOptInStatus = false;
	        var conditionallyCallOptInStatus = isCheckingOptInStatus ? _docuploadsvc.DocUploadService.getOptInStatus(_flow.flow.req).then(function (response) {
	          _flow.flow.isOptIn = response.opt_status && response.opt_status === 'OPTED-IN';
	        }) : Promise.resolve();
	
	        // when all finish
	        utils.Promise.all([callSaveTnc, conditionallyCallOptInStatus]).then(function () {
	          (0, _busy.stopBusy)();
	          if (_flow.flow.isOptIn) {
	            // TODO - add yodleeOptOut screen
	            _this2.props.widget.nav('yodleeOptOut');
	          } else {
	            _this2.props.widget.nav('yodleeSubmit');
	          }
	        }).catch(function (err) {
	          console.error(err);
	          var errorKey = 'Yodlee.failed.message';
	          _flow.flow.lastError = 'failed';
	          _flow.flow.addMessage('!' + (0, _pexui._n)(errorKey), errorKey);
	          (0, _busy.stopBusy)();
	          _this2.props.widget.nav('index');
	        });
	      } else {
	        (0, _busy.stopBusy)();
	        (0, _dialog.showError)('Please confirm the terms and conditions!');
	      }
	    }
	  }, {
	    key: 'hasFooter',
	    value: function hasFooter() {
	      return true;
	    }
	  }, {
	    key: 'hasHelp',
	    value: function hasHelp() {
	      return true;
	    }
	  }, {
	    key: 'getFooterButtons',
	    value: function getFooterButtons() {
	      var yodleeOnly = _flow.flow.isYodleeOnly();
	      return [{
	        id: 'infw_btn_cancel_yodlee',
	        label: (0, _pexui._n)('yodlee.tnc.button_cancel'),
	        isPrimary: false,
	        onClick: this.onCancel.bind(this)
	      }, {
	        id: 'infw_btn_continue',
	        label: (0, _pexui._n)('yodlee.tnc.button_continue'),
	        isPrimary: true,
	        disabled: !this.state.tncConfirmed,
	        busyZone: 'widget',
	        onClick: this.submitYodleeRequest.bind(this)
	      }];
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var tncPdfUrl = utils.getUrlFromResource('yodlee.tnc.pdf');
	
	      return _pexui.React.createElement(
	        'div',
	        { className: 'card' },
	        _pexui.React.createElement(
	          'div',
	          { className: 'infw-message-wrapper' },
	          _pexui.React.createElement(_html.Html, { className: 'infw-message', content: 'yodlee.home.title' })
	        ),
	        _pexui.React.createElement('hr', { className: 'card-separator' }),
	        _pexui.React.createElement(
	          'div',
	          { id: 'infw_yodlee_howto', className: 'infw-yodlee-how-container1' },
	          _pexui.React.createElement(
	            'div',
	            { className: 'infw-yodlee-how-container2' },
	            _pexui.React.createElement(
	              'div',
	              { className: 'infw-yodlee-how-container3' },
	              _pexui.React.createElement(_html.Html, {
	                tag: 'p',
	                className: 'infw-yodlee-how-subtitle',
	                content: 'yodlee.home.how'
	              })
	            ),
	            _pexui.React.createElement(
	              'span',
	              { role: 'list' },
	              howToSteps()
	            )
	          ),
	          _pexui.React.createElement('hr', { className: 'card-separator' })
	        ),
	        _pexui.React.createElement(_html.Html, { id: 'infw_yodlee_tnc', className: 'infw-yodlee-tnc-box', content: 'yodlee.tnc.stmt' }),
	        _pexui.React.createElement(
	          'div',
	          { id: 'infw_yodlee_tnc_op_links', className: 'infw-yodlee-tnc-links' },
	          _pexui.React.createElement(
	            'a',
	            {
	              id: 'infw_link_yodlee_print',
	              onClick: this.onPrint.bind(this),
	              href: tncPdfUrl
	            },
	            (0, _pexui._n)('yodlee.tnc.button_print')
	          ),
	          _pexui.React.createElement(
	            'span',
	            null,
	            ' | '
	          ),
	          _pexui.React.createElement(
	            'a',
	            {
	              id: 'infw_link_yodlee_save',
	              onClick: function onClick(evt) {
	                (0, _track.trackClick)('Click_Save');
	              },
	              href: tncPdfUrl,
	              target: '_blank'
	            },
	            (0, _pexui._n)('yodlee.tnc.button_save')
	          )
	        ),
	        _pexui.React.createElement('hr', { className: 'card-separator' }),
	        _pexui.React.createElement(
	          'div',
	          { className: 'infw-yodlee-tnc-confirm-container1' },
	          _pexui.React.createElement(
	            'div',
	            { className: 'infw-yodlee-tnc-confirm-container2' },
	            _pexui.React.createElement(
	              'div',
	              { className: 'infw-yodlee-tnc-confirm-container-chk' },
	              _pexui.React.createElement('input', {
	                type: 'checkbox',
	                'aria-label': 'tnc confirmation checkbox',
	                id: 'infw_check_yodlee_tnc',
	                className: 'infw-checkbox',
	                checked: this.state.tncConfirmed,
	                onClick: this.onConfirm.bind(this),
	                onKeyDown: this.handleTncCheckbox.bind(this)
	              })
	            ),
	            _pexui.React.createElement(
	              'label',
	              { 'for': 'infw_check_yodlee_tnc' },
	              (0, _pexui._n)('yodlee.tnc.confirm.label')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return YodleePage;
	}(_yodleebase.YodleeBasePage);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.YodleeBasePage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _base = __webpack_require__(84);
	
	var _dialog = __webpack_require__(88);
	
	var _flow = __webpack_require__(10);
	
	var _track = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YodleeBasePage = exports.YodleeBasePage = function (_BasePage) {
	    _inherits(YodleeBasePage, _BasePage);
	
	    function YodleeBasePage(props) {
	        _classCallCheck(this, YodleeBasePage);
	
	        delete props.onClose;
	        return _possibleConstructorReturn(this, (YodleeBasePage.__proto__ || Object.getPrototypeOf(YodleeBasePage)).call(this, props));
	    }
	
	    _createClass(YodleeBasePage, [{
	        key: 'hasFooter',
	        value: function hasFooter() {
	            return false;
	        }
	    }, {
	        key: 'hasHelp',
	        value: function hasHelp() {
	            return false;
	        }
	    }, {
	        key: 'getFooterButtons',
	        value: function getFooterButtons() {
	            return [{
	                id: 'infw_btn_exit_yodlee',
	                label: (0, _pexui._n)('exit.yodlee.label'),
	                isPrimary: false,
	                onClick: this.onCancel.bind(this)
	            }];
	        }
	    }, {
	        key: 'onCancel',
	        value: function onCancel(evt) {
	            var widget = this.props.widget;
	            if (_flow.flow.isYodleeOnly()) {
	                widget.onClose();
	            } else {
	                (0, _track.track)("Yodlee:Exit", { contentName: (0, _flow.getTrackLabel)(_flow.flow.getCurrentNode()) });
	
	                _pexui.React.createElement(_dialog.ExitYodleeDialog, {
	                    onSelect: function onSelect(value) {
	                        if (value === 'yes') {
	                            (0, _track.track)("Yodlee:Exit:YesExit", { contentName: (0, _flow.getTrackLabel)(_flow.flow.getCurrentNode()) });
	                            widget.nav('index');
	                        } else {
	                            (0, _track.trackClick)('Click_NoGoBack');
	                        }
	                    }
	                }).show();
	            }
	        }
	    }]);
	
	    return YodleeBasePage;
	}(_base.BasePage);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.printElements = printElements;
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function printElementsForChrome(elements, styles) {
	    var chromePrintTemplate = '\n        <head>\n            <style>' + styles + '</style>\n        </head>\n        <body>\n            ' + elements.map(function (elemId) {
	        return utils.getElement(elemId).outerHTML;
	    }) + '\n        </body>\n    ';
	    var html = document.getElementsByTagName('HTML')[0];
	    var printElement = document.createElement('div');
	    var uniqueId = 'get-info-tnc-' + Math.floor(Math.random() * 20);
	    var originalDocumentTitle = document.title;
	    // add print elements
	    printElement.setAttribute('id', uniqueId);
	    printElement.innerHTML = chromePrintTemplate;
	    html.appendChild(printElement);
	    document.title = 'Terms and Conditions';
	
	    window.print();
	    // remove print elements
	    html.removeChild(document.getElementById(uniqueId));
	    document.title = originalDocumentTitle;
	}
	
	function printElements(elements, styles) {
	    if (!!window.chrome) {
	        // we're using @media print for chrome to avoid pop up off focus issues
	        return printElementsForChrome(elements, styles);
	    }
	
	    var printTemplate = '<html>\n        <head>\n            <style>\n                ' + styles + '\n            </style>\n        </head>\n        <body>\n            ' + elements.map(function (elemId) {
	        return utils.getElement(elemId).outerHTML;
	    }) + '\n        </body>\n    </html>';
	    var printWindow = open('', '', 'left=0,top=0,width=1000,height=700,toolbar=0,scrollbars=0,status=0');
	
	    printWindow.document.write(printTemplate);
	    printWindow.document.close();
	    printWindow.focus();
	    printWindow.print();
	    printWindow.close();
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ThankYouPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _base = __webpack_require__(84);
	
	var _uicomps = __webpack_require__(85);
	
	var _files = __webpack_require__(97);
	
	var _html = __webpack_require__(89);
	
	var _flow = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThankYouPage = exports.ThankYouPage = function (_BasePage) {
	    _inherits(ThankYouPage, _BasePage);
	
	    function ThankYouPage(props) {
	        _classCallCheck(this, ThankYouPage);
	
	        return _possibleConstructorReturn(this, (ThankYouPage.__proto__ || Object.getPrototypeOf(ThankYouPage)).call(this, props));
	    }
	
	    _createClass(ThankYouPage, [{
	        key: 'hasHelp',
	        value: function hasHelp() {
	            return false;
	        }
	    }, {
	        key: 'getFooterButtons',
	        value: function getFooterButtons() {
	            var _this2 = this;
	
	            return [{
	                id: 'infw_btn_finish',
	                className: 'infw-btn-primary',
	                label: (0, _pexui._n)('thankyou.finish.label'),
	                isPrimary: true,
	                onClick: function onClick(evt) {
	                    return _this2.props.widget.onSubmit();
	                }
	            }];
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            var node = _flow.flow.getCurrentNode();
	            var panelTitle = (0, _pexui._n)(node.widgetOption.content_id + '.title', { business_name: node.account.organization_name });
	
	            return [_pexui.React.createElement(
	                'div',
	                { className: 'infw-message-wrapper' },
	                _pexui.React.createElement(_html.Html, { className: 'infw-message',
	                    content: 'widget.message'
	                })
	            ), _pexui.React.createElement(
	                'div',
	                { className: 'infw-single-box' },
	                _pexui.React.createElement(
	                    'div',
	                    { className: 'infw-accordion-header' },
	                    panelTitle
	                ),
	                _pexui.React.createElement(_files.FilesList, { files: node.files,
	                    node: node }),
	                _pexui.React.createElement('div', { className: 'pad-2' })
	            )];
	        }
	    }]);
	
	    return ThankYouPage;
	}(_base.BasePage);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YodleeSubmitPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.isSSO = isSSO;
	exports.getCallbackUri = getCallbackUri;
	exports.getSsoDomain = getSsoDomain;
	
	var _pexui = __webpack_require__(2);
	
	var _lodash = __webpack_require__(69);
	
	var _yodleebase = __webpack_require__(105);
	
	var _yodleeForm = __webpack_require__(109);
	
	var _base = __webpack_require__(84);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _postMessageHandler = __webpack_require__(110);
	
	var _postMessageHandler2 = _interopRequireDefault(_postMessageHandler);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _flow = __webpack_require__(10);
	
	var _consts = __webpack_require__(65);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _dtm = __webpack_require__(64);
	
	var _track = __webpack_require__(11);
	
	var _accountVerificationModal = __webpack_require__(111);
	
	var _accountVerificationModal2 = _interopRequireDefault(_accountVerificationModal);
	
	var _missingDetailsHeader = __webpack_require__(112);
	
	var _missingDetailsHeader2 = _interopRequireDefault(_missingDetailsHeader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YODLEE_LOAD_TIMEOUT = 60000; // 1 minute
	
	function isSSO() {
	  return _flow.flow.req.is_single_sign_on || _flow.flow.req.is_sso;
	}
	
	function getCallbackUri() {
	  return (0, _pexui.joinUrl)(getSsoDomain(), 'yodleeresponse.html?orginatorid=' + _flow.flow.req.transaction_id);
	}
	
	function getSsoDomain() {
	  return (0, _pexui.joinUrl)(utils.getBaseUri(), 'yodlee/');
	}
	
	var updateLastNodeForYodlee = function updateLastNodeForYodlee() {
	  _flow.flow.lastNodeForYodlee.done = true;
	
	  var yodleeDocOpt = utils.findArray(_flow.flow.lastNodeForYodlee.widgetOption.document_types, function (docOpt) {
	    return docOpt.document_option === 'Yodlee';
	  });
	
	  if (yodleeDocOpt) {
	    yodleeDocOpt.done = true;
	    yodleeDocOpt.completedTime = new Date();
	  }
	  // add a pseudo file for Yodlee result
	  _flow.flow.lastNodeForYodlee.files.push({
	    type: 'info',
	    name: (0, _pexui._n)('Yodlee.success.message'),
	    originalName: (0, _pexui._n)('Yodlee.success.message'),
	    completedTime: new Date()
	  });
	};
	
	var formatYodleeResponse = function formatYodleeResponse(yodleeResp, isYsl) {
	  var yslResponse = {
	    account_level_data: yodleeResp.sites,
	    global_unique_id: yodleeResp.GUID,
	    geo_location: _flow.flow.req.market,
	    is_unregister: !_flow.flow.isRecurr
	  };
	
	  var response = {
	    global_unique_id: yodleeResp.GUID,
	    geo_location: _flow.flow.req.market,
	    is_unregister: !_flow.flow.isRecurr,
	    yodlee_xref_id: yodleeResp.appID,
	    segment_code: yodleeResp.Segment,
	    action: yodleeResp.Action,
	    snapshot_required_indicator: yodleeResp.SNAPSHOT_REQUIRED
	  };
	
	  return isYsl ? yslResponse : response;
	};
	
	var constructResponseToInvoker = function constructResponseToInvoker(yodleeResp, isYsl) {
	  var responseToInvoker = {
	    transaction_id: _flow.flow.transaction_id,
	    process_control_number: _flow.flow.req.document_data.process_control_number,
	    submission_channel_code: 'YDL',
	    documents_requested_code: _flow.flow.lastNodeForYodlee.code,
	    received_timestamp: utils.getTimestamp(),
	    yodlee_response: formatYodleeResponse(yodleeResp, isYsl)
	  };
	
	  if (_flow.flow.lastNodeForYodlee.account && _flow.flow.lastNodeForYodlee.account.customer_id) {
	    responseToInvoker.customer_id = _flow.flow.lastNodeForYodlee.account.customer_id;
	  }
	
	  if (_flow.flow.lastNodeForYodlee.account && _flow.flow.lastNodeForYodlee.account.organization_id) {
	    responseToInvoker.organization_id = _flow.flow.lastNodeForYodlee.account.organization_id;
	  }
	
	  return responseToInvoker;
	};
	
	var saveSuccessResponse = function saveSuccessResponse(yodleeResp, isYsl) {
	  var data = isYsl ? {
	    guid: yodleeResp.GUID,
	    account_level_data: JSON.stringify(yodleeResp.sites)
	  } : {
	    guid: yodleeResp.GUID,
	    app_id: yodleeResp.appID,
	    action: yodleeResp.Action,
	    segment: yodleeResp.Segment,
	    snapshot_required: yodleeResp.SNAPSHOT_REQUIRED
	  };
	
	  _docuploadsvc.DocUploadService.saveYodleeResponse(_flow.flow.transaction_id, data).then(function () {
	    return console.log('Yodlee response has been saved.');
	  });
	};
	
	var handleError = function handleError(lastError, flowMessage, errorMessage) {
	  _docuploadsvc.DocUploadService.saveYodleeResponse(_flow.flow.transaction_id, {
	    error: errorMessage
	  });
	  _flow.flow.lastError = lastError;
	  _flow.flow.addMessage('!' + (0, _pexui._n)(flowMessage), flowMessage);
	};
	
	var YodleeSubmitPage = exports.YodleeSubmitPage = function (_YodleeBasePage) {
	  _inherits(YodleeSubmitPage, _YodleeBasePage);
	
	  function YodleeSubmitPage(props) {
	    _classCallCheck(this, YodleeSubmitPage);
	
	    var _this = _possibleConstructorReturn(this, (YodleeSubmitPage.__proto__ || Object.getPrototypeOf(YodleeSubmitPage)).call(this, props));
	
	    _this.timeoutHandler = null;
	    _this.state = {
	      fgMismatchErrors: [],
	      failedIdentifiers: [],
	      usableIdentifiers: [],
	      submitAttempts: 1,
	      showConfirmationModal: false,
	      yodleeResponse: null
	    };
	
	    _this.addSpinner = _this.addSpinner.bind(_this);
	    _this.handleFgMismatchError = _this.handleFgMismatchError.bind(_this);
	    _this.handleYodleeSuccess = _this.handleYodleeSuccess.bind(_this);
	    _this.messageHandler = _this.messageHandler.bind(_this);
	    _this.accountStatusMessageHandler = _this.accountStatusMessageHandler.bind(_this);
	    _this.onFrameLoad = _this.onFrameLoad.bind(_this);
	    _this.renderMissingDetailsHeader = _this.renderMissingDetailsHeader.bind(_this);
	    _this.renderConfirmationModal = _this.renderConfirmationModal.bind(_this);
	    _this.removeSpinner = _this.removeSpinner.bind(_this);
	    _this.sendResponseToInvoker = _this.sendResponseToInvoker.bind(_this);
	    _this.validateAccountDetails = _this.validateAccountDetails.bind(_this);
	    _this.infoYodleeTrackHandler = _this.infoYodleeTrackHandler.bind(_this);
	    _this.postMessageHandler = (0, _postMessageHandler2.default)(function (origin) {
	      var baseUri = utils.getBaseUri().replace(/\/$/, '');
	      return origin === baseUri || /^https:\/\/finapp\.[a-z]*\.yodlee.com(?:.[a-z]{2}|)$/.test(origin);
	    });
	    return _this;
	  }
	
	  _createClass(YodleeSubmitPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addSpinner();
	      this.initializeYodleeForm();
	    }
	  }, {
	    key: 'addSpinner',
	    value: function addSpinner() {
	      var yodleeIframe = document.getElementById('yodlee-iframe');
	      var yodleeSpinner = _pexui.React.createElement(
	        'div',
	        { id: 'yodlee-spinner' },
	        _pexui.React.createElement('div', { className: 'progress-circle progress-indeterminate dls-accent-white-01-bg' })
	      );
	      var existingYodleeSpinner = document.getElementById('yodlee-spinner');
	
	      // only add spinner if one doesn't exist
	      if (!existingYodleeSpinner) {
	        setTimeout(function () {
	          return yodleeIframe.appendChild(yodleeSpinner);
	        }, 500);
	      }
	    }
	  }, {
	    key: 'removeSpinner',
	    value: function removeSpinner() {
	      var yodleeSpinner = document.getElementById('yodlee-spinner');
	
	      if (yodleeSpinner) {
	        yodleeSpinner.parentNode.removeChild(yodleeSpinner);
	        setTimeout(this.removeSpinner, 500);
	      }
	    }
	  }, {
	    key: 'initializeYodleeForm',
	    value: function initializeYodleeForm() {
	      var _this2 = this;
	
	      this.timeoutHandler = setTimeout(function () {
	        console.error('Times out accessing Yodlee page.');
	        var errorKey = 'error.FG_failed.message';
	        _flow.flow.addMessage('!' + (0, _pexui._n)(errorKey), errorKey);
	        _this2.props.widget.nav('index');
	      }, YODLEE_LOAD_TIMEOUT);
	
	      this.postMessageHandler.on('yodlee_success', this.messageHandler);
	      this.postMessageHandler.on('yodlee_login_error', this.messageHandler);
	      this.postMessageHandler.on('yodlee_session_error', this.messageHandler);
	      this.postMessageHandler.on('yodlee_tech_error', this.messageHandler);
	      this.postMessageHandler.on('yodlee_default_error', this.messageHandler);
	      this.postMessageHandler.on({ fnToCall: 'accountStatus' }, this.accountStatusMessageHandler);
	      this.postMessageHandler.on({ fnToCall: 'infoYodlee' }, this.infoYodleeTrackHandler);
	      this.postMessageHandler.on({ fnToCall: 'submitAction', action: 'exit' }, function (data) {
	        return _this2.validateAccountDetails(data, true);
	      });
	      this.postMessageHandler.on({ fnToCall: 'ssoErrorHandle' }, function (data) {
	        var errorCode = data.errorCode,
	            errorSummary = data.errorSummary;
	        // 3rd party cookie error
	
	        if (errorCode === 1012 || errorCode === '1012') {
	          handleError('sso_tech', 'error.FG_failed.message', 'SSO technical difficulty error. Third party cookie error. Error Params code: ' + errorCode + ', summary: ' + errorSummary);
	        } else {
	          handleError('sso_session', 'Yodlee.failed.message', 'SSO technical difficulty error. Error Params: ' + errorSummary);
	        }
	        if (!_flow.flow.isYodleeOnly()) {
	          _flow.flow.widget.nav('index');
	        }
	      });
	
	      var handleDebouncedWindowSize = (0, _lodash.debounce)(function (height) {
	        var newHeight = height > 500 ? height : 500;
	        document.getElementById('yodlee-iframe').style.height = newHeight + 'px';
	      }, 550, { trailing: true });
	
	      this.postMessageHandler.on({ fnToCall: 'newThemeResizeFloater' }, function (_ref) {
	        var height = _ref.height;
	
	        handleDebouncedWindowSize(height);
	      });
	    }
	  }, {
	    key: 'infoYodleeTrackHandler',
	    value: function infoYodleeTrackHandler(data) {
	      var category = data.category,
	          element = data.element,
	          pagePath = data.page_path,
	          pageTitle = data.page_title;
	
	      var formatToPascalCase = function formatToPascalCase(str) {
	        var camelCaseString = (0, _lodash.camelCase)(str);
	
	        return '' + camelCaseString.charAt(0).toUpperCase() + camelCaseString.slice(1);
	      };
	
	      var getBankName = function getBankName(pagePath) {
	        return pagePath.split('/').length >= 4 ? pagePath.split('/')[3] : '';
	      };
	
	      var _flow$req = _flow.flow.req,
	          transactionId = _flow$req.transaction_id,
	          originatorId = _flow$req.originator_id,
	          market = _flow$req.market;
	
	
	      _docuploadsvc.DocUploadService.log2Server({
	        transaction_id: transactionId,
	        log_type: 'INFO',
	        originator_id: originatorId,
	        country_code: market,
	        log_message: 'Info event from Yodlee: ' + JSON.stringify(data)
	      });
	
	      if (category === 'click') {
	        // format - :Element
	        return (0, _track.trackClick)('' + formatToPascalCase(element));
	      }
	
	      if (category === 'page_view') {
	        // format - Yodlee:PageTitle
	        return (0, _track.track)('Yodlee:' + formatToPascalCase(pageTitle), { bankName: getBankName(pagePath) });
	      }
	      // all events have category as far as we know
	      if (category) {
	        // format - SomeCategory
	        return (0, _track.track)(formatToPascalCase(category));
	      }
	    }
	  }, {
	    key: 'sendResponseToInvoker',
	    value: function sendResponseToInvoker(responseToInvoker) {
	      if (_flow.flow.isYodleeOnly()) {
	        (0, _track.track)('Yodlee:Success', { contentName: (0, _flow.getTrackLabel)(_flow.flow.lastNodeForYodlee) });
	        (0, _track.track)('ThankYou', { events: _consts.SUCCESSFUL_COMPLETED_JOURNEY_EVENT });
	        _flow.flow.raiseInvokerEvent('yodleeResponse', responseToInvoker);
	
	        if (typeof _globals2.default.displayMode === 'string' && _globals2.default.displayMode.indexOf('THANKYOU') >= 0) {
	          _flow.flow.widget.nav('thankyou');
	        } else if (utils.getElement('infw_btn_exit_yodlee')) {
	          utils.getElement('infw_btn_exit_yodlee').disabled = true;
	        }
	      } else {
	        (0, _track.track)('Yodlee:Success', { contentName: (0, _flow.getTrackLabel)(_flow.flow.lastNodeForYodlee) });
	        _flow.flow.raiseInvokerEvent('yodleeResponse', responseToInvoker);
	      }
	    }
	  }, {
	    key: 'handleYodleeSuccess',
	    value: function handleYodleeSuccess(yodleeResp, isYsl) {
	      this.addSpinner();
	      var responseToInvoker = constructResponseToInvoker(yodleeResp, isYsl);
	
	      saveSuccessResponse(yodleeResp, isYsl);
	      updateLastNodeForYodlee();
	      this.sendResponseToInvoker(responseToInvoker);
	    }
	  }, {
	    key: 'handleFgMismatchError',
	    value: function handleFgMismatchError(error) {
	      this.setState({
	        // error parameter will either be an array of error objects or a single error object
	        fgMismatchErrors: (0, _lodash.isArray)(error) ? error.map(function (i) {
	          return i.message;
	        }) : [error.message],
	        submitAttempts: this.state.submitAttempts + 1
	      });
	
	      if ((0, _lodash.isArray)(error)) {
	        return error.forEach(function (_ref2) {
	          var errorKey = _ref2.errorKey;
	          return (0, _track.trackError)(errorKey);
	        });
	      }
	
	      var errorKey = error.errorKey;
	
	
	      (0, _track.trackError)(errorKey);
	    }
	  }, {
	    key: 'handleAllAttemptsFailed',
	    value: function handleAllAttemptsFailed(yodleeResp, isYsl) {
	      // hide confirmation modal
	      this.setState({ showConfirmationModal: false });
	      // display spinner for yodlee only scenarios
	      this.addSpinner();
	      // if not just yodlee flow re-route to index and display error message
	      if (!_flow.flow.isYodleeOnly()) {
	        _flow.flow.addMessageToCurrentNode((0, _pexui._n)('yodlee.fg.match.error.all.attempts'));
	        _flow.flow.widget.nav('index');
	      }
	
	      var error = 'Three (3) unsuccessful attempts have been made.';
	      // notify invoker with postmessage type 'fail'
	
	      var formattedYodleeMetadata = formatYodleeResponse(yodleeResp, isYsl);
	      _flow.flow.raiseInvokerEvent('fail', error, formattedYodleeMetadata);
	      // save yodlee response to service
	      _docuploadsvc.DocUploadService.saveYodleeResponse(_flow.flow.transaction_id, { error: error });
	
	      (0, _track.trackExit)();
	    }
	  }, {
	    key: 'hasFooter',
	    value: function hasFooter() {
	      return true;
	    }
	  }, {
	    key: 'messageHandler',
	    value: function messageHandler(data) {
	      var messageType = utils.determineMessageType(data);
	      switch (messageType) {
	        case 'yodlee_success':
	          var isYsl = false;
	          var yodleeResp = utils.parseYodleeResponse(data.substring(15));
	          return this.validateAccountDetails(yodleeResp, isYsl);
	        case 'yodlee_login_error':
	          handleError('sso_login', 'error.FG_failed.message', 'SSO login error');
	          break;
	        case 'yodlee_session_error':
	          handleError('sso_session', 'error.FG_failed.message', 'SSO stale session error');
	          break;
	        case 'yodlee_tech_error':
	          //Reading error querystring params
	          var yodleeErrorResponseQueryParams = void 0;
	          if (data && data.indexOf("yodlee_tech_error:" !== -1)) {
	            yodleeErrorResponseQueryParams = data.substring('yodlee_tech_error:'.length);
	          }
	          if (yodleeErrorResponseQueryParams && /cookieDisabled=true/.test(yodleeErrorResponseQueryParams)) {
	            handleError('sso_tech', 'error.FG_failed.message', 'SSO technical difficulty error. Third party cookie error. Error Params: ' + yodleeErrorResponseQueryParams, skipResponseToInvoker);
	          } else if (yodleeErrorResponseQueryParams) {
	            handleError('sso_tech', 'error.FG_failed.message', 'SSO technical difficulty error. Error Params: ' + yodleeErrorResponseQueryParams);
	          } else {
	            handleError('sso_tech', 'error.FG_failed.message', 'SSO technical difficulty error.');
	          }
	          break;
	        case 'yodlee_default_error':
	          handleError('sso_default', 'Yodlee.failed.message', 'SSO default error');
	          break;
	      }
	
	      if (!_flow.flow.isYodleeOnly()) {
	        _flow.flow.widget.nav('index');
	      }
	    }
	  }, {
	    key: 'accountStatusMessageHandler',
	    value: function accountStatusMessageHandler(data) {
	      //'accountStatus' event as a result of user submit in Fastlink 2.5 (previously used for AU and CA).
	      if ((0, _lodash.isObject)(data) && data.action === 'exit') {
	        var isYsl = true;
	        return this.handleYodleeSuccess(JSON.parse(data.sites.JSONCallbackStatus), isYsl);
	      }
	      //'accountStatus' event as a result of fastlink errors like login failures, failure connect to banks etc... 
	      //Just logging the data. The error message for user will be displayed at Fastlink. 
	      var _flow$req2 = _flow.flow.req,
	          transactionId = _flow$req2.transaction_id,
	          originatorId = _flow$req2.originator_id,
	          market = _flow$req2.market;
	
	      return _docuploadsvc.DocUploadService.log2Server({
	        transaction_id: transactionId,
	        log_type: 'WARN',
	        originator_id: originatorId,
	        country_code: market,
	        log_message: 'Warning event from Yodlee: ' + JSON.stringify(data)
	      });
	    }
	  }, {
	    key: 'validateAccountDetails',
	    value: function validateAccountDetails(yodleeResp, isYsl) {
	      var _this3 = this;
	
	      this.addSpinner();
	      // TODO - handle YSL payload with isYsl arg
	      return _docuploadsvc.DocUploadService.validateAccountDetails(yodleeResp, this.state.submitAttempts, isYsl).then(function (res) {
	        var failedIdentifiers = res.failed_identifiers,
	            statusCode = res.status_code,
	            usableIdentifiers = res.usable_identifiers;
	
	
	        if (statusCode === 200) {
	          // usableIdentifiers will only be available in the response when
	          // 3 attempts have been made and at least one failed account exists
	          if (usableIdentifiers) {
	            return _this3.setState({
	              failedIdentifiers: failedIdentifiers,
	              usableIdentifiers: usableIdentifiers,
	              showConfirmationModal: true,
	              yodleeResponse: yodleeResp,
	              submitAttempts: _this3.state.submitAttempts + 1
	            });
	          }
	
	          _this3.handleYodleeSuccess(yodleeResp, isYsl);
	
	          if (!_flow.flow.isYodleeOnly()) {
	            return _flow.flow.widget.nav('index');
	          }
	
	          return _this3.addSpinner();
	        }
	
	        // any failure after 3 attemps will trigger dead end scenario
	        if (_this3.state.submitAttempts > 2) {
	          return _this3.handleAllAttemptsFailed(yodleeResp, isYsl);
	        }
	
	        // 1. Error from FG mismatch API: Response code is null
	        // 2. Error from FG mismatch API: account_level_identifiers was null
	        // 3. Error from FG mismatch API: Received FG_BANKDATA_200 or FG_BANKDATA_451, but account_level_identifiers was null
	        if (statusCode === 501) {
	          return _this3.handleFgMismatchError({
	            message: (0, _pexui._n)('yodlee.fg.match.error'),
	            errorKey: 'yodlee.fg.match.error'
	          });
	        }
	
	        // 1. Failed identifiers exist
	        if (statusCode === 400) {
	          if (res.failed_identifiers.length) {
	            var errors = res.failed_identifiers.map(function (identifier) {
	              var errorKey = 'yodlee.fg.match.error.' + identifier.reject_reason_code;
	              var errorString = (0, _pexui._n)(errorKey);
	              return identifier.bank_name ? {
	                message: identifier.bank_name + ': ' + errorString,
	                errorKey: errorKey
	              } : {
	                message: 'Acct No X-' + identifier.account_number_ending_4_digits + ': ' + errorString,
	                errorKey: errorKey
	              };
	            });
	
	            return _this3.handleFgMismatchError(errors);
	          }
	          // render generic error if no identifiers exist
	          return _this3.handleFgMismatchError({
	            message: (0, _pexui._n)('yodlee.fg.match.error'),
	            errorKey: 'yodlee.fg.match.error'
	          });
	        }
	      }, function (err) {
	        // 1. socket hangup
	        // 2. responseBody.error_cd is null
	        // 3. responseCode is not FG_BANKDATA_200 or FG_BANKDATA_451
	        if (_this3.state.submitAttempts > 2) {
	          return _this3.handleAllAttemptsFailed(yodleeResp, isYsl);
	        }
	
	        return _this3.handleFgMismatchError({
	          message: (0, _pexui._n)('yodlee.fg.match.error'),
	          errorKey: 'yodlee.fg.match.error'
	        });
	      });
	    }
	  }, {
	    key: 'handleAccountVerificationResponse',
	    value: function handleAccountVerificationResponse(action) {
	      this.addSpinner();
	      var _flow$req3 = _flow.flow.req,
	          transaction_id = _flow$req3.transaction_id,
	          originator_id = _flow$req3.originator_id,
	          document_data = _flow$req3.document_data,
	          country_code = _flow$req3.market;
	      var process_control_number = document_data.process_control_number;
	      //Log account confirmation modal click event to server
	
	      _docuploadsvc.DocUploadService.log2Server({
	        transaction_id: transaction_id,
	        originator_id: originator_id,
	        process_control_number: process_control_number,
	        country_code: country_code,
	        log_type: 'INFO',
	        log_message: action === 'submit' ? 'User confirmed to provide partially approved Yodlee data' : 'User declined to provide partially approved Yodlee data'
	      });
	      // hide account confirmation modal
	      this.setState({ showConfirmationModal: false });
	      var currentNode = (0, _lodash.get)(_flow.flow, 'nodes', [])[0];
	      // invoke success response
	      if (action === 'submit') {
	        var yodleeResponse = this.state.yodleeResponse;
	
	
	        (0, _track.trackClick)('Click_Submit', { contentName: (0, _flow.getTrackLabel)(currentNode) });
	        var isYsl = !!yodleeResponse.sites;
	        this.handleYodleeSuccess(yodleeResponse, isYsl);
	      }
	      // invoke 'failed' message to parent - BAU
	      if (action === 'fail') {
	        _flow.flow.raiseInvokerEvent('fail', 'User cancelled');
	        (0, _track.trackClick)('Click_Decline', { contentName: (0, _flow.getTrackLabel)(currentNode) });
	      }
	
	      // if not just yodlee flow navigate to main index
	      if (!_flow.flow.isYodleeOnly()) {
	        return _flow.flow.widget.nav('index');
	      }
	    }
	  }, {
	    key: 'renderMissingDetailsHeader',
	    value: function renderMissingDetailsHeader() {
	      return this.state.fgMismatchErrors.length ? _pexui.React.createElement(_missingDetailsHeader2.default, { fgMismatchErrors: this.state.fgMismatchErrors }) : null;
	    }
	  }, {
	    key: 'renderConfirmationModal',
	    value: function renderConfirmationModal() {
	      var _this4 = this;
	
	      (0, _track.track)('VerifySubmit', { contentName: (0, _flow.getTrackLabel)((0, _lodash.get)(_flow.flow, 'nodes', [])[0]) });
	      return _pexui.React.createElement(_accountVerificationModal2.default, {
	        usableIdentifiers: this.state.usableIdentifiers,
	        failedIdentifiers: this.state.failedIdentifiers,
	        handleSubmit: function handleSubmit() {
	          return _this4.handleAccountVerificationResponse('submit');
	        },
	        handleDecline: function handleDecline() {
	          return _this4.handleAccountVerificationResponse('fail');
	        }
	      });
	    }
	  }, {
	    key: 'onFrameLoad',
	    value: function onFrameLoad(event) {
	      if (this.timeoutHandler) {
	        clearTimeout(this.timeoutHandler);
	        this.timeoutHandler = null;
	      }
	
	      this.removeSpinner();
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _state = this.state,
	          fgMismatchErrors = _state.fgMismatchErrors,
	          showConfirmationModal = _state.showConfirmationModal,
	          submitAttempts = _state.submitAttempts,
	          yodleeResponse = _state.yodleeResponse;
	
	      return _pexui.React.createElement(
	        'div',
	        { id: 'yodlee-submit' },
	        submitAttempts <= 3 && this.renderMissingDetailsHeader(),
	        showConfirmationModal && this.renderConfirmationModal(),
	        _pexui.React.createElement(
	          'div',
	          { id: 'yodlee-iframe' },
	          _pexui.React.createElement('iframe', {
	            ref: 'y_iframe',
	            id: 'y_iframe',
	            name: 'y_iframe',
	            frameBorder: '0',
	            onLoad: this.onFrameLoad
	          })
	        ),
	        submitAttempts <= 3 && !showConfirmationModal && _pexui.React.createElement(_yodleeForm.YodleeForm, {
	          addSpinner: this.addSpinner,
	          ssoEnabled: isSSO(),
	          callbackUri: getCallbackUri(),
	          ssodomain: getSsoDomain(),
	          locale: _flow.flow.req.market,
	          yodleeResponse: yodleeResponse
	        })
	      );
	    }
	  }]);
	
	  return YodleeSubmitPage;
	}(_yodleebase.YodleeBasePage);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YodleeForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _lodash = __webpack_require__(69);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _flow = __webpack_require__(10);
	
	var _track = __webpack_require__(11);
	
	var _dtm = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YodleeForm = exports.YodleeForm = function (_React$Component) {
	  _inherits(YodleeForm, _React$Component);
	
	  function YodleeForm(props) {
	    _classCallCheck(this, YodleeForm);
	
	    var _this = _possibleConstructorReturn(this, (YodleeForm.__proto__ || Object.getPrototypeOf(YodleeForm)).call(this, props));
	
	    _this.fetchYodleeAttributes = _this.fetchYodleeAttributes.bind(_this);
	    return _this;
	  }
	
	  _createClass(YodleeForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.addSpinner();
	      this.fetchYodleeAttributes();
	    }
	  }, {
	    key: 'fetchYodleeAttributes',
	    value: function fetchYodleeAttributes() {
	      var _this2 = this;
	
	      return _docuploadsvc.DocUploadService.getYodleeAttributes(_flow.flow.req).then(function (_ref) {
	        var isRecurr = _ref.isRecurr,
	            yodleeAttributes = _ref.yodleeAttributes,
	            providerSpecifics = _ref.providerSpecifics,
	            additionalYodleeParams = _ref.additionalYodleeParams;
	
	        _flow.flow.isRecurr = isRecurr;
	        _this2.refs.yodleeInput.value = yodleeAttributes;
	
	        if (providerSpecifics) {
	          providerSpecifics.map(function (_ref2, i) {
	            var param_name = _ref2.param_name,
	                param_value = _ref2.param_value;
	
	            var input = _pexui.React.createElement('input', {
	              type: 'hidden',
	              name: param_name,
	              id: 'provider-specifics-input-' + param_name + '-' + i,
	              value: param_value
	            });
	            _this2.refs.yodleeForm.appendChild(input);
	          });
	        }
	
	        if (additionalYodleeParams) {
	          var additionalParams = additionalYodleeParams.map(function (_ref3) {
	            var name = _ref3.name,
	                value = _ref3.value;
	            return '&' + name + '=' + value;
	          }).join('');
	
	          _this2.refs.extraParams.value = '' + _this2.refs.extraParams.value + additionalParams;
	        }
	
	        _this2.refs.yodleeForm.submit();
	      }).catch(function (err) {
	        var errorKey = 'Yodlee.failed.message';
	
	        _flow.flow.lastError = 'failed';
	        _flow.flow.addMessage('!' + (0, _pexui._n)(errorKey), errorKey);
	        _flow.flow.widget.nav('index');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var origin = window.location.origin;
	      var yodleeNonSSOActionURL = _globals2.default.config.yodleeNonSSOActionURL;
	
	      var yodleeErrorOption2 = 'postSource=usecase_1';
	      var pcn = (0, _lodash.get)(_flow.flow, 'req.document_data.process_control_number', 0);
	      var countryCode = (0, _lodash.get)(_flow.flow, 'req.market', 0);
	      var tabName = (0, _lodash.get)(_flow.flow, 'currNode', 0);
	      var questionNumber = (0, _track.getQuestionNumber)(_flow.flow.currNode);
	      var parentPageHierarchy = (0, _dtm.getDtmHierarchy)(countryCode) || 0;
	      var isDtm = (0, _track.getIsDtm)();
	      // ITAG requires tabName, but DTM requires questionNumber
	      var extraParams = ['callback=' + this.props.callbackUri + '&' + yodleeErrorOption2 + '&ssoDomain=', this.props.ssodomain + '&dynamicVal=' + pcn + '~~' + countryCode + '~~' + (isDtm ? questionNumber : tabName) + '~~', parentPageHierarchy + '~~0&locationurl=' + origin].join('');
	      var action = yodleeNonSSOActionURL;
	      // render yodlee form
	      return _pexui.React.createElement(
	        'form',
	        {
	          id: 'y_form',
	          ref: 'yodleeForm',
	          name: 'samlPost',
	          method: 'post',
	          target: 'y_iframe',
	          action: action
	        },
	        _pexui.React.createElement('input', {
	          ref: 'extraParams',
	          type: 'hidden',
	          name: 'extraParams',
	          id: 'extraParams',
	          value: extraParams
	        }),
	        _pexui.React.createElement('input', {
	          type: 'hidden',
	          name: 'issuerId',
	          id: 'issuerId',
	          value: 'getinfowidget'
	        }),
	        _pexui.React.createElement('input', {
	          ref: 'yodleeInput',
	          type: 'hidden',
	          name: 'samlResponse',
	          id: 'samlResponse'
	        }),
	        _pexui.React.createElement('input', {
	          type: 'hidden',
	          name: 'locale',
	          value: this.props.locale
	        })
	      );
	    }
	  }]);
	
	  return YodleeForm;
	}(_pexui.React.Component);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(69);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var postMessageHandler = function postMessageHandler(ensureOrigin) {
	  var watched = [];
	
	  var on = function on(stringOrObject, callback) {
	    if ((0, _lodash.isString)(stringOrObject)) {
	      watched = [].concat(_toConsumableArray(watched), [{ callback: callback, _string: stringOrObject }]);
	    } else {
	      watched = [].concat(_toConsumableArray(watched), [(0, _lodash.assign)(stringOrObject, { callback: callback })]);
	    }
	  };
	
	  var off = function off(stringOrObject) {
	    var watchedStringOrObject = (0, _lodash.isString)(stringOrObject) ? { _string: stringOrObject } : stringOrObject;
	
	    watched = watched.reduce(function (acc, watch) {
	      var remainingWatch = (0, _lodash.omit)(watch, ['callback']);
	
	      if (!(0, _lodash.isEqual)(remainingWatch, watchedStringOrObject)) {
	        return [].concat(_toConsumableArray(acc), [watch]);
	      }
	
	      return acc;
	    }, []);
	  };
	
	  var eventListenerHandler = function eventListenerHandler(event) {
	    var data = event.data,
	        origin = event.origin;
	
	    if (ensureOrigin && !ensureOrigin(origin)) {
	      return;
	    }
	
	    watched.forEach(function (watching) {
	      var callback = watching.callback,
	          _string = watching._string;
	
	      var remainingWatching = (0, _lodash.omit)(watching, ['callback']);
	
	      var isMatched = _string && new RegExp(_string).test(data) || (0, _lodash.isMatch)(data, remainingWatching);
	
	      if (isMatched) {
	        return callback(data);
	      }
	    });
	  };
	
	  if (!window.widgetMessageEventHandlerAlreadyRegistered) {
	    window.addEventListener('message', eventListenerHandler, false);
	    window.widgetMessageEventHandlerAlreadyRegistered = true;
	  }
	
	  return {
	    on: on,
	    off: off
	  };
	};
	
	exports.default = postMessageHandler;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pexui = __webpack_require__(2);
	
	var AccountVerificationModal = function AccountVerificationModal(_ref) {
	  var usableIdentifiers = _ref.usableIdentifiers,
	      failedIdentifiers = _ref.failedIdentifiers,
	      handleSubmit = _ref.handleSubmit,
	      handleDecline = _ref.handleDecline;
	  return _pexui.React.createElement(
	    "div",
	    { id: "account-confirmation-modal", className: "infw-modal-wrapper px-widget" },
	    _pexui.React.createElement(
	      "div",
	      {
	        id: "modal-container",
	        className: "infw-dialog-frame dls-accent-white-01-bg container-fluid text-align-center"
	      },
	      _pexui.React.createElement(
	        "div",
	        { className: "infw-font-bold title" },
	        (0, _pexui._n)('yodlee.acm.header_1')
	      ),
	      usableIdentifiers.map(function (identifier) {
	        return _pexui.React.createElement(
	          "div",
	          { className: "row success" },
	          _pexui.React.createElement("span", {
	            className: "dls-icon-success icon-sm dls-rewards-green-02 icon"
	          }),
	          "ACCOUNT NO X-" + identifier.account_number_ending_4_digits
	        );
	      }),
	      _pexui.React.createElement(
	        "div",
	        { className: "title" },
	        (0, _pexui._n)('yodlee.acm.header_2')
	      ),
	      failedIdentifiers.map(function (identifier) {
	        var errorMessageBody = identifier.bank_name ? identifier.bank_name : "ACCOUNT NO X-" + identifier.account_number_ending_4_digits;
	        return _pexui.React.createElement(
	          "div",
	          { className: "row fail" },
	          _pexui.React.createElement("span", {
	            arialabel: "warning icon",
	            role: "alert",
	            className: "dls-icon-warning-filled dls-icon-warning-filled dls-accent-red-01 icon"
	          }),
	          errorMessageBody
	        );
	      }),
	      _pexui.React.createElement(
	        "div",
	        null,
	        _pexui.React.createElement(
	          "button",
	          {
	            className: "btn btn-primary btn-fluid",
	            onClick: handleSubmit
	          },
	          (0, _pexui._n)('yodlee.acm.btn.submit')
	        )
	      ),
	      _pexui.React.createElement(
	        "div",
	        null,
	        _pexui.React.createElement(
	          "button",
	          {
	            className: "btn btn-secondary btn-fluid decline",
	            onClick: handleDecline
	          },
	          (0, _pexui._n)('yodlee.acm.btn.decline')
	        )
	      )
	    )
	  );
	};
	
	exports.default = AccountVerificationModal;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pexui = __webpack_require__(2);
	
	var MissingDetailsHeader = function MissingDetailsHeader(_ref) {
	  var fgMismatchErrors = _ref.fgMismatchErrors;
	  return _pexui.React.createElement(
	    "div",
	    { id: "missing-info-template" },
	    _pexui.React.createElement(
	      "div",
	      { className: "infw-font-bold" },
	      "Additional Information Required."
	    ),
	    fgMismatchErrors.map(function (error) {
	      return _pexui.React.createElement(
	        "div",
	        { className: "infw-faq-title infw-font-bold mismatch-error" },
	        _pexui.React.createElement("span", {
	          ariaLabel: "warning icon",
	          role: "alert",
	          className: "infw-icon-warning dls-icon-warning-filled dls-accent-red-01 mismatch-error-icon"
	        }),
	        error
	      );
	    }),
	    _pexui.React.createElement(
	      "div",
	      { className: "missing-details-footer" },
	      (0, _pexui._n)('yodlee.account_mismatch.subtitle')
	    )
	  );
	};
	
	exports.default = MissingDetailsHeader;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _yodleebase = __webpack_require__(105);
	
	var _html = __webpack_require__(89);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YodleeOptOut = function (_YodleeBasePage) {
	    _inherits(YodleeOptOut, _YodleeBasePage);
	
	    function YodleeOptOut() {
	        _classCallCheck(this, YodleeOptOut);
	
	        return _possibleConstructorReturn(this, (YodleeOptOut.__proto__ || Object.getPrototypeOf(YodleeOptOut)).apply(this, arguments));
	    }
	
	    _createClass(YodleeOptOut, [{
	        key: 'getTitle',
	        value: function getTitle() {
	            return (0, _pexui._n)('yodlee.optout.title');
	        }
	    }, {
	        key: 'hasFooter',
	        value: function hasFooter() {
	            return true;
	        }
	    }, {
	        key: 'getFooterButtons',
	        value: function getFooterButtons() {
	            var _this2 = this;
	
	            return [{
	                label: (0, _pexui._n)('yodlee.optout.cancel'),
	                isPrimary: false,
	                onClick: function onClick() {
	                    return _this2.props.widget.onClose();
	                }
	            }, {
	                label: (0, _pexui._n)('yodlee.optout.enroll'),
	                isPrimary: true,
	                onClick: function onClick() {
	                    return _this2.props.widget.nav('yodleeSubmit');
	                }
	            }];
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            return _pexui.React.createElement(_html.Html, {
	                className: 'infw-yodlee-how-container2',
	                content: (0, _pexui._n)('yodlee.optout.description') });
	        }
	    }]);
	
	    return YodleeOptOut;
	}(_yodleebase.YodleeBasePage);
	
	exports.default = YodleeOptOut;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pexui = __webpack_require__(2);
	
	var _base = __webpack_require__(84);
	
	var _html = __webpack_require__(89);
	
	var _flow = __webpack_require__(10);
	
	var _globals = __webpack_require__(9);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _consts = __webpack_require__(65);
	
	var _docuploadsvc = __webpack_require__(68);
	
	var _track = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nova = function (_BasePage) {
	  _inherits(Nova, _BasePage);
	
	  function Nova(props) {
	    _classCallCheck(this, Nova);
	
	    return _possibleConstructorReturn(this, (Nova.__proto__ || Object.getPrototypeOf(Nova)).call(this, props));
	  }
	
	  _createClass(Nova, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _flow.flow.raiseInvokerEvent('loaded', undefined);
	      _flow.flow.lastChannel = 'NOVA';
	    }
	  }, {
	    key: 'invokeNovaWidget',
	    value: function invokeNovaWidget() {
	      var _flow$req = _flow.flow.req,
	          novaUserArgs = _flow$req.nova_identifier,
	          transactionId = _flow$req.transaction_id,
	          originatorId = _flow$req.originator_id,
	          countryCode = _flow$req.market;
	      var widget = this.props.widget;
	      var config = _globals2.default.config;
	      var novaEnv = config.novaEnv,
	          novaPublicId = config.novaPublicId,
	          novaProductId = config.novaProductId;
	
	      var _flow$getCurrentNode = _flow.flow.getCurrentNode(),
	          docRequestedCode = _flow$getCurrentNode.code;
	
	      (0, _track.track)('Nova', {
	        contentName: (0, _flow.getTrackLabel)(_flow.flow.getCurrentNode()),
	        selfServiceStart: true,
	        events: !_globals2.default.event51Sent ? _consts.SUCCESSFUL_FIRST_LOAD_EVENT : undefined
	      });
	
	      // Invoke widget with novaUserArgs
	      window.Nova.register({
	        env: novaEnv,
	        publicId: novaPublicId,
	        productId: novaProductId,
	        userArgs: novaUserArgs,
	        onSuccess: function onSuccess(publicToken, status) {
	          _flow.flow.raiseInvokerEvent('novaResponse', {
	            transaction_id: transactionId,
	            submission_channel_code: 'NOVA',
	            documents_requested_code: docRequestedCode,
	            received_timestamp: Date.now(),
	            nova_response: {
	              status: status,
	              public_token: publicToken
	            }
	          });
	
	          _docuploadsvc.DocUploadService.log2Server({
	            transaction_id: transactionId,
	            log_type: 'INFO',
	            originator_id: originatorId,
	            country_code: countryCode,
	            log_message: 'Nova completed successfully status: ' + status + ', publicToken: ' + publicToken
	          });
	
	          (0, _track.track)('Nova:Success', {
	            contentName: (0, _flow.getTrackLabel)(_flow.flow.getCurrentNode()),
	            successStatus: 'nova.' + status
	          });
	
	          if (_flow.flow.isNovaOnly()) {
	            (0, _track.track)('ThankYou', {
	              events: _consts.SUCCESSFUL_COMPLETED_JOURNEY_EVENT
	            });
	          }
	        },
	        onError: function onError(publicToken, error) {
	          _flow.flow.raiseInvokerEvent('message', {
	            message: 'Nova error',
	            error_code: error
	          });
	
	          _docuploadsvc.DocUploadService.log2Server({
	            transaction_id: transactionId,
	            log_type: 'ERROR',
	            originator_id: originatorId,
	            country_code: countryCode,
	            log_message: 'Error from Nova: ' + error
	          });
	
	          (0, _track.trackError)('nova.' + error);
	        },
	        initialRoute: '/countrySelector',
	        disableUnsupportedCountry: true,
	        hideFinalIllustration: false,
	        hideExitButton: true
	      });
	    }
	  }, {
	    key: 'hasHeader',
	    value: function hasHeader() {
	      return false;
	    }
	  }, {
	    key: 'hasFooter',
	    value: function hasFooter() {
	      return true;
	    }
	  }, {
	    key: 'hasHelp',
	    value: function hasHelp() {
	      return false;
	    }
	  }, {
	    key: 'getFooterButtons',
	    value: function getFooterButtons() {
	      var _this2 = this;
	
	      return [{
	        id: 'infw_btn_exit_nova',
	        label: (0, _pexui._n)('exit.nova.label'),
	        isPrimary: false,
	        onClick: function onClick() {
	          return _this2.props.widget.onClose();
	        }
	      }];
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      return _pexui.React.createElement(
	        'div',
	        null,
	        _pexui.React.createElement('script', {
	          src: 'https://static.neednova.com/connect/v2/init.js',
	          onLoad: this.invokeNovaWidget.bind(this),
	          onError: function onError() {
	            return (0, _track.trackError)('nova.SCRIPT');
	          }
	        }),
	        _pexui.React.createElement('div', { id: 'nova-embed' })
	      );
	    }
	  }]);
	
	  return Nova;
	}(_base.BasePage);
	
	exports.default = Nova;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// pex_getinfo_widget.js